import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB'; // the locale you want
import { useLocation, useNavigate } from 'react-router-dom';
import UserService from '../../Services/user.service';
import ReportsService from '../../Services/reports.service';
import ClientService from '../../Services/client.service';
import DocumentService from '../../Services/documents.service';
import EnumsService from '../../Services/enums.service';
import editIcon from '../../assests/images/Icons/editIcon.svg';
import deleteIcon from '../../assests/images/Icons/deleteIcon.svg';
import PuffLoader from "react-spinners/PuffLoader";
import DropzoneArea from '../../Components/ClientDetails/SubComponents/DropzoneArea.jsx';
import ImportExportService from '../../Services/importExport.service';
import { useBack } from "use-back";
import assetIcon from '../../assests/images/Icons/assetIcon.svg';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import TaxAuthorityService from '../../Services/taxAuthority.service';
import profitAndLossIcon from "../../assests/images/Icons/profitAndLoss.svg";
import { useTranslation } from 'react-i18next';
import { useDirectionByLanguage } from '../../hooks/useDirectionByLanguage';
import useTaiodetImport from '../../hooks/useTaiodetImport';
import usePriorityImport from '../../hooks/usePriorityImport';
import '../../Components/ClientDetails/ClientDetails.css'; // make sure the path to your CSS file is correct
import backIcon from '../../assests/images/left-arrow.png';
import FinancialModal from '../../Components/Widgets/FinancialModal/FinancialModal.js';
import TrackingList from '../../assests/images/Hamburger/TrackingListBlue.svg';
import importIconSvg from "../../assests/images/svgs/import.svg"
import transactionDocumentsIcon from "../../assests/images/Icons/financial.svg";
import Constants from '../../assests/Constants/constants';
import { MENU_ITEMS } from '../../assests/Constants/menuRestrictionKeys';
import { ToastContainer, toast } from "react-toastify";
import reportsIcon from "../../assests/images/Icons/reports.svg";
import {
    AccountingModuleIcon,
    SalesModuleIcon,
    ArchiveModuleIcon,
    CrmModuleIcon,
    ReportsModuleIcon,
    SettingsModuleIcon,
    MatchingModuleIcon,
} from '../../assests/images/Icons/ModuleActionIcons';
import { useSignalR } from '../../Contexts/signalR';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service';
import SubAccountantService from '../../Services/subAccountant.service';
import PartnerService from '../../Services/partner.service';
import dayjs from 'dayjs';
import CustomYearDatePicker from '../../Components/Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker.js';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import holdingItemsIcon from '../../assests/images/Icons/holdingItems.svg';
import auditAiIcon from '../../assests/images/Icons/auditAi.svg';
import auditAiSparkIcon from '../../assests/images/Icons/auditAiSpark.svg';

import ListAltIcon from '@mui/icons-material/ListAlt';
import CalculateIcon from '@mui/icons-material/Calculate';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';

import VatModal from '../../Components/Widgets/ReportTrackingModals/VatModal.js';
import WithholdingTaxModal from '../../Components/Widgets/ReportTrackingModals/WithholdingTaxModal.js';
//table imports

import { beautifyNumber } from '../../Utils/FormatNumber';
import { getBiMonthlyRange } from '../../Utils/helpers';
import {
    IconButton, Box, Typography, Tooltip,
    FormControlLabel, Switch 
} from '@mui/material';
import { WarningAmber as WarningIcon, CheckCircle as CheckIcon, Close as CloseIcon, Block as BlockIcon } from '@mui/icons-material';
import uploadIcon from "../../assests/images/Icons/upload.svg";
import walletIcon from "../../assests/images/Icons/wallet.svg";

import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import ClientActionCard from '../../Components/ClientDetails/SubComponents/ClientActionCard.jsx';
import BusinessFieldActionCard from '../../Components/ClientDetails/SubComponents/BusinessFieldActionCard.jsx';
import businessFieldConfigs from '../../assests/Constants/businessFieldConfigs.js';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';

// Item Icons
import accountCardsDetailsIcon from '../../assests/images/Icons/accountCard.svg';
import incomesIcon from '../../assests/images/Icons/income.svg';
import expensesIcon from '../../assests/images/Icons/expense.svg';
import paymentAcceptanceIcon from '../../assests/images/Icons/paymentAcceptance.svg';
import journalEntryIcon from '../../assests/images/Icons/journalEntry.svg';
import otherDocumentIcon from '../../assests/images/Icons/otherDocument.svg';
import cardMatchingIcon from '../../assests/images/Icons/cardMatching.svg';
import bankIcon from '../../assests/images/Icons/bank.svg';
import bankPageIcon from '../../assests/images/Icons/collection.svg';
import sortCodeReportIcon from '../../assests/images/Icons/sortcodeReport.svg';
import accountCardsTableIcon from '../../assests/images/Icons/ledger.svg';
import referenceSequenceIcon from '../../assests/images/Icons/referenceCheck.svg';
import collectionsIcon from '../../assests/images/Icons/collection.svg';
import advancesReportIcon from '../../assests/images/Icons/reports.svg';
import pcnFileIcon from '../../assests/images/Icons/reports.svg';
import vatReportIcon from '../../assests/images/Icons/reports.svg';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ReportingFollowUpModal from '../../Components/ReportingFollowUp/ReportingFollowUpModal';
import { REPORTING_FOLLOW_UP_SAVED_EVENT } from '../../Components/ReportingFollowUp/reportingFollowUpConstants';
import NationalInsuranceModal from '../../Components/NationalInsurance/NationalInsuranceModal';
import { NATIONAL_INSURANCE_SAVED_EVENT } from '../../Services/nationalInsurance.service';
import SalaryModal from '../../Components/Salaries/SalaryModal';
import SalariesService, { SALARY_SETTINGS_SAVED_EVENT } from '../../Services/salaries.service';
import ReportingFollowUpService from '../../Services/reportingFollowUp.service';
import { PermissionsContext } from '../../Contexts/Permissions';
import AssignmentService from '../../Services/assignment.service';
import AuthService from '../../Services/auth.service';
import VatTooltip from '../../Components/ClientDetails/SubComponents/VatTooltip.js';
import { getBiMonthlyRangeByDate } from '../../Utils/helpers';
import PostponedChecks from '../../Components/Widgets/PostponedChecks/PostponedChecks.jsx';
import ActionCards from '../../Components/ClientDetails/SubComponents/PanelsCards/ActionCards.jsx';
import VatAdvancesSection from '../../Components/ClientDetails/SubComponents/PanelsCards/VatAdvancesSection.jsx';
import ClientDataTable from '../../Components/ClientDetails/SubComponents/ClientDataTable/ClientDataTable.jsx';
import ModalsSection from '../../Components/ClientDetails/SubComponents/ModalsSection/ModalsSection.jsx';
import UploadsBreakdownModal from '../../Components/Widgets/UploadsBreakdownModal/UploadsBreakdownModal.jsx';
import { ClientHeaderProvider } from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/ClientHeaderContext.js';
import ClientDetailsHeader from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/ClientDetailsHeader.jsx';
import WithholdingModal from '../../Components/ClientDetails/SubComponents/ModalsSection/WithholdingModal.jsx';
import ClientWithholdingModal from '../../Components/ClientDetails/SubComponents/ModalsSection/ClientWithholdingModal.jsx';
import DownloadModals from '../../Components/ClientDetails/SubComponents/ModalsSection/DownloadModals.jsx';
import ProblematicCardsModal from '../../Components/ClientDetails/SubComponents/ModalsSection/ProblematicCardsModal.jsx';
import MonthStatusModal from '../../Components/Widgets/MonthStatusModal/MonthStatusModal.jsx';
import JournalDocumentationModal from '../../Components/Document/SubComponents/JournalDocumentationModal.jsx';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';
import { useReportingPeriod } from '../../Contexts/ReportingPeriodContext';
import { useClientNavigation } from '../../hooks/useClientNavigation';
import { splitOtherDocumentTypes } from '../../Utils/otherDocumentSections';
import { useDispatch } from 'react-redux';
import {
    setAllClientData,
    setClientLoading,
    setClientError,
    setVatReportData,
    setIncomeTaxAdvances,
    setCalculatedValues,
    setWitholdingIncomesNoVat,
    setAdvanceReportTax,
    setReportTax,
    setIncomeNoVat
} from '../../store/reducers/clientDataSlice.js';
import {
    markWarned,
    clearExpiredWarnings,
} from '../../store/reducers/postponedChecksSlice';
import { useMenuItems } from '../../hooks/useMenuItems.js'; // update path as needed
import { setSelectedClient } from '../../store/reducers/selectedClientSlice';

import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx';
import PCNService from '../../Services/pcn.service.js';
import CaseRelationshipService from '../../Services/caseRelationship.service';
import VatAdvancesDataService from '../../Services/vatAdvancesData.service';
import { calculateIncomeTaxAdvances } from '../../Utils/advanceCalculator/calculateIncomeTaxAdvances';
import MasavPaymentDayNotice from '../../Components/Widgets/MasavPaymentDayNotice/MasavPaymentDayNotice.jsx';

const MySwal = withReactContent(Swal);
const projectIcon = <FolderSpecialIcon sx={{ color: '#304FFF' }} />;


registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it
const formatDate = (date) => {
    return dayjs(date).toDate();
};
const headerStyle = {
    backgroundColor: '#f7f7f7',
    color: 'black',
    fontWeight: 'bold'
}
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 300,
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: 24,
    padding: 4,
};

const adjustToIsraelTime = (date) => {
    const israelTimeOffset = 2 * 3600 * 1000; // 2 hours in milliseconds
    return new Date(date.getTime() + israelTimeOffset);
};
const getStartOfYear = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1); // Jan 1st of the given year
    return adjustToIsraelTime(startOfYear);
};

const InvoiceItemsIcon = ({ width = 30, height = 30 }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
        {/* Document Background */}
        <path
            d="M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6z"
            fill="#E0E7FF"
        />
        <path
            d="M14 2v6h6"
            fill="#C7D2FE"
        />
        {/* Item box icon in foreground */}
        <rect
            x="7"
            y="11"
            width="10"
            height="6"
            rx="1"
            fill="#304FFF"
        />
        {/* Line inside the box to suggest an item label */}
        <path
            d="M9 13h6"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);


const ClientDetails = () => {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const direction = useDirectionByLanguage(i18n);
    const location = useLocation();

    const [client, setClient] = useState(null);
    const { startDateBi, endDateBi } = getBiMonthlyRange();



    const [startYearDate, setStartYearDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartYearDate');
        return storedDateString ? new Date(storedDateString) : getStartOfYear(new Date());
    });
    const { setMenuProps,setOnPCNRefresh, pcnRefreshClientDetails, setPcnRefreshClientDetails, handleSendTextMessageToChat, openReferenceSequenceModal: openReferenceSequenceModalFromContext, openReferencesModal } = useHamburgerMenu();



    const { permissions, permissionsState, loading: permissionsLoading, user, token, isAccountant, userTypeContext, clientPermissionsState, subAccountantCaseRestrictions } = useContext(PermissionsContext);

    
    const isClient = useMemo(() => {
        return userTypeContext?.toString() === Constants.UserType.Client;
    }, [userTypeContext]);
    const hideStatusBadge = clientPermissionsState?.CantSeeStatusDocuments && isClient;
    // ManageOnly clients are blocked from logging in entirely; only accountants reach this page when the
    // client has the permission, and we restrict the layout to CRM + filtered Archive + 1301 reports.
    const isManageOnly = !!clientPermissionsState?.ManageOnly;

    // --- Main Date State ---
    const [date, setDate] = useState(() => {
        const storedDateString = localStorage.getItem('Date');
        return storedDateString ? new Date(storedDateString) : new Date();
    });
    const [startDate, setStartDate] = useState(() => {
        const stored = localStorage.getItem('StartDate');
        return stored ? new Date(stored) : new Date();      // stored כבר ISO
    });
    const [endDate, setEndDate] = useState(() => {
        const stored = localStorage.getItem('EndDate');
        return stored ? new Date(stored) : new Date();
    });
    const [biStartDate, setBiStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('BiStartDate');
        return storedDateString ? new Date(storedDateString) : startDateBi;
    });
    const [biEndDate, setBiEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('BiEndDate');
        return storedDateString ? new Date(storedDateString) : endDateBi;
    });
    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });
    const isRangeRef = useRef(isRange);
    isRangeRef.current = isRange;

    // --- Advanced Reporting Date State & Handlers ---
    const [advancedDate, setAdvancedDate] = useState(() => {
        const stored = localStorage.getItem('AdvancedDate');
        return stored ? new Date(stored) : new Date();
    });
    const [advancedStartDate, setAdvancedStartDate] = useState(() => {
        const stored = localStorage.getItem('AdvancedStartDate');
        return stored ? new Date(stored) : new Date();
    });
    const [advancedEndDate, setAdvancedEndDate] = useState(() => {
        const stored = localStorage.getItem('AdvancedEndDate');
        return stored ? new Date(stored) : new Date();
    });
    const [advancedBiStartDate, setAdvancedBiStartDate] = useState(() => {
        const stored = localStorage.getItem('AdvancedBiStartDate');
        return stored ? new Date(stored) : startDateBi;
    });
    const [advancedBiEndDate, setAdvancedBiEndDate] = useState(() => {
        const stored = localStorage.getItem('AdvancedBiEndDate');
        return stored ? new Date(stored) : endDateBi;
    });

    /**
     * Re-fetches consolidated data with updated advance dates while keeping VAT dates the same.
     * Used by all advance date change handlers.
     */
    const refetchWithAdvanceDates = async (newAdvStart, newAdvEnd, isRangeOverride) => {
        const rangeFlag = typeof isRangeOverride === 'boolean' ? isRangeOverride : isRangeRef.current;
        const vatStart = rangeFlag ? startDate : isBiMonthly ? biStartDate : date;
        const vatEnd = rangeFlag ? endDate : isBiMonthly ? biEndDate : date;
        try {
            dispatch(setClientLoading(true));
            const dto = {
                CaseId: client.caseId,
                StartDate: vatStart.toISOString(),
                EndDate: vatEnd.toISOString(),
                IsRange: rangeFlag,
                AdvanceStartDate: newAdvStart.toISOString(),
                AdvanceEndDate: newAdvEnd.toISOString(),
                AccountantId: user.accountantId,
                CheckType: 'תקבול',
                OnlyProcessed: !!onlyProcessedDocumentsRef.current,
            };
            const data = await VatAdvancesDataService.fetchVatAdvancesPageData(dto, token);
            const payload = VatAdvancesDataService.buildReduxPayload(data, client, user);
            dispatch(setAllClientData(payload));
            setAcceptedWithholdingTax(data.advanceReceiptWithholding || 0);
            setCollectionBalance(data.balance || 0);
            if (data.isSubordinate !== undefined) setIsSubordinateClient(data.isSubordinate);
            if (data.mainClientData) setMainClientData(data.mainClientData);
            if (data.isMainWithSubordinates !== undefined) setIsMainWithSubordinates(data.isMainWithSubordinates);
            if (data.subordinateClients) setSubordinateClients(data.subordinateClients);
            setVatGroup(data.vatGroup ?? null);
        } catch (error) {
            console.error('Error fetching data with advance dates:', error);
            dispatch(setClientError(error.message));
        } finally {
            dispatch(setClientLoading(false));
        }
    };

    const handleAdvancedDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), advancedDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(advancedDate.getFullYear(), newDate.getMonth(), 10));
        }
        setAdvancedDate(updatedDate);
        localStorage.setItem('AdvancedDate', updatedDate);
        await refetchWithAdvanceDates(updatedDate, updatedDate);
    };
    const handleAdvancedStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), advancedStartDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(advancedStartDate.getFullYear(), newDate.getMonth(), 10));
        }
        setAdvancedStartDate(updatedDate);
        localStorage.setItem('AdvancedStartDate', updatedDate);
        await refetchWithAdvanceDates(updatedDate, advancedEndDate);
    };
    const handleAdvancedEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), advancedEndDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(advancedEndDate.getFullYear(), newDate.getMonth(), 10));
        }
        setAdvancedEndDate(updatedDate);
        localStorage.setItem('AdvancedEndDate', updatedDate);
        await refetchWithAdvanceDates(advancedStartDate, updatedDate);
    };
    const handleAdvancedBiMonthDate = async (newStart, newEnd) => {
        setAdvancedBiStartDate(newStart);
        setAdvancedBiEndDate(newEnd);
        localStorage.setItem('AdvancedBiStartDate', newStart.toISOString());
        localStorage.setItem('AdvancedBiEndDate', newEnd.toISOString());
        await refetchWithAdvanceDates(newStart, newEnd);
    };
    const handleAdvancedRangeChange = () => {
        const next = !isRange;
        isRangeRef.current = next;
        localStorage.setItem('IsRange', JSON.stringify(next));
        setIsRange(next);

        let advStart, advEnd;
        if (next) {
            advStart = isAdvancedBiMonthly !== isBiMonthly ? advancedStartDate : startDate;
            advEnd = isAdvancedBiMonthly !== isBiMonthly ? advancedEndDate : endDate;
        } else if (isAdvancedBiMonthly) {
            advStart = advancedBiStartDate;
            advEnd = advancedBiEndDate;
        } else {
            advStart = advancedDate;
            advEnd = advancedDate;
        }

        if (isAdvancedBiMonthly === isBiMonthly) {
            setAdvancedStartDate(startDate);
            setAdvancedEndDate(endDate);
        }

        refetchWithAdvanceDates(advStart, advEnd, next);
    };

    const { goBack } = useContext(NavHistoryContext);


    const [incomeOfSellEquipmentNoVat, setIncomeOfSellEquipmentNoVat] = useState(0);

    // const [direction, setDirection] = useState('rtl'); // Default to 'rtl'
    const [selectedWithholdingCard, setSelectedWithholdingCard] = useState('');
    const [openVatModal, setOpenVatModal] = useState(false);
    const [openWithholdingTaxModal, setOpenWithholdingTaxModal] = useState(false);
    const [withholdingTax, setWithholdingTax] = useState({});
    const [openReportingFollowUp, setOpenReportingFollowUp] = useState(false);
    const [openNationalInsurance, setOpenNationalInsurance] = useState(false);
    const [nationalInsuranceSummary, setNationalInsuranceSummary] = useState(null);
    const [openSalary, setOpenSalary] = useState(false);
    const [salaryOverview, setSalaryOverview] = useState(null);
    const [salaryLoading, setSalaryLoading] = useState(false);

    //File Download Variables
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [showJEImportModal, setShowJEImportModal] = useState(false);
    const [showRivhitImportModal, setShowRivhitImportModal] = useState(false);
    const [showHeshinDatModal, setShowHeshinDatModal] = useState(false);
    const [showPostponedChecks, setShowPostponedChecks] = useState(false);
    const [showDownloadFilesModal, setShowDownloadFilesModal] = useState(false);
    const [showExportJournalModal, setShowExportJournalModal] = useState(false);
    const [showImportJournalModal, setShowImportJournalModal] = useState(false);
    const [showJournalDocModal, setShowJournalDocModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [showAccountCardModal, setShowAccountCardModal] = useState(false);
    const [showAccountCardImportModal, setShowAccountCardImportModal] = useState(false);
    const [showBiMonth, setShowBiMonth] = useState(false);
    const [showPCNModal, setShowPCNModal] = useState(false);
    const [pcnIncludeStornoChecks, setPcnIncludeStornoChecks] = useState(null);
    const [showPCNChecksModal, setShowPCNChecksModal] = useState(false);
    const [pcnHighConfirmationDocs, setPcnHighConfirmationDocs] = useState([]);
    const [pcnDocumentsNeedingAllocation, setPcnDocumentsNeedingAllocation] = useState([]);
    const [pcnDocumentsWithoutReference, setPcnDocumentsWithoutReference] = useState([]);
    const [pcnDocumentsOutOfRange, setPcnDocumentsOutOfRange] = useState([]);
    const [pcnChecksLoading, setPcnChecksLoading] = useState(false);
    const [pcnCheckDates, setPcnCheckDates] = useState(null); // Store dates used for PCN check
    const [isPropAccountCardEditing, setIsPropAccountCardEditing] = useState(false);
    const [isPropAccountCardAdding, setIsPropAccountCardAdding] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [AccountCardOptions, setAccountCardOptions] = useState([]);
    const [sortCodesGroupOptions, setSortCodesGroupOptions] = useState([]);
    const [sortCodeOptions, setSortCodeOptions] = useState([]);

    const [selectedPalCode, setSelectedPalCode] = useState('');
    const [cardId, setCardId] = useState('');
    const [cardName, setCardName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [editedItem, setEditedItem] = useState(null);
    // const [caseTypeOptions, setCaseTypeOptions] = useState([]);
    const [acceptedWithholdingTax, setAcceptedWithholdingTax] = useState(0);
    const fileInputRef1 = useRef(null);
    const initInProgressRef = useRef(false);
    const lastInitCaseIdRef = useRef(null);
    const fetchVatInProgressRef = useRef(false);
    const fetchAdvancedInProgressRef = useRef(false);
    const fetchSubAccountantsCalledRef = useRef(null);
    const { documentUpdate } = useSignalR();
    const [subAccountants, setSubAccountants] = useState([]);
    
    // State for partners and partner-specific calculated values
    const [partners, setPartners] = useState([]);
    const [partnerCalculatedValues, setPartnerCalculatedValues] = useState({});
    const [totalUploads, setTotalUploads] = useState(0);
    const [showUploadsBreakdown, setShowUploadsBreakdown] = useState(false);
    const [actionType, setActionType] = useState('delete');
    const [filetype, setFileType] = useState('TXT');
    const [filesRange, setFilesRange] = useState('monthly');
    const [isBiMonthly, setIsBiMonthly] = useState(false);
    const [isAdvancedBiMonthly, setIsAdvancedBiMonthly] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState("");
    const [open, setOpen] = useState({});
    const [formData, setFormData] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
    const [palCodes, setPalCodes] = useState([]);
    const [withHoldingTaxType, setWithHoldingTaxType] = useState('');
    const [selectedReportType, setSelectedReportType] = useState('');
    const [withHoldingTaxModalOpen, setWithHoldingTaxModalOpen] = useState(false);
    const [clientWithHoldingTaxModalOpen, setClientWithHoldingTaxModalOpen] = useState(false);
    const [isDateRange, setIsDateRange] = useState(false); // New state variable
    const [selectedAccountCard, setSelectedAccountCard] = useState(null);
    // const [calculatedValues, setCalculatedValues] = useState({
    //     computed: { IncomeTaxAdvances: 0, AcceptedWithholdingTaxMaximum: 0, total: 0 },
    //     reported: { IncomeTaxAdvances: 0, AcceptedWithholdingTaxMaximum: 0, total: 0 },
    // });
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    // fetch from redux
    // const [incomesVatDetailed, setIncomesVatDetailed] = useState({ vat: 0, vat17: 0, vat18: 0 });
    // const [incomesAmountDetailed, setIncomesAmountDetailed] = useState({ amount: 0, amount17: 0, amount18: 0 });
    // const [expensesVatDetailed, setExpensesVatDetailed] = useState({ vat: 0, vat17: 0, vat18: 0 });
    // const [equipmentVatDetailed, setEquipmentVatDetailed] = useState({ vat: 0, vat17: 0, vat18: 0 });
    const [tokenDaysRemaining, setTokenDaysRemaining] = useState(0);
    const [tokenSecondsRemaining, setTokenSecondsRemaining] = useState(0);
    const [parsedOtherDocuments, setParsedOtherDocuments] = useState({});
    const [parsedPermanentFiles, setParsedPermanentFiles] = useState([]);
    const [parsedCustomTitles, setParsedCustomTitles] = useState([]);
    const [otherDocumentsTitles, setOtherDocumentsTitles] = useState([]);
    const [documentTypesCount, setDocumentTypesCount] = useState({});
    const [selectOtherDocumentsOptions, setSelectOtherDocumentsOptions] = useState([]);
    const [palCodeCategoryOptions, setPalCodeCategoryOptions] = useState([]);
    const [unfinishedAssignments, setUnfinishedAssignments] = useState(0);
    // const [reportTax, setReportTax] = useState({});
    // const [advanceReportTax, setAdvanceReportTax] = useState({});
    const [editReportTax, setEditReportTax] = useState(false);
    const [collectionBalance, setCollectionBalance] = useState(0);
    
    // Shared case state
    const [isSubordinateClient, setIsSubordinateClient] = useState(false);
    const [mainClientData, setMainClientData] = useState(null);
    const [isMainWithSubordinates, setIsMainWithSubordinates] = useState(false);
    const [subordinateClients, setSubordinateClients] = useState([]);
    // VAT-group consolidation indicator (display-only; aggregation already applied server-side)
    const [vatGroup, setVatGroup] = useState(null);

    // "Only processed documents" toggle: mirrors PCN874 behavior — when on, all VAT / withholding /
    // advance aggregations on this page (and the two report downloads driven from it) exclude
    // documents that are still in the per-client unprocessed-documents store. Persisted to
    // localStorage so the user's preference survives page reloads.
    const [onlyProcessedDocuments, setOnlyProcessedDocuments] = useState(() => {
        // Default-on: when nothing has been persisted yet (first visit / cleared storage)
        // we want the toggle to start as TRUE so the user sees only processed documents
        // by default. Only an explicit "false" persisted by a previous user action turns
        // it off.
        try {
            const stored = localStorage.getItem('ClientDetails.OnlyProcessed');
            return stored === null ? true : stored === 'true';
        } catch {
            return true;
        }
    });
    useEffect(() => {
        try {
            localStorage.setItem('ClientDetails.OnlyProcessed', onlyProcessedDocuments ? 'true' : 'false');
        } catch {
            // ignore – non-fatal
        }
    }, [onlyProcessedDocuments]);
    // Keep a ref so async downloads triggered from menus see the latest value.
    const onlyProcessedDocumentsRef = useRef(onlyProcessedDocuments);
    // Suppress the first auto-refetch so we don't double-fetch on initial mount.
    const onlyProcessedInitRef = useRef(true);
    useEffect(() => {
        onlyProcessedDocumentsRef.current = onlyProcessedDocuments;
        if (onlyProcessedInitRef.current) {
            onlyProcessedInitRef.current = false;
            return;
        }
        // Toggle changed → refetch with current dates so the displayed numbers update.
        try {
            const vatStart = isRange ? startDate : isBiMonthly ? biStartDate : date;
            const vatEnd = isRange ? endDate : isBiMonthly ? biEndDate : date;
            if (typeof fetchDataOnDateRangeChange === 'function' && vatStart && vatEnd && client?.caseId) {
                fetchDataOnDateRangeChange(vatStart, vatEnd);
            }
        } catch (e) {
            // best-effort: any error will be surfaced by the next user-driven fetch
            console.warn('OnlyProcessed toggle refetch failed', e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onlyProcessedDocuments]);

    const [jeStartDate, setJeStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });
    const [jeEndDate, setJeEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('EndDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });

    const [show856Modal, setShow856Modal] = useState(false);
    const [showUniformFileModal, setShowUniformFileModal] = useState(false);
    const [showMonthStatusModal, setShowMonthStatusModal] = useState(false);
    const [heshinPrmFile, setHeshinPrmFile] = useState(null);
    const [heshinDatFile, setHeshinDatFile] = useState(null);
    const [showProblematicCardsModal, setShowProblematicCardsModal] = useState(false);
    const [moveInDatFile, setMoveInDatFile] = useState(null);
    const [moveInDatAmountDivisor, setMoveInDatAmountDivisor] = useState(1); // 1 = no division (default), 10 = one decimal, 100 = two decimals
    const [problematicCards, setProblematicCards] = useState([]);
    const [problematicActions, setProblematicActions] = useState([]); // what actions to do with problomatic cards
    const dispatch = useDispatch();
    const [pcnReportDetails, setPcnReportDetails] = useState(null);
    const [showImportManifestModal, setShowImportManifestModal] = useState(false);
    // const { setOnPCNRefresh, pcnRefreshClientDetails } = useHamburgerMenu();
    /* ────────────────────────  ATZMAIT CSV FLOW  ──────────────────────── */

    useEffect(() => {
        if (client) {
            setMenuProps({
                client,
                token,
                isRange,
                date,
                startDate,
                endDate,
                onReferencesSave: async () => {
                    if (!client?.caseId) return;
                    try {
                        const updatedClient = await ClientService.GetClient(token, client.caseId);
                        await fetchDocumentsNotification(updatedClient, token);
                    } catch (error) {
                        console.error('Error refreshing client data after saving references:', error);
                    }
                },
            });
        }
    }, [client, token, isRange, date, startDate, endDate, setMenuProps]);

    const { setReportingPeriod } = useReportingPeriod();
    useEffect(() => {
        setReportingPeriod({
            date,
            startDate,
            endDate,
            biStartDate,
            biEndDate,
            isRange,
            isBiMonthly,
        });
    }, [date, startDate, endDate, biStartDate, biEndDate, isRange, isBiMonthly, setReportingPeriod]);


    // 1) modal visibility
    const [showAtzmaitImportModal, setShowAtzmaitImportModal] = useState(false);

    // 2) selected CSV file
    const [atzmaitCsvFile, setAtzmaitCsvFile] = useState(null);
    const handleAtzmaitCsvDrop = useCallback((files) => {
        if (files?.length) setAtzmaitCsvFile(files[0]);
    }, []);

    // 3) missing sort-codes returned from preview
    const [missingSortCodes, setMissingSortCodes] = useState([]);
    const [pkudaMissingSortCodes, setPkudaMissingSortCodes] = useState([]);

    /** Phase-1: preview (detect codes, no DB writes) */
    const previewAtzmaitCsv = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewTransactionReportAtzmaitCsv(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            setMissingSortCodes(res?.missingSortCodes ?? []);
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Preview CSV failed:', err);
            toast.error(t('PreviewFailed'));
        }
    }, [client, token, t]);

    const previewPkuda = useCallback(async (files, sortCodeWorkbook) => {
        if (!files?.length || !client) return;

        try {
            const res = await ImportExportService.PreviewTransactionReportPkuda(
                client.caseId,
                client.accountantId,
                files,
                sortCodeWorkbook,
                token
            );

            setPkudaMissingSortCodes(res?.missingSortCodes ?? []);
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Preview PKUDA failed:', err);
            toast.error(t('PreviewFailed'));
        }
    }, [client, token, t]);

    const commitPkuda = useCallback(async (files, sortCodeWorkbook, skipDuplicates = true) => {
        if (!files?.length || !client) return;

        try {
            const res = await ImportExportService.CommitTransactionReportPkuda(
                client.caseId,
                client.accountantId,
                files,
                sortCodeWorkbook,
                skipDuplicates,
                token
            );

            toast.success(t('ImportCompleted'));
            return res;
        } catch (err) {
            console.error('Commit PKUDA failed:', err);
            toast.error(t('ImportFailed'));
        }
    }, [client, token, t]);

    /** Phase-2a: create every missing SortCode via Enums.AddSortCode */
    const createMissingSortCodes = useCallback(async (codes) => {
        if (!codes?.length || !client) return;

        try {

            const results = await Promise.all(
                codes.map(sc => {
                    let parsedVatType = null;
                    if (sc.sortCodeVatType) {
                        try {
                            parsedVatType = parseInt(sc.sortCodeVatType) ?? null;
                        } catch {
                            parsedVatType = null;
                        }
                    }

                    return EnumsService.AddSortCode(
                        client.accountantId,
                        sc.sortCodeName,
                        sc.sortCodeId,
                        sc.sortCodeCategory ?? sc.sortCodeGroup ?? null,
                        null,
                        null,
                        parsedVatType,
                        sc.vat,
                        sc.participatesInProfitAndLoss,
                        null, // pcnTransactionType
                        null, // code6111Id
                        sc.inventoryType ?? 0,
                        token
                    );
                })
            );

            // Check if any failed
            const failedResults = results.filter(r => !r || !r.ok);
            if (failedResults.length > 0) {
                throw new Error(`${failedResults.length} sortcodes failed to create`);
            }

            toast.success(t('MissingSortCodesCreated'));
        } catch (err) {
            console.error('Create sort codes failed:', err);
            toast.error(t('CreateSortCodesFailed'));
            throw err; // Re-throw so caller knows it failed
        }
    }, [client, token, t]);

    
    /** Phase-2b: commit the CSV once all codes exist */
    const commitAtzmaitCsv = useCallback(async (file, importDuplicates = false) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.CommitTransactionReportAtzmaitCsv(
                client.caseId,
                client.accountantId,
                file,
                token,
                importDuplicates
            );

            toast.success(t('ImportCompleted'));
            return res;
        } catch (err) {
            console.error('Commit CSV failed:', err);
            toast.error(t('ImportFailed'));
        }
    }, [client, token, t]);



    const {
        income,
        expense,
        equipment,
        zeroVatAmount,
        sellEquipNoVat,
        incomeNoVat,
        netVatAmount,
        incomeTaxAdvances,
        withholding,
        loading: clientDataLoading,
        vatReport,
        closedMonths,
        incomesAmount,
        expensesAmount,
        purchaseOfEquipmentExpensesAmount,
        incomesVatAmount,
        balances,
        profitAmount,
        expensesVatAmount,
        witholdingIncomesNoVat,
        purchaseOfEquipmentExpensesVatAmount,
        lastFetchedStartDate,
        lastFetchedEndDate,
        calculatedValues,
        incomesVatDetailed,
        incomesAmountDetailed,
        expensesVatDetailed,
        equipmentVatDetailed,
        paymentWithholdingTax,
        advanceReportTax,
        reportTax,
        pageIncomeTaxAdvancePercentage,
        pageUseIncomeTaxAdvancePercentage,
        pageIncomeTaxAdvanceAmount,
        partnerAdvanceSettings,

    } = useSelector(state => state.clientDataSlice);
    const warnedCaseIds = useSelector(state => state.postponedChecksSlice.warnedCaseIds);
    
    // Get isMonthly and endYearDate from Redux since they're not defined locally
    const { isMonthly, endYearDate } = useSelector((state) => state.reportPeriodSlice);



    const handleDeleteClick = (itemId) => {
        setItemIdToDelete(itemId);
        setOpenDeleteDialog(true)
    };

    const formattedAccountSourceDeductionCardOptions = AccountCardOptions
        ?.filter((option) => option.sourceDeductionAssociation === 1) // Filter options
        .map((option) => ({
            value: option.cardId,
            label: `${option.cardId} - ${option.name}`,
            cardId: option.cardId,
            name: option.name,
            companyId: option.accountCaseId,
            palCode: option.palCode,
        }));

    const handleSelectedAccountCardChangeForWithholding = (event, value) => {
        setSelectedWithholdingCard(value?.value || '');
        setSelectedAccountCard(value);
    };




    const fetchEnumsInProgressRef = useRef(false);
    const fetchEnums = async (token, client, isSetLoading) => {
        try {
            if (isSetLoading) {
                setLoading(true);
            }
            if (!client) {
                return;
            }
            if (!isSetLoading && fetchEnumsInProgressRef.current) return;
            fetchEnumsInProgressRef.current = true;
            // Fetch Enums and assignments in parallel
            const [
                accountsResponse,
                palCodesResponse,
                otherDocumentsResponse,
                documentTypesCountResponse,
                unfinishedAssignmentsResponse,
                sortCodeGroupRes,
                palCodeCategoryResponse,
                sortCodesResponse,
                otherDocumentsTitlesResponse
            ] = await Promise.all([
                EnumsService.GetAccountCardsByCaseId(client.caseId, token),
                EnumsService.GetPalCodesByAccountantId(client.accountantId, token),
                EnumsService.GetOtherDocumentsTypesByAccountantId(client.accountantId, token),
                EnumsService.GetOtherDocumentsCountsByCaseId(client.caseId, token),
                AssignmentService.GetUnfinishedAssignmentsByCaseId(client.caseId, token),
                EnumsService.GetSortCodesGroupByAccountantId(client.accountantId, token),
                EnumsService.GetPalCodeCategoriesByAccountantId(client.accountantId, token),
                EnumsService.GetSortCodesByAccountantId(client.accountantId, token),
                EnumsService.GetOtherDocumentsTitlesByAccountantId(client.accountantId, token).catch(() => null),

            ]);

            // Parse responses in parallel
            const [
                accountsData,
                palCodesData,
                otherDocumentsData,
                documentTypesCountData,
                unfinishedAssignmentsData,
                sortCodeGroups,
                palCodeCategoryData,
                sortCodesData,
                otherDocumentsTitlesData
            ] = await Promise.all([
                accountsResponse.json(),
                palCodesResponse.json(),
                otherDocumentsResponse.json(),
                documentTypesCountResponse.json(),
                Promise.resolve(unfinishedAssignmentsResponse), // Assume this is already parsed
                sortCodeGroupRes.json(),
                palCodeCategoryResponse.json(),
                sortCodesResponse.ok ? sortCodesResponse.json() : Promise.resolve([]),
                otherDocumentsTitlesResponse?.ok ? otherDocumentsTitlesResponse.json().catch(() => []) : Promise.resolve([]),
            ]);

            // Update states for select options and other data
            const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];
            const formattedPalCodes = palCodesData?.map(palCode => ({
                label: palCode.palCodeId,
                value: palCode.palCodeId,
            }));

            setAccountCardOptions(accountCardOptions);
            setFormattedPalCodeOptions(formattedPalCodes);
            setPalCodes(palCodesData || []); // Store full PalCodes array
            setSelectOtherDocumentsOptions(otherDocumentsData);
            setOtherDocumentsTitles(Array.isArray(otherDocumentsTitlesData) ? otherDocumentsTitlesData : []);
            setDocumentTypesCount(documentTypesCountData);
            setUnfinishedAssignments(unfinishedAssignmentsData);
            setSortCodesGroupOptions(sortCodeGroups);
            setPalCodeCategoryOptions(palCodeCategoryData);
            setSortCodeOptions(sortCodesData || []);
            // Show success notification
            // toast.success(t('fetchEnumsSuccess'));
        } catch (error) {
            console.error("Error fetching enums or assignments:", error);
            toast.error(t('fetchEnumsFailure', { errorText: error.message }));
        } finally {
            fetchEnumsInProgressRef.current = false;
            if (isSetLoading) {
                setLoading(false);
            }
        }
    };

    const formattedSortCodesGroupNamesOptions = sortCodesGroupOptions?.map(option => ({
        name: option.sortCodeGroup,
        value: option.sortCodeGroup,
        label: `${option.sortCodeGroup}`,

    }));
    const formattedSortCodeVatType = Object.entries(Constants.SortCodeVatType).map(([key, value]) => ({
        name: t(value),   // Using the string value (e.g., 'NotParticipating') as the name
        value: key,    // Using the number (e.g., '0') as the value
        label: t(value)   // Using the string value (e.g., 'NotParticipating') as the label
    }));
    const fetchTotalUploads = async (token, caseId) => {
        try {
            const totalUploadsResponse = await ClientService.GetClientUploads(token, caseId);

            setTotalUploads(totalUploadsResponse);
        } catch (error) {
            // toast.error(t('fetchEnumsFailure', { errorText: error.message }));
        }
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLoading(true)
        try {
            // Call the DeleteDocument function from DocumentService with the item's id
            const response = await ClientService.DeleteClient(token, itemIdToDelete);
            // const response1 = await ChatService.DeleteChatUser(itemIdToDelete);
            if (response.ok) {
                // Handle successful deletion, e.g., by updating your UI
                toast.success(t('deleteClientSuccess'));
            } else {
                // Handle any errors or display a message
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);
                toast.error(t('deleteClientFailure', { errorText: errorResponse.message }));
            }
        } catch (error) {
            console.error('Error deleting document:', error);
            toast.error(t('errorDeletingClient', { errorText: error.message }));
        }
        setIsModalVisible(false);
        setLoading(false)
        navigate("/Main", { state: { refresh: true, accountantId: client.accountantId, token: token } });
    };



    // Helper function to get all related case IDs for shared reporting
    const getAllRelatedCaseIds = async (caseId, token) => {
        try {
            // Check if this case has relationships
            const relationships = await CaseRelationshipService.GetCaseRelationshipsByCaseId(token, caseId);
            
            if (!relationships || relationships.length === 0) {
                // No relationships, return just the current case
                return { caseIds: [caseId], mainCaseId: caseId, isSubordinate: false };
            }

            // Find the main case ID
            let mainCaseId = caseId;
            const relationship = relationships.find(rel => rel.subordinateCaseId === caseId);
            const isSubordinate = !!relationship;
            if (relationship) {
                mainCaseId = relationship.mainCaseId;
            }

            // Get all subordinate case IDs
            const subordinateCaseIds = await CaseRelationshipService.GetSubordinateCaseIds(token, mainCaseId);
            
            // Return main case + all subordinate cases
            return { 
                caseIds: [mainCaseId, ...subordinateCaseIds], 
                mainCaseId: mainCaseId, 
                isSubordinate: isSubordinate 
            };
        } catch (error) {
            console.error('Error getting related case IDs:', error);
            return { caseIds: [caseId], mainCaseId: caseId, isSubordinate: false }; // Fallback to current case only
        }
    };


    async function fetchDataForAdvancedAcceptedWithholdingTax(startDate, endDate) {
        if (fetchAdvancedInProgressRef.current) return;
        fetchAdvancedInProgressRef.current = true;
        try {
            // setLoading(true);

            let startAdvanced;
            let endAdvanced;
            let isAdvancedRange = false;


            if (isRange) {
                // If user explicitly selected a date range, advanced is also a range
                startAdvanced = startDate;
                endAdvanced = endDate;
                isAdvancedRange = true;
            } else {
                // 1) If both 'advanced' and 'normal' are (or aren't) bi-monthly => same date logic
                if (isAdvancedBiMonthly === isBiMonthly) {
                    startAdvanced = startDate;
                    endAdvanced = endDate;
                }
                // 2) VAT חודשי, Advance דו חודשי: caller passes 2-month range; snap to bi-monthly block
                else if (isAdvancedBiMonthly && !isBiMonthly) {
                    [startAdvanced, endAdvanced] = getBiMonthlyRangeByDate(startDate);
                }
                // 3) VAT דו חודשי, Advance חודשי: caller passes 1-month range (startDate === endDate)
                else if (!isAdvancedBiMonthly && isBiMonthly) {
                    startAdvanced = startDate;
                    endAdvanced = endDate;
                    isAdvancedRange = false;
                }
            }

            // Get all related case IDs for shared reporting
            const { caseIds: relatedCaseIds, mainCaseId, isSubordinate } = await getAllRelatedCaseIds(client.caseId, token);

            // Get main client data for settings (if this is a shared case)
            let mainClient = client;
            if (isSubordinate && mainCaseId !== client.caseId) {
                try {
                    mainClient = await ClientService.GetClient(token, mainCaseId);
                    setMainClientData(mainClient);
                } catch (error) {
                    console.error('Error fetching main client data:', error);
                }
            }
            
            // Set subordinate status
            setIsSubordinateClient(isSubordinate);

            const formattedStartDate = startDate.toISOString();
            const formattedEndDate = endDate.toISOString();

            // 2) Retrieve userType, if relevant
            const userType = (await UserService.getCurrentUserType()).toString();

            
            // 3) Build promises for each related case
            const allPromises = relatedCaseIds.map(caseId => {
                // Build DTO for each case
                const dto = {
                    CaseId: caseId,
                    StartDate: startDate,
                    EndDate: endDate,
                    IsRange: isRange,
                };

                const dtoAdvanced = {
                    CaseId: caseId,
                    StartDate: startAdvanced,
                    EndDate: endAdvanced,
                    IsRange: isAdvancedRange,
                };

                return [
                    // 3.1) A special advanced calculation
                    ReportsService.getAdvanceByDateRange(dtoAdvanced, token),

                    // 3.2) The advanced type of Withholding call
                    DocumentService.GetWithholdingRangeType(
                        'PaymentAcceptances',
                        caseId,
                        'תקבול',
                        formattedStartDate,
                        formattedEndDate,
                        token
                    ),

                    // 3.3) For calculating "witholdingIncomesNoVat", we need total incomes (without VAT)
                    DocumentService.GetAmountWithNoVATDocumentsbyDateRange(
                        'Incomes',
                        caseId,
                        formattedStartDate,
                        formattedEndDate,
                        token
                    ),

                    // 3.4) Sell Equipment Without VAT
                    DocumentService.GetSellEquipmentAmountDocumentsbyDate(
                        caseId,
                        client.accountantId,
                        formattedStartDate,
                        formattedEndDate,
                        token,
                        false // `false` means "without VAT"
                    ),

                    // 3.5) Income Tax Advances (advanced section: use advanced reporting type)
                    ClientService.GetIncomeTaxAdvancesByDateRange(
                        caseId,
                        formattedStartDate,
                        formattedEndDate,
                        'תקבול', // or whatever code your system uses
                        token,
                        true // UseAdvancedReportingType for advance section
                    ),
                ];
            });

            // 4) Execute all promises in parallel
            const allResponses = await Promise.all(
                allPromises.map(casePromises => Promise.all(casePromises))
            );

            // 5) Parse responses and group by type
            const advanceDataArray = [];
            const advancedWithholdingDataArray = [];
            const incomesNoVatDataArray = [];
            const sellEquipmentDataArray = [];
            const incomeTaxAdvancesDataArray = [];

            allResponses.forEach(caseResponses => {
                const [
                    advanceDataResponse,
                    advancedWithholdingResponse,
                    incomesNoVatResponse,
                    sellEquipmentResponse,
                    incomeTaxAdvancesResponse,
                ] = caseResponses;

                advanceDataArray.push(advanceDataResponse.json());
                advancedWithholdingDataArray.push(advancedWithholdingResponse.json());
                incomesNoVatDataArray.push(incomesNoVatResponse.json());
                sellEquipmentDataArray.push(sellEquipmentResponse.json());
                incomeTaxAdvancesDataArray.push(incomeTaxAdvancesResponse.json());
            });

            // 6) Wait for all JSON parsing to complete
            const [
                advanceDataResults,
                advancedWithholdingDataResults,
                incomesNoVatDataResults,
                sellEquipmentDataResults,
                incomeTaxAdvancesDataResults,
            ] = await Promise.all([
                Promise.all(advanceDataArray),
                Promise.all(advancedWithholdingDataArray),
                Promise.all(incomesNoVatDataArray),
                Promise.all(sellEquipmentDataArray),
                Promise.all(incomeTaxAdvancesDataArray),
            ]);


            

            // 7) Sum data from all related cases manually
            const advanceData = advanceDataResults[0] || {}; // Use first case data as base
            const advancedWithholdingData = advancedWithholdingDataResults.reduce((sum, data) => sum + (data || 0), 0);
            const incomesNoVatData = {
                amount: incomesNoVatDataResults.reduce((sum, data) => sum + (data?.amount || 0), 0),
                amount17: incomesNoVatDataResults.reduce((sum, data) => sum + (data?.amount17 || 0), 0),
                amount18: incomesNoVatDataResults.reduce((sum, data) => sum + (data?.amount18 || 0), 0)
            };
            const sellEquipmentData = {
                totalAmount: sellEquipmentDataResults.reduce((sum, data) => sum + (data?.totalAmount || 0), 0)
            };
            const incomeTaxAdvancesData = {
                incomeTaxAdvances: incomeTaxAdvancesDataResults.reduce((sum, data) => sum + (data?.incomeTaxAdvances || 0), 0)
            };


            
            // 8) Update the "report tax" data from the "advance" call
            dispatch(setAdvanceReportTax(advanceData));

            // 9) Set "Accepted Withholding Tax" from the advanced call
            setAcceptedWithholdingTax(advancedWithholdingData);

            // 10) Compute your "witholdingIncomesNoVat" from: incomesNoVat - sellEquipmentNoVat
            const sellEquipAmount = sellEquipmentData?.totalAmount || 0;
            const witholdingVal = incomesNoVatData?.amount - sellEquipAmount;
            dispatch(setWitholdingIncomesNoVat(witholdingVal));

            // 11) Set the "raw" incomeTaxAdvances array
            dispatch(setIncomeTaxAdvances(incomeTaxAdvancesData.incomeTaxAdvances));

            // 12) (Optional) If you have logic for checking closed months, do that here, too:


        } catch (error) {
            console.error('Error fetching advanced data:', error);
            toast.error(t('errorFetchingData', { errorText: error.message }));
        } finally {
            fetchAdvancedInProgressRef.current = false;
            setLoading(false);
        }
    }


    function fetchWithTimeout(fetchFunc, timeout = 15000) {
        return Promise.race([
            fetchFunc(),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error("Request timed out")), timeout)
            ),
        ]);
    }
    async function safeFetchJson(fetchFunc, ...args) {
        try {
            const res = await fetchWithTimeout(() => fetchFunc(...args));
            // If your service returns a fetch response
            if (!res.ok) throw new Error(await res.text());
            return await res.json();
        } catch (error) {
            return { _error: error };
        }
    }

    // -----------------------------------------------
    // The full, detailed fetch function with NO missing lines
    //   - We fetch data in parallel
    //   - We handle userType offset logic
    //   - We parse all responses
    //   - We store both summary and detailed VAT in state
    // -----------------------------------------------
    async function fetchDataOnDateRangeChange(startDate, endDate, overrideAdvanceDates = null, isRangeOverride = null) {
        try {
            dispatch(setClientLoading(true));
            const samePeriod = isAdvancedBiMonthly === isBiMonthly;
            const effectiveIsRange = typeof isRangeOverride === 'boolean' ? isRangeOverride : isRangeRef.current;

            let advStartDate = null, advEndDate = null;
            if (overrideAdvanceDates) {
                advStartDate = overrideAdvanceDates.start;
                advEndDate = overrideAdvanceDates.end;
            } else if (!samePeriod) {
                if (effectiveIsRange) {
                    advStartDate = advancedStartDate;
                    advEndDate = advancedEndDate;
                } else if (isAdvancedBiMonthly) {
                    advStartDate = advancedBiStartDate;
                    advEndDate = advancedBiEndDate;
                } else {
                    advStartDate = advancedDate;
                    advEndDate = advancedDate;
                }
            }

            const dto = {
                CaseId: client.caseId,
                StartDate: startDate.toISOString(),
                EndDate: endDate.toISOString(),
                IsRange: effectiveIsRange,
                AdvanceStartDate: advStartDate ? advStartDate.toISOString() : null,
                AdvanceEndDate: advEndDate ? advEndDate.toISOString() : null,
                AccountantId: user.accountantId,
                CheckType: 'תקבול',
                OnlyProcessed: !!onlyProcessedDocumentsRef.current,
            };

            const data = await VatAdvancesDataService.fetchVatAdvancesPageData(dto, token);
            const payload = VatAdvancesDataService.buildReduxPayload(data, client, user);
            dispatch(setAllClientData(payload));

            setAcceptedWithholdingTax(data.advanceReceiptWithholding || 0);
            setCollectionBalance(data.balance || 0);

            if (data.isSubordinate !== undefined) {
                setIsSubordinateClient(data.isSubordinate);
            }
            if (data.mainClientData) {
                setMainClientData(data.mainClientData);
            }
            console.log('data.isMainWithSubordinates', data.isMainWithSubordinates);
            console.log('data.subordinateClients', data.subordinateClients);
            if (data.isMainWithSubordinates !== undefined) {
                setIsMainWithSubordinates(data.isMainWithSubordinates);
            }
            if (data.subordinateClients) {
                setSubordinateClients(data.subordinateClients);
            }
            setVatGroup(data.vatGroup ?? null);

        } catch (error) {
            console.error('Error fetching data on date range change:', error);
            dispatch(setClientError(error.message));
            toast.error(t('errorFetchingData', { errorText: error.message }));
        } finally {
            dispatch(setClientLoading(false));
        }
    }
    // Helper for VAT data fetch (extracted from your original logic)
    async function fetchVatData(start, end, options = {}) {
        if (fetchVatInProgressRef.current) return;
        fetchVatInProgressRef.current = true;
        const { advStart, advEnd, useAdvancedForAdvanceSection } = options;
        try {
            dispatch(setClientLoading(true));
            // Format dates
            const formattedStart = start.toISOString();
            const formattedEnd = end.toISOString();
            // For Income Tax Advance: use advanced dates + flag when advance section has different context
            const advanceDates = useAdvancedForAdvanceSection && advStart != null && advEnd != null
                ? { start: advStart.toISOString(), end: advEnd.toISOString(), useAdvancedReportingType: true }
                : { start: formattedStart, end: formattedEnd, useAdvancedReportingType: false };
            // Get userType
            const userType = (await UserService.getCurrentUserType()).toString();
            // Get balance
            const balance = await EnumsService.GetBalancesByCaseIds(
                user.accountantId,
                [client.caseId],
                token,
                new Date()
            );
            setCollectionBalance(balance[0]?.balance);
            // Build request promises
            const promises = [
                DocumentService.GetVatAndAmountDocumentsbyDateRange(
                    'Incomes', client.caseId, formattedStart, formattedEnd, token
                ),
                DocumentService.GetVatAndAmountDocumentsbyDateRange(
                    'Expenses', client.caseId, formattedStart, formattedEnd, token
                ),
                ClientService.GetIncomeTaxAdvancesByDateRange(
                    client.caseId, advanceDates.start, advanceDates.end, 'תקבול', token, advanceDates.useAdvancedReportingType
                ),
                DocumentService.GetWithholdingRange(
                    'PaymentAcceptances', client.caseId, formattedStart, formattedEnd, token
                ),
            ];
            // If not userType 1, add VAT report; add Advance report only when advance section uses same period as VAT.
            // Mismatched reporting types (useAdvancedForAdvanceSection): we do 2 fetches so amounts stay period-correct.
            // Case A: VAT דו חודשי, Advance חודשי → VAT 2 months, advance 1 month; Case B: VAT חודשי, Advance דו חודשי → VAT 1 month, advance 2 months.
            // Advance amounts (witholdingIncomesNoVat, advanceReportTax) must come from fetchDataForAdvancedAcceptedWithholdingTax only in those cases.
            const addAdvanceReportInVatFetch = userType !== '1' && !useAdvancedForAdvanceSection;
            if (userType !== '1') {
                const dto = { CaseId: client.caseId, StartDate: start, EndDate: end, IsRange: isRange };
                promises.unshift(ReportsService.getVatByDateRange(dto, token));
                if (addAdvanceReportInVatFetch) {
                    const dtoAdv = { CaseId: client.caseId, StartDate: start, EndDate: end, IsRange: isRange };
                    promises.unshift(ReportsService.getAdvanceByDateRange(dtoAdv, token));
                }
            }
            // Resolve all
            const responses = await Promise.all(promises);
            const offset = userType !== '1' ? (addAdvanceReportInVatFetch ? 2 : 1) : 0;
            let reportTax = null;
            let advanceReportTax = null;
            if (userType !== '1') {
                const [rep, adv] = addAdvanceReportInVatFetch
                    ? await Promise.all([responses[0].json(), responses[1].json()])
                    : [await responses[0].json(), null];
                if (addAdvanceReportInVatFetch) advanceReportTax = adv;
                reportTax = {
                    vatTransactions: 0,
                    otherVATTaxes: 0,
                    equipmentVAT: 0,
                    netVAT: 0,
                    ...rep
                };
            }
            const [incomeRes, expenseRes, advancesRes, withholdingRes] =
                await Promise.all(responses.slice(offset).map(r => r.json()));
            const income = incomeRes?.income || 0;
            const zeroVatAmount = incomeRes?.zeroVatAmount || 0;
            const sellEquipNoVat = incomeRes.sellEquipmentWithoutVat;
            const expense = expenseRes?.expense || 0;
            const equipment = expenseRes?.equipment || 0;
            const incomeVat = income?.vat || 0;
            const expenseVat = expense?.vat || 0;
            const equipmentVat = equipment?.vat || 0;
            const incomesWithoutVat = income?.totalWithoutVat || 0;
            const expensesWithoutVat = expense?.totalWithoutVat || 0;
            const equipmentWithoutVat = equipment?.totalWithoutVat || 0;
            const profitAmount = incomesWithoutVat - expensesWithoutVat - equipmentWithoutVat;
            const netVatAmount = incomeVat - expenseVat - equipmentVat;
            const incomeNoVat = zeroVatAmount || 0;
            const incomesVatDetailed = income;
            const incomesAmountDetailed = {
                amount17: income?.totalWithoutVat17 || 0,
                amount18: income?.totalWithoutVat18 || 0
            };
            // Month closure check
            const [isClosedStart, isClosedEnd] = await Promise.all(
                [ClientService.CheckIfMonthClosed(client.caseId, start, token),
                ClientService.CheckIfMonthClosed(client.caseId, end, token)]
                    .map((r) => r.then((res) => res.json()))
            );
            setAcceptedWithholdingTax(withholdingRes.receiptWithholding);
            // When reporting types differ (VAT דו חודשי + Advance חודשי, or VAT חודשי + Advance דו חודשי), advance-section amounts come only from fetchDataForAdvancedAcceptedWithholdingTax.
            const payload = {
                user: {
                    accountantId: user.accountantId,
                    caseId: client.caseId
                },
                reportTax: reportTax,
                income,
                expense,
                equipment,
                zeroVatAmount,
                sellEquipNoVat,
                balances: balance[0]?.balance || 0,
                incomeTaxAdvances: advancesRes.incomeTaxAdvances,
                withholding: {
                    payment: withholdingRes.paymentWithholding,
                    accepted: withholdingRes.receiptWithholding
                },
                closedMonths: {
                    start: isClosedStart,
                    end: isClosedEnd
                },
                incomesAmountDetailed: incomesAmountDetailed,
                expensesVatDetailed: expense,
                equipmentVatDetailed: equipment,
                incomesVatDetailed,
                incomesVatAmount: incomeVat,
                expensesVatAmount: expenseVat,
                purchaseOfEquipmentExpensesVatAmount: equipmentVat,
                incomesAmount: incomesWithoutVat,
                expensesAmount: expensesWithoutVat,
                purchaseOfEquipmentExpensesAmount: equipmentWithoutVat,
                profitAmount,
                netVatAmount,
                incomeNoVat,
                paymentWithholdingTax: withholdingRes.paymentWithholding,
                pageIncomeTaxAdvancePercentage: client?.incomeTaxAdvancePercentage ?? null,
                pageUseIncomeTaxAdvancePercentage: client?.useIncomeTaxAdvancePercentage ?? null,
                pageIncomeTaxAdvanceAmount: client?.incomeTaxAdvanceAmount ?? null,
                // Legacy fetch path doesn't return per-partner yearly settings; keep slice consistent.
                partnerAdvanceSettings: {},
            };
            if (!useAdvancedForAdvanceSection) {
                payload.advanceReportTax = advanceReportTax;
                payload.witholdingIncomesNoVat = incomesWithoutVat - sellEquipNoVat;
            }
            dispatch(setAllClientData(payload));
        } catch (err) {
            console.error('Error fetching VAT data:', err);
            dispatch(setClientError(err.message));
            toast.error(t('errorFetchingData', { errorText: err.message }));
        } finally {
            fetchVatInProgressRef.current = false;
            dispatch(setClientLoading(false));
        }
    }

    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
        if (!documentCounts) {
            setFormData(client);
            setClient(client);
            return
        }
        // Enrich clients with their total document counts
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts.totalCounts || 0, // Default to 0 if no matching count is found
            documentCounts: documentCounts.documentCounts || {},
            documentIds: documentCounts.documentIds || {},
        };
        setFormData(enrichedClient);
        setClient(enrichedClient);
        dispatch(setSelectedClient(enrichedClient));
    }


    const init = useCallback(async () => {
        try {
            if (!user || !token) {
                navigate("/login");
                return;
            }
            if (location.state?.client) {
                const { client } = location.state;

                if (initInProgressRef.current || lastInitCaseIdRef.current === client.caseId) {
                    return;
                }
                initInProgressRef.current = true;

                const clientData = await ClientService.GetClient(token, client.caseId);
                dispatch(setSelectedClient(clientData));

                const IsBiMonthly = clientData.reportingType === 'דו חודשי';
                const IsAdvancedBiMonthly = clientData?.advancedReportingType === 'דו חודשי';
                setIsBiMonthly(IsBiMonthly);
                setIsAdvancedBiMonthly(IsAdvancedBiMonthly);

                const [, , , tokenDaysRemainingData] = await Promise.all([
                    fetchEnums(token, clientData, false),
                    fetchTotalUploads(token, clientData.caseId),
                    fetchDocumentsNotification(clientData, token),
                    (clientData.caseType === Constants.CharityOrganization 
                        ? TaxAuthorityService.getTokenDaysRemaining(clientData.caseId, token, Constants.TaxAuthorityScopes.Donations)
                        : TaxAuthorityService.getTokenDaysRemaining(clientData.caseId, token, Constants.TaxAuthorityScopes.CreationNumber))
                ]);
                const daysRemaining = tokenDaysRemainingData?.daysRemaining ?? 0;
                const secoundsRemaining = tokenDaysRemainingData?.secondsRemaining ?? 0;
                setTokenDaysRemaining(daysRemaining);
                setTokenSecondsRemaining(secoundsRemaining);

                lastInitCaseIdRef.current = clientData.caseId;

                if (!client.isActive && !localStorage.getItem('dismissedDialog')) {
                    setOpenDialog(true);
                }
            }
        } catch (error) {
            console.error("Initialization failed", error);
        } finally {
            initInProgressRef.current = false;
        }
    }, [location.state, token, user]);

    useEffect(() => {
        if (!permissionsLoading && user && token) {
            init();
        }
    }, [permissionsLoading, user, token, location.state, navigate]);

    const getCurrentBiMonthlyPeriodDates = () => {
        const now = new Date();
        const currentMonth = now.getUTCMonth(); // 0-indexed month
        const currentYear = now.getUTCFullYear();

        let startMonth, endMonth;
        if (currentMonth % 2 === 0) { // even month
            startMonth = currentMonth;
            endMonth = currentMonth + 1;
        } else { // odd month
            startMonth = currentMonth - 1;
            endMonth = currentMonth;
        }

        const startDate = new Date(Date.UTC(currentYear, startMonth, 1));
        const endDate = new Date(Date.UTC(currentYear, endMonth + 1, 0, 23, 59, 59, 999)); // Last day of end month

        return { startDate, endDate };
    };

    useEffect(() => {
        if (!client) return;

        const { accountantId, reportingType } = client;

        if (fetchSubAccountantsCalledRef.current !== accountantId) {
            fetchSubAccountantsCalledRef.current = accountantId;
            fetchSubAccountantsData(accountantId, token, true);
        }

        if (reportingType === 'דו חודשי' && !isRange) {
            let biStartDate, biEndDate;

            // Check if dates exist in localStorage
            const storedStartDateString = localStorage.getItem('BiStartDate');
            const storedEndDateString = localStorage.getItem('BiEndDate');

            if (storedStartDateString && storedEndDateString) {
                biStartDate = new Date(storedStartDateString);
                biEndDate = new Date(storedEndDateString);
            } else {
                ({ startDate: biStartDate, endDate: biEndDate } = getCurrentBiMonthlyPeriodDates());
            }

            setBiStartDate(biStartDate);
            setBiEndDate(biEndDate);

            // Fetch only if the date range actually changes
            fetchDataOnDateRangeChange(biStartDate, biEndDate);
        } else {
            if (!isRange) {
                fetchDataOnDateRangeChange(date, date);
            } else {
                fetchDataOnDateRangeChange(startDate, endDate);
            }
        }
    }, [client]);

    useEffect(() => {
        // To handle multiple updates efficiently, consider iterating over documentUpdate keys
        Object.keys(documentUpdate).forEach(updateCaseId => {
            const update = documentUpdate[updateCaseId];
            // Update clients with new totalCounts for the matching caseId

            if (client?.caseId === updateCaseId) { // Check if the client's caseId matches the update's caseId
                const updatedClients = {
                    ...client,
                    totalCounts: update.totalCounts, // Update totalCounts from documentUpdate
                    documentIds: update.documentsIds,
                    documentCounts: update.documentsCount

                };
                setFormData(updatedClients);
                setClient(updatedClients); // Update the state with the modified lzist
            }

        });
    }, [documentUpdate]);

    // Synchronize isClosedReportingMonth with Redux closedMonths data
    useEffect(() => {
        if (closedMonths) {
            if (isBiMonthly) {
                // For bi-monthly, both months should be closed
                const bothClosed = closedMonths.start && closedMonths.end;
                setIsClosedReportingMonth(bothClosed);
            } else {
                // For single month, check the start month (which represents the current date)
                setIsClosedReportingMonth(closedMonths.start || false);
            }
        }
    }, [closedMonths, isBiMonthly]);



    const {
        viewDocumentDetails,
        viewSortCodeReport,
        viewJournalEntryDetails,
        viewOtherDocumentDetails,
        viewClientItems,
        viewInventoryItems,
        viewPaymentAcceptanceDetails,
        viewProfitAndLossDetails,
        viewProfittAndLoss6111,
        viewReport1214,
        viewReport1214B,
        viewReport1281,
        viewReport1362,
        viewAnnualReportQuestionnaire,
        viewAnnualReport,
        viewTransactionDocuments,
        viewLedgerReport,
        viewAccountCardsTable,
        viewReceivables,
        viewReceivablesAging,
        viewCashFlowForecast,
        viewForeignTravelReport,
        viewClientExpenseAssignmentReport,
        viewBankTransactions,
        viewCollectionPage,
        viewAssignments,
        viewUserActivity,
        viewCardMatching,
        viewBankPage,
        viewAssets,
        viewProjects,
        viewDocumentCreate,
        viewHoldingItems,
        viewClarificationDocuments,
        viewVehicleManagement,
        viewGarageWorkDiary,
        viewAudit,
        viewAuditReports,
        viewTrackingList,
        viewAdvanceCalculator,
        viewAccountCardDashboardBAccountCard,
        viewSignatureDocument,
        viewForms,
        viewAddClient,
    } = useClientNavigation(client);

    // Taiodet Import Hook
    const {
        previewTaiodetAccountCards,
        commitTaiodetAccountCards,
        previewTaiodetJournal,
        commitTaiodetJournal
    } = useTaiodetImport({
        client,
        token,
        fetchEnums,
        setLoading
    });

    const {
        previewPriorityAccountCards,
        commitPriorityAccountCards,
        previewPriorityJournal,
        commitPriorityJournal,
        previewPriorityOpeningBalance,
        commitPriorityOpeningBalance
    } = usePriorityImport({
        client,
        token,
        fetchEnums,
        setLoading
    });

    //File Download Functions
    const closeDownloadModal = () => {
        setShowDownloadModal(false);

    };

    const closeImportModal = () => {
        setShowImportModal(false);

    };

    const closeFileDownloadModal = () => {
        setShowDownloadFilesModal(false);

    };

    const closeExportJournal = () => {
        setShowExportJournalModal(false);
        setShowDownloadModal(true);
        setFileType('');
        setFilesRange('');
    };

    const closeImportJournal = () => {
        setShowImportJournalModal(false);
        setShowImportModal(true);

    };
    const closeAccountCardModal = () => {
        setShowAccountCardModal(false);
        setShowDownloadModal(true);
        setFileType('');
    };

    const closeAccountCardImportModal = () => {
        setShowAccountCardImportModal(false);
        setShowImportModal(true);
        setFileType('');
    };
    const openReferenceSequenceModal = () => {
        openReferenceSequenceModalFromContext();
        setShowDownloadFilesModal(false);
    };

    const checkAuthCompletion = async (authWindow, scope = Constants.TaxAuthorityScopes.CreationNumber) => {
        setLoading(true);
        try {
            let attempts = 0;
            const maxAttempts = 25;

            while (attempts < maxAttempts) {
                // Check if the authWindow was closed by the user
                if (authWindow.closed) {
                    setLoading(false);
                    toast.error(t('Authentication window was closed by the user.'));
                    return;
                }

                const result = await TaxAuthorityService.getTokenDaysRemaining(client.caseId, token, scope);

                if (result.daysRemaining > 0) {
                    setLoading(false);
                    setTokenDaysRemaining(result.daysRemaining); // Update the token days remaining
                    setTokenSecondsRemaining(result.secondsRemaining);
                    toast.success(`${t('TokenRefreshedSuccessfully')}: ${result.daysRemaining} ${t('Days')}`);

                    // Close the auth window
                    if (authWindow && !authWindow.closed) {
                        authWindow.close();
                    }
                    return;
                } else {
                    attempts += 1;
                    await new Promise((resolve) => setTimeout(resolve, 3000));
                }
            }

            setLoading(false);
            toast.error(t('TokenRefreshFailed'));

            // Close the auth window on timeout
            if (authWindow && !authWindow.closed) {
                authWindow.close();
            }
        } catch (error) {
            console.error('Error checking auth completion:', error);
            setLoading(false);
            toast.error(t('TokenRefreshFailed'));

            // Close the auth window on error
            if (authWindow && !authWindow.closed) {
                authWindow.close();
            }
        }
    };

    const handleTaxAuthorityAuth = (authUrl, scope = Constants.TaxAuthorityScopes.CreationNumber) => {
        // Open the authentication URL in a new tab
        const authWindow = window.open(authUrl, '_blank');

        // Store the authWindow in state if needed
        // setAuthWindow(authWindow);

        // Start checking for authentication completion (scope picks the right token: invoices/donations)
        checkAuthCompletion(authWindow, scope);
    };

    const refreshTaxAuthorityTokenValidity = async (isCharityOrganization = false) => {
        if (!client || !token) return;
        try {
            const scope = isCharityOrganization ? Constants.TaxAuthorityScopes.Donations : Constants.TaxAuthorityScopes.CreationNumber;
            const res = await TaxAuthorityService.getTokenDaysRemaining(client.caseId, token, scope);
            setTokenDaysRemaining(res?.daysRemaining ?? 0);
            setTokenSecondsRemaining(res?.secondsRemaining ?? 0);
        } catch (e) {
            console.error('Failed to refresh Tax Authority token validity', e);
            setTokenDaysRemaining(0);
            setTokenSecondsRemaining(0);
        }
    };

    //export
    const openExportModal = () => {
        setShowDownloadModal(false);
        setShowExportJournalModal(true);
    }

    const openAccountCardModal = () => {
        setShowDownloadModal(false);
        setShowAccountCardModal(true);
    }

    const openAccountCardImportModal = () => {
        setShowImportModal(false);
        setShowAccountCardImportModal(true);
    }

    const openImportModal = () => {
        setShowImportModal(false);
        setShowImportJournalModal(true);
    }

    const openJournalEntriesImportModal = () => {
        setShowImportJournalModal(false);
        setShowJEImportModal(true);
    }


    const openRivhitEntriesImportModal = () => {
        setShowImportJournalModal(false);
        setShowRivhitImportModal(true);
    }

    const handleDownloadReceptionLog = () => {
        setShowJournalDocModal(true);
    }

    // The modal payload carries the report options plus every filter field; the reports
    // service decides which of them end up in the request body.
    const onSubmitJournalDocumentation = async (options) => {
        const {
            types,
            sortBy,
            sortDirection,
            format,
            startDate: modalStart,
            endDate: modalEnd,
            includeDescription = true,
            documentIds = null,
        } = options;
        setLoading(true);
        try {
            const StartDate = modalStart ? modalStart : (isRange ? startDate : date);
            const EndDate = modalEnd ? modalEnd : (isRange ? endDate : date);
            const selectedTypes = (types && types.length > 0) ? types : [];
            const finalDocumentIds = documentIds || null;
            const filters = options;

            if (format === 'excel') {
                const blob = await ReportsService.getJournalEntryDocumentationExcel(
                    client.caseId,
                    StartDate,
                    EndDate,
                    selectedTypes,
                    token,
                    sortBy,
                    sortDirection,
                    includeDescription,
                    finalDocumentIds,
                    filters
                );
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                // PDF
                const blob = (selectedTypes.length > 1)
                    ? await ReportsService.getJournalEntryDocumentationCombinedPdf(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes,
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    )
                    : await ReportsService.getJournalEntryDocumentation(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes[0],
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    );

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }

            toast.success(t('reportDownloadSuccess'));
            setShowJournalDocModal(false);
        } catch (error) {
            console.error(error);
            toast.error(t('reportDownloadFailure'));
        } finally {
            setLoading(false);
        }
    };

    const getLastDayOfMonth = (year, month) => {
        return new Date(Date.UTC(year, month + 1, 0)).getDate();
    };

    const setDates = (isRange, date, startDate, endDate) => {
        let start, end;
        if (isBiMonthly && !isRange) {
            start = biStartDate;
            end = biEndDate;
        }
        else if (isRange) {
            // When range is provided, set start and end date to the first and last day of their respective months
            const startMonth = startDate.getMonth();
            const startYear = startDate.getFullYear();
            const endMonth = endDate.getMonth();
            const endYear = endDate.getFullYear();

            const lastDayStart = getLastDayOfMonth(startYear, startMonth);
            const lastDayEnd = getLastDayOfMonth(endYear, endMonth);

            start = new Date(Date.UTC(startYear, startMonth, 1));
            end = new Date(Date.UTC(endYear, endMonth, lastDayEnd, 23, 59, 59, 999));
        } else {
            // When no range is provided, set start and end date to the first and last day of the same month
            const month = date.getMonth();
            const year = date.getFullYear();

            const lastDay = getLastDayOfMonth(year, month);

            start = new Date(Date.UTC(year, month, 1));
            end = new Date(Date.UTC(year, month, lastDay, 23, 59, 59, 999));
        }
        return { start, end };
    };

    const openWithholdingTaxModel = (reportType) => {

        setSelectedReportType(reportType);
        setWithHoldingTaxModalOpen(true);
    };

    const openClientWithholdingTaxModel = (reportType) => {
        setSelectedReportType(reportType);
        setClientWithHoldingTaxModalOpen(true);
    };

    const downloadVATReport = async () => {
        try {
            dispatch(setClientLoading(true));
            /* 1️⃣  build the same date range you already pass to the report */
            const { start, end } = setDates(isRange, date, startDate, endDate);

            /* 2️⃣  ask the server whether any docs are still un-processed   */
            const existRes = await ClientService.VatTransactionDocumentsExist({
                caseId: client.caseId,
                accountantId: client.accountantId,
                startDate: start,
                endDate: end
            }, token);


            const netVatDone = existRes?.data?.netVat === false;

            /* 3️⃣  If netVat === true  → warn the user first               */
            if (netVatDone) {
                const result = await MySwal.fire({
                    title: t('UnprocessedDocumentsWarning'),   // 🔑 add to i18n
                    text: t('SomeTransactionsAreStillNotProcessed'),  // optional body
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: t('Yes'),   // continue & download
                    cancelButtonText: t('No'),
                    customClass: { container: 'swal-high-zindex' }
                });

                if (!result.isConfirmed) {
                    dispatch(setClientLoading(false));
                    return;                         // user aborted
                }
            }

            /* 4️⃣  Everything is clear or the user confirmed → download   */
            await ClientService.VATReport(
                client.caseId,
                client.accountantId,
                start,
                end,
                token,
                onlyProcessedDocumentsRef.current
            );
            toast.success(t('reportDownloadSuccess'));
        } catch (err) {
            console.error(err);
            toast.error(err.message || t('reportDownloadFailure'));
        } finally {
            dispatch(setClientLoading(false));
            setShowDownloadModal(false);
        }
    };


    // Helper to get the correct date range for Withholding Tax Report
    const getWithholdingTaxReportDates = () => {
        let start, end;
        if (isAdvancedBiMonthly !== isBiMonthly) {
            // Use advanced date state
            if (isRange) {
                start = advancedStartDate;
                end = advancedEndDate;
            } else if (isAdvancedBiMonthly) {
                start = advancedBiStartDate;
                end = advancedBiEndDate;
            } else {
                start = advancedDate;
                end = advancedDate;
            }
        } else {
            // Use main date state
            if (isRange) {
                start = startDate;
                end = endDate;
            } else if (isBiMonthly) {
                start = biStartDate;
                end = biEndDate;
            } else {
                start = date;
                end = date;
            }
        }
        return { start, end };
    };

    // Helper to set advanced date range
    const setAdvancedDateRange = (start, end) => {
        setAdvancedStartDate(start);
        setAdvancedEndDate(end);
        localStorage.setItem('AdvancedStartDate', start.toISOString());
        localStorage.setItem('AdvancedEndDate', end.toISOString());
    };

    const downloadWithholdingTaxReport = async (partnerId = null) => {

        
        // Check sessionStorage for partnerId (used when called from date modal)
        if (!partnerId) {
            const storedPartnerId = sessionStorage.getItem('selectedPartnerIdForReport');
            if (storedPartnerId) {
                partnerId = storedPartnerId;
                sessionStorage.removeItem('selectedPartnerIdForReport');
            }
        }
        
        dispatch(setClientLoading(true));
        try {
            const { start, end } = getWithholdingTaxReportDates();
            console.log('Calling ReportsService.WithholdingTaxReport with:', {
                caseId: client.caseId,
                accountantId: client.accountantId,
                start,
                end,
                partnerId
            });
            await ReportsService.WithholdingTaxReport(client.caseId, client.accountantId, start, end, token, partnerId, onlyProcessedDocumentsRef.current);
            toast.success(t("reportDownloadSuccess"));
        }
        catch (error) {
            console.error(error);
            toast.error(t("reportDownloadFailure"));
        }
        finally {
            dispatch(setClientLoading(false));
        }
        setShowDownloadModal(false);
    };



    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const downloadPCNReport = async () => {
        setShowPCNModal(true);
    }

    const handlePCNDownload = async (modalStartDate = null, modalEndDate = null) => {
        setLoading(true);

        // Use modal dates if provided, otherwise use parent component dates
        let start, end;
        if (modalStartDate && modalEndDate) {
            start = modalStartDate;
            end = modalEndDate;
        } else {
            // Dates are the same for both files, so calculate once
            const dateResult = setDates(isRange, date, startDate, endDate);
            start = dateResult.start;
            end = dateResult.end;
        }

        /* ───────────── TXT file first ───────────── */
        try {
            await PCNService.DownloadPCNReport(
                client.caseId,
                start,
                end,
                pcnIncludeStornoChecks,   // keep if your backend still needs it
                token
            );
            toast.success(t("reportDownloadSuccess"));
        } catch (error) {
            console.error(error);
            toast.error(t("reportDownloadFailure"));
        }

        // Nice little gap so two "Save as…" dialogs don't overlap
        await delay(500);

        /* ───────────── PDF file second ───────────── */
        try {
            await PCNService.DownloadPCNPDF(
                client.caseId,
                start,
                end,
                pcnIncludeStornoChecks,   // same here
            );
            toast.success(t("reportDownloadSuccess"));
        } catch (error) {
            console.error(error);
            toast.error(t("reportDownloadFailure"));
        }

        // House‑keeping
        setLoading(false);
        setShowPCNModal(false);      // or setShowDownloadModal(false) if you renamed it
        setPcnIncludeStornoChecks(null);
    };


    // Function to refresh PCN data
    const refreshPCNData = useCallback(async () => {
       
        if (client && token ) {
            // Use stored PCN check dates if available, otherwise use component dates
            let start, end;
            if (pcnCheckDates) {
                start = pcnCheckDates.start;
                end = pcnCheckDates.end;
            } else {
                const dates = setDates(isRange, date, startDate, endDate);
                start = dates.start;
                end = dates.end;
            }

            try {
                const response = await PCNService.CheckPCNDocuments(
                    client.caseId,
                    start,
                    end,
                    pcnIncludeStornoChecks
                );
                if (response.success) {
                    setPcnHighConfirmationDocs(response.documents || []);
                    setPcnDocumentsNeedingAllocation(response.documentsNeedingAllocation || []);
                    setPcnDocumentsWithoutReference(response.documentsWithoutReference || []);
                    setPcnDocumentsOutOfRange(response.documentsOutOfRange || []);

                    // Set the new PCN report details
                    if (response.incomes || response.expenses || response.equipmentTransactions) {
                        setPcnReportDetails({
                            incomes: response.incomes || [],
                            expenses: response.expenses || [],
                            equipmentTransactions: response.equipmentTransactions || [],
                            clientName: client.name,
                            incomeType: response.incomeType || {},
                            expenseType: response.expenseType || {},
                            incomeVatSum: response.incomeVatSum,
                            incomeSum: response.incomeSum,
                            expenseVatSum: response.expenseVatSum,
                            expenseSum: response.expenseSum,
                            equipmentInputVat: response.equipmentInputVat,
                            equipmentInputSum: response.equipmentInputSum,
                            amountToPayOrRefund: response.amountToPayOrRefund,
                        });
                    }
                }
            } catch (error) {
                console.error('Error refreshing PCN data:', error);
            }
            setPcnRefreshClientDetails(false);
        }
    }, [client, token, isRange, date, startDate, endDate, pcnIncludeStornoChecks, pcnCheckDates]);

    // Set the PCN refresh callback in the context
    useEffect(() => {
        if (pcnRefreshClientDetails) {
            refreshPCNData();
        }
    }, [pcnRefreshClientDetails]);


    const handlePCNChecks = async (modalStartDate = null, modalEndDate = null) => {
        setPcnChecksLoading(true);

        try {
            // Use modal dates if provided, otherwise use parent component dates
            let start, end;
            if (modalStartDate && modalEndDate) {
                start = modalStartDate;
                end = modalEndDate;
            } else {
                const { start: parentStart, end: parentEnd } = setDates(isRange, date, startDate, endDate);
                start = parentStart;
                end = parentEnd;
            }

            // Store the dates used for this PCN check so refreshes use the same dates
            setPcnCheckDates({ start, end });

            const response = await PCNService.CheckPCNDocuments(
                client.caseId,
                start,
                end,
                pcnIncludeStornoChecks
            );

            if (response.success) {
                setPcnHighConfirmationDocs(response.documents || []);
                setPcnDocumentsNeedingAllocation(response.documentsNeedingAllocation || []);
                setPcnDocumentsWithoutReference(response.documentsWithoutReference || []);
                setPcnDocumentsOutOfRange(response.documentsOutOfRange || []);

                // Set the new PCN report details
                if (response.incomes || response.expenses || response.equipmentTransactions) {
                    setPcnReportDetails({
                        incomes: response.incomes || [],
                        expenses: response.expenses || [],
                        equipmentTransactions: response.equipmentTransactions || [],
                        clientName: client.name,
                        incomeType: response.incomeType || {},
                        expenseType: response.expenseType || {},
                        incomeVatSum: response.incomeVatSum,
                        incomeSum: response.incomeSum,
                        expenseVatSum: response.expenseVatSum,
                        expenseSum: response.expenseSum,
                        equipmentInputVat: response.equipmentInputVat,
                        equipmentInputSum: response.equipmentInputSum,
                        amountToPayOrRefund: response.amountToPayOrRefund,
                    });
                }

                setShowPCNChecksModal(true);
            } else {
                toast.success(t("NoHighConfirmationDocuments"));
            }
        } catch (error) {
            console.error(error);
            toast.error(t("PCNChecksFailed"));
        } finally {
            setPcnChecksLoading(false);
        }
    };


    const downloadProfitAndLoss = async () => {
        setLoading(true);
        try {
            const { start, end } = setDates(isRange, date, startDate, endDate);
            await ClientService.ProfitAndLossDetailsYearlyReport(client.caseId, client.accountantId, start, end, token);
            toast.success(t("reportDownloadSuccess"));
        } catch (error) {
            console.error(error);
            toast.error(t("reportDownloadFailure"));
        }
        setLoading(false);
        setShowDownloadModal(false);
    }



    const journalEntryDownload = async () => {
        setLoading(true);
        if (filesRange === "" && !isRange) {
            toast.info(t('EnterRangeForResults'));
            setLoading(false);
            return;
        }

        if (filetype == "DAT") {
            await ClientService.DownloadJournalEntryDatReport(client.caseId, jeStartDate, jeEndDate, filesRange, token);
        }
        if (filetype == "TXT") {
            await ClientService.DownloadJournalEntryReport(client.caseId, jeStartDate, jeEndDate, filesRange, token);
        }
        if (filetype != "TXT" && filetype != "DAT") {
            toast.info(t('Please Select File Type'));
        }
        setLoading(false)
    };

    const [showMoveinExportPreview, setShowMoveinExportPreview] = useState(false);
    const [moveinExportPreviewData, setMoveinExportPreviewData] = useState(null);
    /**
     * Map of SortCodeName -> MappedCode that the user edits in the preview modal.
     * Keys come from preview.uniqueSortCodeNames; values default to the first 3 chars of the name.
     */
    const [moveinSortCodeMappings, setMoveinSortCodeMappings] = useState({});

    const journalEntryDownloadMovein = async () => {
        setLoading(true);
        try {
            const previewData = await ImportExportService.PreviewExportTransactionReportMovinDat(
                client.caseId,
                jeStartDate,
                jeEndDate,
                token
            );
            const names = Array.isArray(previewData?.uniqueSortCodeNames)
                ? previewData.uniqueSortCodeNames
                : [];
            const defaultMappings = {};
            names.forEach((n) => {
                const name = n ?? '';
                defaultMappings[name] = (name || '1').slice(0, 3);
            });
            setMoveinSortCodeMappings(defaultMappings);
            setMoveinExportPreviewData(previewData);
            setShowMoveinExportPreview(true);
        } catch (error) {
            console.error('Error previewing MOVEIN export:', error);
            toast.error(t('PreviewFailed') || 'Preview failed');
        }
        setLoading(false);
    };

    const confirmMoveinExport = async () => {
        setLoading(true);
        try {
            const mappings = Object.entries(moveinSortCodeMappings || {}).map(([SortCodeName, MappedCode]) => ({
                SortCodeName,
                MappedCode: (MappedCode ?? '').toString().slice(0, 3)
            }));
            await ImportExportService.ExportTransactionReportMovinDat(
                client.caseId,
                jeStartDate,
                jeEndDate,
                token,
                mappings
            );
            toast.success(t('ExportSuccess') || 'Export successful');
            setShowMoveinExportPreview(false);
            setMoveinExportPreviewData(null);
            setMoveinSortCodeMappings({});
        } catch (error) {
            console.error('Error exporting MOVEIN:', error);
            toast.error(t('ExportFailed') || 'Export failed');
        }
        setLoading(false);
    };

    const [showPkudaExportPreview, setShowPkudaExportPreview] = useState(false);
    const [pkudaExportPreviewData, setPkudaExportPreviewData] = useState(null);
    const [pkudaExportOptions, setPkudaExportOptions] = useState({
        includeIncomes: true,
        includeExpenses: true,
        includeJournalEntries: true
    });

    const journalEntryDownloadPkuda = async () => {
        setLoading(true);
        try {
            const options = {
                includeIncomes: true,
                includeExpenses: true,
                includeJournalEntries: true
            };
            setPkudaExportOptions(options);
            const previewData = await ImportExportService.PreviewExportTransactionReportPkuda(
                client.caseId, 
                jeStartDate, 
                jeEndDate, 
                token,
                options
            );
            setPkudaExportPreviewData(previewData);
            setShowPkudaExportPreview(true);
        } catch (error) {
            console.error('Error previewing PKUDA export:', error);
            toast.error(t('PreviewFailed') || 'Preview failed');
        }
        setLoading(false)
    };

    const refreshPkudaExportPreview = async (nextOptions) => {
        const options = nextOptions || pkudaExportOptions;
        setPkudaExportOptions(options);
        setLoading(true);
        try {
            const previewData = await ImportExportService.PreviewExportTransactionReportPkuda(
                client.caseId,
                jeStartDate,
                jeEndDate,
                token,
                options
            );
            setPkudaExportPreviewData(previewData);
        } catch (error) {
            console.error('Error refreshing PKUDA export preview:', error);
            toast.error(t('PreviewFailed') || 'Preview failed');
        }
        setLoading(false);
    };

    const confirmPkudaExport = async () => {
        const { includeIncomes, includeExpenses, includeJournalEntries } = pkudaExportOptions;
        if (!includeIncomes && !includeExpenses && !includeJournalEntries) {
            toast.info(t('SelectAtLeastOneExportType') || 'יש לבחור לפחות סוג אחד לייצוא');
            return;
        }
        setLoading(true);
        try {
            await ImportExportService.ExportTransactionReportPkuda(
                client.caseId, 
                jeStartDate, 
                jeEndDate, 
                token,
                pkudaExportOptions
            );
            toast.success(t('ExportSuccess') || 'Export successful');
            setShowPkudaExportPreview(false);
            setPkudaExportPreviewData(null);
        } catch (error) {
            console.error('Error exporting PKUDA:', error);
            toast.error(t('ExportFailed') || 'Export failed');
        }
        setLoading(false)
    };


    const accountantCardDownload = async (type) => {
        setLoading(true);
        if (filetype === "DAT") {
            await ClientService.DownloadAccountantCardReportDat(client.caseId, date, type, token);
        }
        if (filetype === "TXT") {
            await ClientService.DownloadAccountantCardReport(client.caseId, date, type, token);
        } else {
            toast.info(t('Please Select File Type'));
        }
        setLoading(false)
    };

    const accountantCardDownloadHeshin = async (type) => {
        setLoading(true);
        await ImportExportService.ExportAccountCardsHeshinDat(client.caseId, token);
        setLoading(false)
    };

    const [showAccountCardExportPreview, setShowAccountCardExportPreview] = useState(false);
    const [accountCardExportPreviewData, setAccountCardExportPreviewData] = useState(null);
    const [editableAccountCards, setEditableAccountCards] = useState([]);

    const accountantCardDownloadPkuda = async () => {
        setLoading(true);
        try {
            const previewData = await ImportExportService.PreviewExportAccountCards(
                client.caseId,
                token
            );
            setAccountCardExportPreviewData(previewData);
            setEditableAccountCards(previewData.cards.map(card => ({
                cardId: card.cardId,
                name: card.name,
                exportCode: card.suggestedColumn26, // Single export code
                column26: card.suggestedColumn26, // Keep for backwards compatibility
                currentPalCode: card.currentPalCode
            })));
            setShowAccountCardExportPreview(true);
        } catch (error) {
            console.error('Error previewing account cards export:', error);
            toast.error(t('PreviewFailed') || 'Preview failed');
        }
        setLoading(false);
    };

    const confirmAccountCardExport = async () => {
        setLoading(true);
        try {
            await ImportExportService.ExportAccountCardsPkuda(
                client.caseId,
                editableAccountCards,
                token
            );
            toast.success(t('ExportSuccess') || 'Export successful');
            setShowAccountCardExportPreview(false);
            setAccountCardExportPreviewData(null);
            setEditableAccountCards([]);
        } catch (error) {
            console.error('Error exporting account cards PKUDA:', error);
            toast.error(t('ExportFailed') || 'Export failed');
        }
        setLoading(false);
    };

    const accountantCardImportRevhet = async (type) => {
        setLoading(true);
        if (filetype === "DAT") {
            await ClientService.DownloadAccountantCardReportDat(client.caseId, date, type, token);
        }
        if (filetype === "TXT") {
            await ClientService.DownloadAccountantCardReport(client.caseId, date, type, token);
        } else {
            toast.info(t('Please Select File Type'));
        }
        setLoading(false)
    };


    const { hasBack, handleBack } = useBack();

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        // handleBack();
        goBack()
    };



    const handleEdit = (client) => {
        navigate('/AddClient', {
            state: {
                client: client,
                isEdit: true
            }
        });
    };

    const handleSaveNotes = async (notesValue) => {
        if (!client?.caseId || !token) return false;
        try {
            const result = await ClientService.UpdateClientNotes(
                token,
                client.caseId,
                notesValue || '',
            );
            const updatedNotes = result?.data?.notes ?? (notesValue || null);
            const updatedClient = { ...client, notes: updatedNotes };
            setClient(updatedClient);
            await updateLocationState({ notes: updatedNotes });
            dispatch(setSelectedClient(updatedClient));
            toast.success(t('SavedSuccessfully'));
            return true;
        } catch (err) {
            toast.error(err?.body?.message || t('FailedToUpdateCustomer'));
            return false;
        }
    };

    const updateLocationState = async (newClientData) => {

        const updatedClientData = {
            ...location.state.client,
            ...newClientData
        };

        // Navigate with the updated client data and replace the current state
        navigate(location.pathname, {
            replace: true,
            state: { client: updatedClientData }
        });
    };

    const validateIsraeliPhoneNumber = (phoneNumber) => {
        const regex = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/;
        return regex.test(phoneNumber);
    };

    const validateEmail = (email) => {
        if (email === '') {
            return true;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleStatusClientSave = async (IsActive) => {
        try {
            setLoading(true);

            const response = await AuthService.EnableDisable(formData.caseId, 1, IsActive, token);

            if (response?.message) {
                // Successfully updated the user status
                const updatedClient = await ClientService.GetClient(token, formData.caseId);
                setClient(updatedClient);
                setFormData(updatedClient);
                await updateLocationState(updatedClient);
                
                // Update Redux store to reflect changes throughout the application
                dispatch(setSelectedClient(updatedClient));

                // Provide success feedback
                // alert(`Success: ${response.message}`);
            } else {
                // Handle unexpected response structure
                console.error("Unexpected response structure:", response);
                // alert("Unexpected response received from the server.");
            }
        } catch (error) {
            // Handle errors gracefully
            console.error("Error in handleStatusClientSave:", error);

            // Check if it's an HTTP error
            if (error.response) {
                alert(`Error: ${error.response.data.message || 'Failed to update user status.'}`);
            } else {
                alert("An unknown error occurred while updating the user status.");
            }
        } finally {
            setIsEditing(false);
            setLoading(false);
        }
    };

    const fetchSubAccountantsData = async (accountantId, token, isFirstFetch) => {
        try {
            // setLoading(true);
            const data = await SubAccountantService.GetSubAccountantByAccountantId(token, accountantId);
            if (isFirstFetch) {
                let transformedData = data.map(item => ({
                    label: item.name,
                    value: item.subAccountantId
                }));
                setSubAccountants(transformedData);
                // toast.success(t('fetchSubAccountantsDataSuccess'));
            } else {
                setSubAccountants([...subAccountants, ...data]);
            }
        } catch (error) {
            console.error(error);
            toast.error(t('fetchSubAccountantsDataError'));
        }
        // setLoading(false);
    };

    const areFieldsValid = (fields) => {
        return fields.every(field => field && field.trim() !== '');
    };


    const checkIfExistingAccountCard = (accountCardOptions, cardId, accountCaseId, edit = false) => {

        const existingAccountCard = accountCardOptions.filter(card =>
            (card.accountCaseId === accountCaseId && accountCaseId) ||
            (card.cardId === cardId && cardId)
        );
        const isExist = existingAccountCard && (edit
            ? existingAccountCard.length > 1
            : existingAccountCard.length > 0);
        if (isExist) {
            toast.info(t('AccountCardExists', { accountCodeId: existingAccountCard.cardId }));
            return true;
        }
    }

    const handlePropAccountCardSave = async () => {
        try {
            setLoading(true);
            let accountCardResponseOk = true;
            const areAccountCardFieldsValid = areFieldsValid([client.caseId, cardName]);
            if (checkIfExistingAccountCard(AccountCardOptions, cardId, companyId, true)) {
                return;
            }
            // Make the account card API call if fields are valid

            if (areAccountCardFieldsValid) {
                const response1 = await EnumsService.AddAccountCard(client.caseId, cardId, cardName, companyId, selectedPalCode, token);
                accountCardResponseOk = response1.ok;
                if (!response1.ok) {
                    const errorText = await response1.text();
                    console.error("Error adding account card:", errorText);
                    toast.error(t('accountCardSaveFailure', { errorText }));
                } else {
                    toast.success(t('accountCardSaveSuccess'));
                }
            }

            // If the API call was successful, fetch enums
            if (accountCardResponseOk) {
                await fetchEnums(token, client, true);
            }

        } catch (error) {
            console.error(error);
        }
        setIsPropAccountCardAdding(false);
        // setSortCodeId('');
        // setSortCodeName('');
        setCardId('');
        setCardName('');
        setCompanyId('');
        setLoading(false);
    };



    const CloseReportingMonth = async (status) => {
        setLoading(true);
        try {
            if (isBiMonthly) {
                // If bi-monthly, iterate over the range and make API calls
                const biDates = [biStartDate, biEndDate];
                for (const currentDate of biDates) {
                    const response = await ClientService.UpdateReportingMonth(client.caseId, currentDate, status, token);
                    if (!response.ok) {
                        const errorText = await response.text();
                        console.error(t('MonthReportNotClosed'), errorText);
                        toast.error(
                            status
                                ? `${t('MonthReportNotClosed')}: ${errorText}`
                                : `${t('MonthReportNotOpened')}: ${errorText}`,
                        );
                        setLoading(false);
                        return; // Stop further calls if one fails
                    }
                }
                // If all calls succeed, show a success message
                toast.success(
                    status ? t('MonthReportClosedSuccess') : t('MonthReportOpenedSuccess'),
                    { position: "top-left" }
                );
                setIsClosedReportingMonth(status);
            } else {
                // Single date case
                const response = await ClientService.UpdateReportingMonth(client.caseId, date, status, token);
                if (response.ok) {
                    toast.success(
                        status ? t('MonthReportClosedSuccess') : t('MonthReportOpenedSuccess'),
                        { position: "top-left" }
                    );
                    setIsClosedReportingMonth(status);
                } else {
                    const errorText = await response.text();
                    console.error(t('MonthReportNotClosed'), errorText);
                    toast.error(
                        status
                            ? `${t('MonthReportNotClosed')}: ${errorText}`
                            : `${t('MonthReportNotOpened')}: ${errorText}`,
                    );
                }
            }
        } catch (error) {
            console.error(t('MonthReportNotClosed'), error);
            toast.error(
                status
                    ? `${t('MonthReportNotClosed')}: ${error}`
                    : `${t('MonthReportNotOpened')}: ${error}`,
            );
        } finally {
            setLoading(false); // Stop loading regardless of the outcome
            setIsModalVisible(false);
        }
    };


    const handleConfirm = async () => {
        setIsModalVisible(false);
        if (actionType === 'delete') {
            await handleConfirmDelete();
        } else if (actionType === 'AccountCardDelete') {
            await handleAccountCardDeleteOptions(itemIdToDelete)
        } else if (actionType === 'InactiveUser') {
            await handleStatusClientSave(false);
        }
        else if (actionType === 'closeMonth') {
            await CloseReportingMonth(true);
        } else if (actionType === 'openMonth') {
            await CloseReportingMonth(false);
        }
    };

    const getConfirmMessage = () => {
        switch (actionType) {
            case 'InactiveUser':
                return t('ConfirmInactiveUser');
            case 'closeMonth':
                return t('AreYouSureCloseMonth');
            case 'openMonth':
                return t('AreYouSureOpenMonth');
            default:
                return t('confirmDeleteMessage');

        }
    };

    const getTitleMessage = () => {
        switch (actionType) {

            case 'InactiveUser':
                return t('AreYouSureInactiveUser');
            case 'closeMonth':
                return t('ConfirmCloseMonth');
            case 'openMonth':
                return t('ConfirmOpenMonth');
            default:
                return t('confirmDeleteTitle');
        }
    };
    const handleAccountCardDeleteOptions = async (cardId) => {
        try {
            setLoading(true);
            let accountCardResponseOk = true;

            // Make the account card API call if fields are valid
            const response1 = await EnumsService.DeleteAccountCardsbyCaseId(client.caseId, cardId, token);
            accountCardResponseOk = response1.ok;
            if (!response1.ok) {
                const errorText = await response1.text();
                console.error(`Error deleting account card:`, errorText);
                toast.error(t('accountCardDeleteFailure', { errorText }));
            } else {
                toast.success(t('accountCardDeleteSuccess'));
            }

            // If the API call was successful, fetch enums
            if (accountCardResponseOk) {
                await fetchEnums(token, client, true);
            }

        } catch (error) {
            console.error(error);
        }
        setItemIdToDelete(null);

        setLoading(false);
    };



    const handleAccountCardEditOptions = async (oldCardId, cardId, oldName, name, AccountCaseId, PalCode) => {
        try {
            if (checkIfExistingAccountCard(AccountCardOptions, cardId, AccountCaseId, true)) {
                return;
            }
            setLoading(true);
            let AccountCardResponseOk = true;
            const response = await EnumsService.UpdateAccountCard(client.caseId, oldCardId, oldName, cardId, name, AccountCaseId, PalCode, token);
            AccountCardResponseOk = response.ok;
            if (!response.ok) {
                const errorText = await response.text();
                console.error(`Error updating account card:`, errorText);
                toast.error(t('accountCardEditFailure', { errorText }));
            } else {
                toast.success(t('accountCardEditSuccess'));
            }

            if (AccountCardResponseOk) {
                await fetchEnums(token, client, true);
            }
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };



    const formattedAccountCardOptions = AccountCardOptions?.map(option => ({
        value: option.cardId, // Assuming sortCodeId is the unique identifier
        label: `${option.cardId} - ${option.name}`,
        cardId: option.cardId,
        name: option.name,
        companyId: option.accountCaseId,
        palCode: option.palCode
    }));
    formattedAccountCardOptions.shift();


    // const handleRangeChange = () => {
    //     // Determine the appropriate start and end dates based on the range type


    //     // Fetch data based on the current state and configuration
    //     if (isBiMonthly && isRange) {
    //         const start = new Date(biStartDate);
    //         const end = new Date(biEndDate);
    //         fetchDataOnDateRangeChange(start, end);
    //     }
    //     else if (!isRange) {
    //         const start = new Date(startDate);
    //         const end = new Date(endDate);
    //         fetchDataOnDateRangeChange(start, end);
    //     } else {
    //         fetchDataOnDateRangeChange(date, date);
    //     }

    //     // Toggle the isRange state
    //     setIsRange(prevIsRange => !prevIsRange);

    //     // Update local storage
    //     localStorage.setItem('IsRange', JSON.stringify(!isRange));


    // };


    // Function to upload to the first API
    // ⬇️ Drop this next to handleHeshinDatUpload
    const uploadFileToAccountCardRevhit = async (file) => {
        // ─── 1. basic validation ───────────────────────────────────────────────
        if (!file) {
            toast.error(t("PleaseUploadFile"));
            return;
        }

        const ext = file.name.split(".").pop().toLowerCase();
        if (!["csv", "xlsx", "xls"].includes(ext)) {
            toast.error(
                t("Invalid file format: Revhit file must be .csv, .xlsx or .xls.")
            );
            return;
        }

        try {
            setLoading(true);

            /* 2. call the API – UploadAccountCardsFileDataRevhit
               ‣ we expect JSON like:
               {
                   processedCount: 12,
                   errorCount: 1,
                   errorMessages: ["Line 4: …"],
                   problematicCards: [
                       { lineNumber: 7, dto: { cardId: "123", name: "…" } },
                       …
                   ],
                   cardMapping: { "oldId": "newId", … }   // if you kept renaming
               }
            */
            const result = await ImportExportService.UploadAccountCardsFileDataRevhit(
                client.caseId,
                file,
                token
            );


            toast.success(t('RevhitFileUploadedSuccessfully', { processedCount: result.processedCount, errorCount: result.errorCount }));
            // ─── 3. show duplicate/problematic cards, if any ───────────────────
            if (result.problematicCards?.length) {
                setProblematicCards(result.problematicCards);
                setShowProblematicCardsModal(true);
            }

            // You can surface parsing/validation errors too:
            if (result.errorMessages?.length) {
                result.errorMessages.forEach((msg) => toast.error(msg));
            }

            // ─── 4. housekeeping ───────────────────────────────────────────────
            // setShowRevhitModal(false);     // assuming you have a modal for this
            // setRevhitFile(null);           // clear <input type="file" …/>
            await fetchEnums(token, client, true); // refresh dropdowns, etc.

        } catch (err) {
            console.error("Revhit upload error:", err);
            toast.error(t("ErrorUploadingFileTo"));
        } finally {
            setLoading(false);
        }
    };




    // Function to handle file selection
    const handleFileChange = (event, uploadFunction) => {
        const file = event.target.files[0];
        if (file) {
            uploadFunction(file); // Call the passed upload function with the selected file
        }
    };

    // Function to trigger the file input and specify the upload function
    const handleFileButtonClick = (fileInputRef, uploadFunction) => {
        // Reset the file input value
        fileInputRef.current.value = '';

        // Set up the onchange event handler
        fileInputRef.current.onchange = (event) => handleFileChange(event, uploadFunction);

        // Trigger the file input click
        fileInputRef.current.click();
    };

    //bimonth functions
    // const handleBiMonthDate = async (startDate, endDate, openVat = false, openWithHolding = false) => {
    //     setBiStartDate(startDate);
    //     setBiEndDate(endDate);
    //     localStorage.setItem('BiStartDate', startDate.toISOString());
    //     localStorage.setItem('BiEndDate', endDate.toISOString());
    //     await fetchDataOnDateRangeChange(startDate, endDate);
    //     // if (openVat) {
    //     //     

    //     //     handleOpenVatModal(false, startDate, endDate);
    //     // }
    //     // if (openWithHolding) {
    //     //     handleWithholdingTaxEdit(false, startDate, endDate);
    //     // }
    // }

    const handleActivateClient = async () => {
        // Implement the logic to activate the client here
        setOpenDialog(false);
        await handleStatusClientSave(true);
        localStorage.removeItem('dismissedDialog');
    };

    const handleCloseDialog = () => {
        // Save to localStorage to prevent showing the dialog on refresh
        localStorage.setItem('dismissedDialog', true);
        setOpenDialog(false);
    };

    const handleCloseDeleteDialog = () => {
        // Save to localStorage to prevent showing the dialog on refresh
        localStorage.setItem('dismissedDialog', true);
        setOpenDeleteDialog(false);
    };

    const handleDeletePermanently = () => {
        setIsModalVisible(true);
        setOpenDeleteDialog(false);
    };

    const handleInactiveUser = () => {

        setActionType("InactiveUser");
        setOpenDeleteDialog(false);
        setIsModalVisible(true);
    };

    const handleClickOpen856 = () => {
        setShow856Modal(true);
    }
    const handleClickUnifrom = () => {
        setShowUniformFileModal(true);
    }


    const {
        accountingItems,
        reportsItems,
        salesItems,
        vehicleItems,
        garageItems,
        auditItems,
        bankItems,
        documentsItems,
        settingsItems,
    } = useMenuItems({
        t,
        client,
        userTypeContext,
        permissionsState,
        Constants,
        parsedOtherDocuments,
        parsedPermanentFiles,
        parsedCustomTitles,
        viewAccountCardsTable,
        viewReceivables,
        viewReceivablesAging,
        viewCashFlowForecast,
        viewForeignTravelReport,
        viewClientExpenseAssignmentReport,
        viewDocumentDetails,
        viewPaymentAcceptanceDetails,
        viewJournalEntryDetails,
        viewAssets,
        viewProjects,
        viewProfitAndLossDetails,
        viewProfittAndLoss6111,
        viewReport1214,
        viewReport1214B,
        viewReport1281,
        viewReport1362,
        viewAnnualReportQuestionnaire,
        viewAnnualReport,
        viewLedgerReport,
        openReferenceSequenceModal,
        openReferencesModal,
        downloadWithholdingTaxReport,
        downloadPCNReport,
        downloadVATReport,
        openWithholdingTaxModel,
        openClientWithholdingTaxModel,
        handleClickOpen856,
        handleClickUnifrom,
        onManageMonthlyStatus: () => setShowMonthStatusModal(true),
        viewClientItems,
        viewInventoryItems,
        viewTransactionDocuments,
        viewDocumentCreate,
        viewBankTransactions,
        viewCardMatching,
        viewBankPage,
        viewOtherDocumentDetails,
        viewHoldingItems,
        viewClarificationDocuments,
        viewVehicleManagement,
        viewGarageWorkDiary,
        viewAudit,
        viewAuditReports,
        viewSignatureDocument,
        viewForms,
        viewAddClient,
        handleDownloadReceptionLog,
        // icons
        accountCardsDetailsIcon,
        incomesIcon,
        expensesIcon,
        paymentAcceptanceIcon,
        journalEntryIcon,
        projectIcon,
        assetIcon,
        sortCodeReportIcon,
        profitAndLossIcon,
        accountCardsTableIcon,
        referenceSequenceIcon,
        reportsIcon,
        advancesReportIcon,
        pcnFileIcon,
        vatReportIcon,
        InvoiceItemsIcon,
        transactionDocumentsIcon,
        bankIcon,
        cardMatchingIcon,
        bankPageIcon,
        otherDocumentIcon,
        holdingItemsIcon,
        auditIcon: auditAiIcon,

        // Navigation functions
        viewDocumentDetails,
        viewJournalEntryDetails,
        viewOtherDocumentDetails,
        viewClientItems,
        viewInventoryItems,
        viewPaymentAcceptanceDetails,
        viewProfitAndLossDetails,
        viewProfittAndLoss6111,
        viewReport1214,
        viewReport1214B,
        viewReport1281,
        viewReport1362,
        viewTransactionDocuments,
        viewLedgerReport,
        viewAccountCardsTable,
        viewBankTransactions,
        viewCollectionPage,
        viewAssignments,
        viewUserActivity,
        viewCardMatching,
        viewBankPage,
        viewAssets,
        viewProjects,
        viewDocumentCreate,
        viewHoldingItems,
        viewClarificationDocuments,
        viewTrackingList,
        viewAdvanceCalculator,
        viewAccountCardDashboardBAccountCard,

        hideStatusBadge,
        token,
        partners,
        subAccountantCaseRestrictions: subAccountantCaseRestrictions || []

    });

    const showVatPanelForTaxExemptClient = Boolean(
        client?.showVatPanelForTaxExempt ?? client?.ShowVatPanelForTaxExempt
    );

    // Remove VAT-related sales shortcuts for tax-exempt clients unless they opt in to VAT/advance UI.
    const filteredSalesItems = salesItems.filter(item => {
        if (Constants.TaxExemptTypes.includes(client?.caseType) && !showVatPanelForTaxExemptClient) {
            return item.label !== t('TaxInvoice') && item.label !== t('ReceiptTax') && item.label !== t('CreditNote') && item.label !== t('LawyerInvoice') && item.label !== t('LawyerReceipt');
        }
        return true;
    });



    const filteredReportsItems = reportsItems.filter(item => {
        const isClientWithoutPremium = userTypeContext?.toString() === Constants.UserType.Client && !permissionsState.Premium;
        if (isClientWithoutPremium) {
            return item.label !== t('ReportsForAuthority');
        }
        return true;
    });

    // For ManageOnly clients the Archive card surfaces only OtherDocuments, SignatureDocuments and Forms.
    const manageOnlyDocumentsItems = useMemo(
        () => (documentsItems || []).filter(item =>
            item.label !== t('PermanentFile')
        ),
        [documentsItems, t]
    );

    // For ManageOnly clients the Reports card surfaces only the annual report / 1301 questionnaire.
    const manageOnlyReportsItems = useMemo(() => {
        const fromMenu = (reportsItems || []).find(
            (item) => item.menuKey === MENU_ITEMS.AnnualReportQuestionnaire
        );
        if (fromMenu) return [fromMenu];
        return [{
            menuKey: MENU_ITEMS.AnnualReportQuestionnaire,
            label: t('AnnualReportQuestionnaire'),
            icon: profitAndLossIcon,
            onClick: () => viewAnnualReportQuestionnaire('AnnualReportQuestionnaire'),
            subItems: null,
        }];
    }, [reportsItems, t, viewAnnualReportQuestionnaire]);
    useEffect(() => {
        if (client && selectOtherDocumentsOptions && selectOtherDocumentsOptions.length > 0) {
            const { otherDocuments, permanentFiles, customTitles } = splitOtherDocumentTypes(selectOtherDocumentsOptions, otherDocumentsTitles);

            const toSubItem = (doc, isPermanent, title = null) => ({
                label: doc.name,
                icon: otherDocumentIcon,
                number: documentTypesCount[doc.name] || 0,
                onClick: () => viewOtherDocumentDetails("OtherDocuments", doc.name, isPermanent, title),
                subItems: null
            });

            setParsedOtherDocuments(otherDocuments.map((doc) => toSubItem(doc, false)));
            setParsedPermanentFiles(permanentFiles.map((doc) => toSubItem(doc, true)));
            setParsedCustomTitles(customTitles.map(({ title, types }) => ({
                label: title.name,
                onClick: () => viewOtherDocumentDetails("OtherDocuments", null, false, title),
                subItems: types.map((doc) => toSubItem(doc, false, title)),
            })));
        }
    }, [selectOtherDocumentsOptions, otherDocumentsTitles, documentTypesCount, client]);
    // ReportTracking
    const crmItems = [
        !permissionsState.ViewSubAccountantClients && !permissionsState.CantSeeCollectionPage && {
            label: t('Collections'),
            icon: collectionsIcon,
            onClick: () => viewCollectionPage('CollectionPage'),
            subItems: null
        },
        {
            label: t('Assignments'),
            icon: <AssignmentIcon sx={{ color: '#3c51ff' }} />,
            onClick: () => viewAssignments('Assignments'),
            subItems: null

        },
        ...(isAccountant
            ? [{
                label: t('UserActivities'),
                icon: <ListAltIcon sx={{ color: '#3c51ff' }} />,
                onClick: () => viewUserActivity('UserActivities'),
                subItems: null,
            }]
            : []),
        {
            label: t('TrackingList'),
            icon: TrackingList,
            onClick: () => viewTrackingList('TrackingList'),
            subItems: null

        },
        !permissionsState.ViewSubAccountantClients && !isClient && {
            label: t('ReportingFollowUp'),
            icon: <FactCheckIcon sx={{ color: '#3c51ff' }} />,
            onClick: () => setOpenReportingFollowUp(true),
            subItems: null,
        },
        // {
        //     label: t('AdvanceDynamicCalculator'),
        //     icon: <CalculateIcon sx={{ color: '#3c51ff' }} />,
        //     onClick: () => viewAdvanceCalculator('AdvanceDynamicCalculator'),
        //     subItems: null,
        // },


    ].filter(Boolean);


    const handleOpenPostponedChecks = () => {
        setShowPostponedChecks(true);
    };
    const handleClosePostponedChecks = () => {
        setShowPostponedChecks(false);
    };



    const handleDownloadWithholdingReportReport = async (showZeroBalance = false, supplierNameFilter = '', useCreditAccount = false) => {
        if (withHoldingTaxType == '') {
            return
        }
        setLoading(true);
        // setWithHoldingTaxModalOpen(false);
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            switch (withHoldingTaxType) {
                case 'yearlyCertificate':
                    await ReportsService.getSupplierWithholdingTaxCertificate(
                        client.caseId,
                        start,
                        client.accountantId,
                        selectedAccountCard?.value,
                        token,
                        false,
                        showZeroBalance,
                        useCreditAccount
                    );
                    break;

                case 'yearlyReport':
                    await ReportsService.getSupplierWithholdingTaxSummaryYearly(
                        client.caseId,
                        start,
                        client.accountantId,
                        token,
                        false, // showMode = false for PDF
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                case 'monthlyReport':
                    await ReportsService.getSupplierWithholdingTaxSummary(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        false, // showMode = false for PDF
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                case 'monthlyPeriodReport':
                    await ReportsService.getSupplierWithholdingTaxSummaryMonthlyPeriod(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        false, // showMode = false for PDF
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                default:
                    console.warn('Invalid withholding tax type');
                    break;
            }
        } catch (error) {
            console.error(error);
            toast.error(t('reportDownloadFailure'));
        }
        setLoading(false);
    };

    const handleShowWithholdingReportReport = async (showZeroBalance = false, supplierNameFilter = '', useCreditAccount = false) => {
        if (withHoldingTaxType == '') {
            return '';
        }
        
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            let html = '';
            switch (withHoldingTaxType) {
                case 'yearlyCertificate':
                    html = await ReportsService.getSupplierWithholdingTaxCertificate(
                        client.caseId,
                        start,
                        client.accountantId,
                        selectedAccountCard?.value,
                        token,
                        true, // showMode = true
                        showZeroBalance,
                        useCreditAccount
                    );
                    break;

                case 'yearlyReport':
                    html = await ReportsService.getSupplierWithholdingTaxSummaryYearly(
                        client.caseId,
                        start,
                        client.accountantId,
                        token,
                        true, // showMode = true
                        showZeroBalance, // showZeroBalance parameter
                        supplierNameFilter, // supplierNameFilter parameter
                        useCreditAccount
                    );
                    break;

                case 'monthlyReport':
                    html = await ReportsService.getSupplierWithholdingTaxSummary(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        true, // showMode = true
                        showZeroBalance, // showZeroBalance parameter
                        supplierNameFilter, // supplierNameFilter parameter
                        useCreditAccount
                    );
                    break;

                case 'monthlyPeriodReport':
                    html = await ReportsService.getSupplierWithholdingTaxSummaryMonthlyPeriod(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        true, // showMode = true
                        showZeroBalance, // showZeroBalance parameter
                        supplierNameFilter, // supplierNameFilter parameter
                        useCreditAccount
                    );
                    break;

                default:
                    console.warn('Invalid withholding tax type');
                    break;
            }
            return html;
        } catch (error) {
            console.error(error);
            toast.error(t('reportShowFailure'));
            throw error;
        }
    };



    const setWithholdingTaxTypeFunc = (type) => {
        setWithHoldingTaxType(type);
        if (type === 'monthlyReport' || type === 'monthlyPeriodReport') {
            setIsDateRange(true);
        }
        else {
            setIsDateRange(false);
        }
    }

    const closeWithHoldingTaxModal = () => {
        setWithHoldingTaxModalOpen(false);
        setSelectedReportType('');
    };

    const handleDownloadClientWithholdingReportReport = async (showZeroBalance = true) => {
        if (withHoldingTaxType == '') {
            return
        }
        setLoading(true);
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
             if (withHoldingTaxType === 'yearlyReport') {
                const result = await MySwal.fire({
                    title: t('IncludeComparisonInReport'),
                    text: t('IncludeComparisonInReport'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: t('Yes'),
                    cancelButtonText: t('No'),
                    customClass: { container: 'swal-high-zindex' },
                });
                
                const showReportingColumns = result.isConfirmed ? true : false;
                
                await ReportsService.getClientWithholdingTaxSummaryYearly(
                    client.caseId,
                    start,
                    client.accountantId,
                    token,
                    false,
                    showZeroBalance,
                    showReportingColumns // ✅ Dynamic based on user choice
                );
            } else if (withHoldingTaxType === 'monthlyReport') {
                await ReportsService.getClientWithholdingTaxSummary(
                    client.caseId,
                    start,
                    end,
                    client.accountantId,
                    token,
                    false,
                    showZeroBalance
                );
            } else if (withHoldingTaxType === 'monthlyPeriodReport') {
                await ReportsService.getClientWithholdingTaxSummaryMonthlyPeriod(
                    client.caseId,
                    start,
                    end,
                    client.accountantId,
                    token,
                    false,
                    showZeroBalance
                );
            }
            toast.success(t('reportDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading client withholding report:', error);
            toast.error(t('reportDownloadFailure'));
        }
        setLoading(false);
    };

    const handleDownloadClientWithholdingExcelReport = async (showZeroBalance = true) => {
        if (withHoldingTaxType == '') {
            return;
        }
        setLoading(true);
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            let reportType;
            if (withHoldingTaxType === 'yearlyReport') {
                reportType = 'yearly';
            } else if (withHoldingTaxType === 'monthlyReport') {
                reportType = 'monthly';
            } else if (withHoldingTaxType === 'monthlyPeriodReport') {
                reportType = 'monthlyperiod';
            }

            await ReportsService.getClientWithholdingTaxSummaryExcel(
                client.caseId,
                start,
                end,
                client.accountantId,
                token,
                reportType,
                showZeroBalance
            );
            toast.success(t('reportDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading client withholding Excel report:', error);
            toast.error(t('reportDownloadFailure'));
        }
        setLoading(false);
    };

    const handleShowClientWithholdingReportReport = async (showZeroBalance = true) => {
        if (withHoldingTaxType == '') {
            return '';
        }
        
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }
        

        try {
            if (withHoldingTaxType === 'yearlyReport') {
                return await ReportsService.getClientWithholdingTaxSummaryYearly(
                    client.caseId,
                    start,
                    client.accountantId,
                    token,
                    true,
                    showZeroBalance
                );
            } else if (withHoldingTaxType === 'monthlyReport') {
                return await ReportsService.getClientWithholdingTaxSummary(
                    client.caseId,
                    start,
                    end,
                    client.accountantId,
                    token,
                    true,
                    showZeroBalance
                );
            } else if (withHoldingTaxType === 'monthlyPeriodReport') {
                return await ReportsService.getClientWithholdingTaxSummaryMonthlyPeriod(
                    client.caseId,
                    start,
                    end,
                    client.accountantId,
                    token,
                    true,
                    showZeroBalance
                );
            }
        } catch (error) {
            console.error('Error showing client withholding report:', error);
            toast.error(t('reportShowFailure'));
            return '';
        }
    };

    const closeClientWithHoldingTaxModal = () => {
        setClientWithHoldingTaxModalOpen(false);
        setSelectedReportType('');
    };



    const handleHeshinPrmDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            if (file.name.toLowerCase().endsWith('.prm')) {
                setHeshinPrmFile(file);
                toast.success(`heshin.prm ${t('FileSelected')}`);
            } else {
                toast.error(t("InvalidFilePrmType"));
            }
        }
    };

    const handleHeshinDatDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            if (file.name.toLowerCase().endsWith('.dat')) {
                setHeshinDatFile(file);
                toast.success(`heshin.dat ${t('FileSelected')}`);
            } else {
                toast.error(t("InvalidFileDatType"));
            }
        }
    };


    const handleMoveInDatDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            if (file.name.toLowerCase().endsWith('.dat')) {
                setMoveInDatFile(file);
                toast.success(`movein.dat ${t('FileSelected')}`);
            } else {
                toast.error(t("InvalidFileDatType"));
            }
        }
    };

    const handlRivhitPKUDADrop = (acceptedFiles) => {
        console.warn('handlRivhitPKUDADrop is deprecated.', acceptedFiles);
    };




    const handleHeshinDatUpload = async () => {
        if (!heshinPrmFile || !heshinDatFile) {
            toast.error("PleaseUploadBothHeshinFiles");
            return;
        }

        // Validate file extensions
        if (!heshinPrmFile.name.toLowerCase().endsWith(".prm")) {
            toast.error(t("Invalid file format: heshin.prm file must have a .prm extension."));
            return;
        }
        if (!heshinDatFile.name.toLowerCase().endsWith(".dat")) {
            toast.error(t("Invalid file format: heshin.dat file must have a .dat extension."));
            return;
        }

        try {
            setLoading(true);
            const result = await ImportExportService.ImportAccountCardsHeshinDat(
                client.caseId,
                heshinPrmFile,
                heshinDatFile,
                token
            );

            // Example result shape:
            // {
            //   processedCount: 3,
            //   errorCount: 1,
            //   message: "Import successful.",
            //   problematicCards: [ { lineNumber: 3, dto: {...} }, {...} ]
            // }

            toast.success(t('HeshinFilesUploadedSuccessfully', { processedCount: result.processedCount, errorCount: result.errorCount }));

            // Check if there are problematic cards
            if (result.problematicCards && result.problematicCards.length > 0) {
                setProblematicCards(result.problematicCards);
                setShowProblematicCardsModal(true);
            }

            // Close the HeshinDat modal (the one for uploading files)
            setShowHeshinDatModal(false);

            // Optionally reset the files
            setHeshinPrmFile(null);
            setHeshinDatFile(null);

            // Refresh your data if needed
            await fetchEnums(token, client, true);

        } catch (error) {
            console.error("Error uploading Heshin files:", error.message);
            toast.error("ErrorUploadingHeshinFiles");
        } finally {
            setLoading(false);
        }
    };


    const handleMoveInDatUpload = async () => {
        if (!moveInDatFile) {
            toast.error(t("PleaseUploadMoveinDatFile"));
            return;
        }

        try {
            setLoading(true);

            // Call the service function
            const response = await ImportExportService.ImportTransactionReportMovinDat(client.caseId, moveInDatFile, token, moveInDatAmountDivisor);

            // Assuming the response is successful
            setShowJEImportModal(false); // Close the modal
            setMoveInDatFile(null); // Reset the file

            if (response.ok) {
                toast.success(t("FileUploadedSuccessfullyToJournalEntries"));

            } else {
                toast.error(t('ErrorUploadingMoveinDatFile'));

            }
        } catch (error) {
            console.error("Error uploading movein.dat file:", error.message);
            toast.error(t('ErrorUploadingMoveinDatFile'));
        } finally {
            setLoading(false);
        }
    };


    const handleRivhitPKUDADatUpload = async () => {
        console.warn('handleRivhitPKUDADatUpload is deprecated.');
    };

    const handleSelectActionType = (index, actionType) => {
        // e.g. user picks 0=CreateNewCard or 1=UpdateExternalSoftwareCardNumber
        const updated = [...problematicActions];
        updated[index] = {
            ...updated[index],
            actionType,
        };
        setProblematicActions(updated);
    };

    const handleSelectExistingCard = (index, cardIdToReplace) => {
        // if user picks an existing card
        const updated = [...problematicActions];
        updated[index] = {
            ...updated[index],
            cardIdToReplace,
        };
        setProblematicActions(updated);
    };

    const importMdbAccountCards = async (file /* : File */) => {
        if (!file) return;
        try {
            setLoading(true);

            const res = await ImportExportService.ImportMdbAccountCards(
                client.caseId,
                file,
                token
            );

            toast.success(
                t('MdbCardsUploadedSuccessfully', {
                    processedCount: res.processedCount ?? res[0],
                    errorCount: res.errorCount ?? res[1]
                })
            );

            if (res.problematicCards?.length) {
                setProblematicCards(res.problematicCards);
                setShowProblematicCardsModal(true);
            }

            /* refresh drop‑downs etc. */
            await fetchEnums(token, client, true);

            return res;                            // let the caller know we're done
        } catch (err) {
            console.error(err);
            toast.error(t('ErrorUploadingMdbCards'));
            throw err;
        } finally {
            setLoading(false);
        }
    };


    /** Preview MDB journal entries with sortcode validation */
    const previewMdbJournal = useCallback(async (file, sortCodeFile, options = {}) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewMdbJournalEntries(
                client.caseId,
                client.accountantId,
                file,
                sortCodeFile,
                token,
                options
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('MDB journal preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit MDB journal entries (after sortcodes created) */
    const commitMdbJournal = useCallback(async (file, sortCodeFile, defaultSortCodeNameForEmpty, skipDuplicates = true, options = {}) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportMdbJournalEntries(
                client.caseId,
                file,
                sortCodeFile,
                defaultSortCodeNameForEmpty,
                skipDuplicates,
                token,
                options
            );

            // Show success with details
            const processedCount = res.processedCount ?? res[0] ?? 0;
            const errorCount = res.errorCount ?? res[1] ?? 0;
            const errorMessages = res.errorMessages ?? res[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                // Show errors in console and toast
                console.error('MDB import errors:', errorMessages);
                toast.warning(
                    t('MdbJournalUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} entries with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('MdbJournalUploadedSuccessfully', {
                        processedCount,
                        errorCount
                    })
                );
            }
            
            /* anything changed? → refresh */
            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('MDB journal upload error:', err);
            toast.error(t('MdbJournalUploadFailed'));
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Preview Excel journal entries with sortcode validation */
    const previewExcelJournal = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewExcelJournalEntries(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Excel journal preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Excel journal entries (after sortcodes created) */
    const commitExcelJournal = useCallback(async (file, defaultSortCodeNameForEmpty) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportExcelJournalEntries(
                client.caseId,
                file,
                defaultSortCodeNameForEmpty,
                token
            );

            const processedCount = res.processedCount ?? res[0] ?? 0;
            const errorCount = res.errorCount ?? res[1] ?? 0;
            const errorMessages = res.errorMessages ?? res[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Excel import errors:', errorMessages);
                toast.warning(
                    t('ExcelJournalUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} entries with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('ExcelJournalUploadedSuccessfully', {
                        processedCount,
                        errorCount
                    }) || `Successfully imported ${processedCount} journal entries.`
                );
            }
            
            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Excel journal upload error:', err);
            toast.error(t('ExcelJournalUploadFailed') || 'Excel journal import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Preview Excel account cards */
    const previewExcelAccountCards = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewExcelAccountCards(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Excel account cards preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Excel account cards */
    const commitExcelAccountCards = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportExcelAccountCards(
                client.caseId,
                file,
                token
            );

            const processedCount = res.processedCount ?? res[0] ?? 0;
            const errorCount = res.errorCount ?? res[1] ?? 0;
            const errorMessages = res.errorMessages ?? res[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Excel account cards import errors:', errorMessages);
                toast.warning(
                    t('ExcelAccountCardsUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} cards with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('ExcelAccountCardsUploadedSuccessfully', {
                        processedCount,
                        errorCount
                    }) || `Successfully imported ${processedCount} account cards.`
                );
            }
            
            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Excel account cards upload error:', err);
            toast.error(t('ExcelAccountCardsUploadFailed') || 'Excel account cards import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // RIVHIT CSV V2 IMPORT FUNCTIONS (Dynamic Header Reading)
    // ═══════════════════════════════════════════════════════════════════════════════

    /** Preview Rivhit CSV V2 */
    const previewRivhitCsvV2 = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewRivhitCsvV2(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Rivhit CSV V2 preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Rivhit CSV V2 */
    const commitRivhitCsvV2 = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportRivhitCsvV2(
                client.caseId,
                file,
                token
            );

            const processedCount = res.processedCount ?? 0;
            const errorCount = res.errorCount ?? 0;
            const errorMessages = res.errorMessages ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Rivhit CSV V2 import errors:', errorMessages);
                toast.warning(
                    `${t('ImportedWithErrors') || 'Imported'} ${processedCount} ${t('cards')} ${t('with')} ${errorCount} ${t('errors')}. ${t('CheckConsole')}`
                );
            } else {
                toast.success(
                    `${t('SuccessfullyImported') || 'Successfully imported'} ${processedCount} ${t('accountCards')}.`
                );
            }
            
            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Rivhit CSV V2 upload error:', err);
            toast.error(t('RivhitCsvUploadFailed') || 'Rivhit CSV import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // ACCOUNT INDEX IMPORT FUNCTIONS (רבגונית / ניהולית - אינדקס חשבונות Excel)
    // ═══════════════════════════════════════════════════════════════════════════════

    const previewAccountIndex = useCallback(async (previewFn, file) => {
        if (!file || !client) return;

        try {
            const res = await previewFn(client.caseId, client.accountantId, file, token);
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Account index preview failed:', err);
            toast.error(err?.message || t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitAccountIndex = useCallback(async (importFn, file) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await importFn(client.caseId, client.accountantId, file, token);

            const processedCount = res?.processedCount ?? 0;
            const renumberedCount = res?.renumberedCount ?? 0;
            const skippedCount = res?.skippedCount ?? 0;
            const errorCount = res?.errorCount ?? 0;
            const errorMessages = res?.errorMessages ?? [];

            if (errorCount > 0) {
                console.error('Account index import errors:', errorMessages);
                toast.warning(t('AccountIndexImportedWithErrors', { processedCount, errorCount })
                    || `יובאו ${processedCount} כרטיסים עם ${errorCount} שגיאות.`);
            } else {
                toast.success(t('AccountIndexImportedSuccessfully', { processedCount, renumberedCount, skippedCount })
                    || `יובאו ${processedCount} כרטיסי חשבון (${renumberedCount} במזהה חדש, ${skippedCount} קיימים כבר).`);
            }

            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Account index import error:', err);
            toast.error(err?.message || t('AccountIndexImportFailed') || 'ייבוא אינדקס חשבונות נכשל');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    const previewRavginitAccountIndex = useCallback(
        (file) => previewAccountIndex(ImportExportService.PreviewRavginitAccountIndex, file),
        [previewAccountIndex]);

    const commitRavginitAccountIndex = useCallback(
        (file) => commitAccountIndex(ImportExportService.ImportRavginitAccountIndex, file),
        [commitAccountIndex]);

    const previewNihulitAccountIndex = useCallback(
        (file) => previewAccountIndex(ImportExportService.PreviewNihulitAccountIndex, file),
        [previewAccountIndex]);

    const commitNihulitAccountIndex = useCallback(
        (file) => commitAccountIndex(ImportExportService.ImportNihulitAccountIndex, file),
        [commitAccountIndex]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // RIVHIT CLOSING BALANCE IMPORT FUNCTIONS
    // ═══════════════════════════════════════════════════════════════════════════════

    const previewRivhitClosingBalance = useCallback(async (trialBalanceFile, palCodeFile, year) => {
        if (!trialBalanceFile || !palCodeFile || !client) return;

        try {
            const res = await ImportExportService.PreviewRivhitClosingBalance(
                client.caseId,
                client.accountantId,
                trialBalanceFile,
                palCodeFile,
                year,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Rivhit closing balance preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitRivhitClosingBalance = useCallback(async (trialBalanceFile, palCodeFile, year) => {
        if (!trialBalanceFile || !palCodeFile || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportRivhitClosingBalance(
                client.caseId,
                client.accountantId,
                trialBalanceFile,
                palCodeFile,
                year,
                token
            );

            const processedCount = res.processedCount ?? 0;
            const errorCount = res.errorCount ?? 0;
            const errorMessages = res.errorMessages ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Rivhit closing balance import errors:', errorMessages);
                toast.warning(
                    `ייובאו ${processedCount} פקודות יומן עם ${errorCount} שגיאות.`
                );
            } else {
                toast.success(
                    `ייובאו ${processedCount} פקודות יומן בהצלחה.`
                );
            }

            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Rivhit closing balance import error:', err);
            toast.error('ייבוא יתרת סגירה ריוחית נכשל');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // RAMPLUS IMPORT FUNCTIONS
    // ═══════════════════════════════════════════════════════════════════════════════

    const previewRamplusAccountCards = useCallback(async (cardsFile, accountsFile) => {
        if (!cardsFile || !client) return;
        try {
            const res = await ImportExportService.PreviewRamplusAccountCards(
                client.caseId, client.accountantId, cardsFile, accountsFile, token
            );
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Ramplus account cards preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitRamplusAccountCards = useCallback(async (cardsFile, accountsFile) => {
        if (!cardsFile || !client) return;
        try {
            setLoading(true);
            const res = await ImportExportService.ImportRamplusAccountCards(
                client.caseId, client.accountantId, cardsFile, accountsFile, token
            );
            const processedCount = res.processedCount ?? 0;
            const errorCount = res.errorCount ?? 0;
            if (errorCount > 0) {
                toast.warning(t('RamplusAccountCardsUploadedWithErrors', { processedCount, errorCount })
                    || `ייובאו ${processedCount} כרטיסים עם ${errorCount} שגיאות.`);
            } else {
                toast.success(t('RamplusAccountCardsUploadedSuccessfully', { processedCount })
                    || `ייובאו ${processedCount} כרטיסי חשבון בהצלחה.`);
            }
            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Ramplus account cards import error:', err);
            toast.error(t('RamplusAccountCardsUploadFailed') || 'ייבוא כרטיסי חשבון רם פלוס נכשל');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    const previewRamplusJournal = useCallback(async (journalFile, sortCodeFile, cardsFile = null, options = {}) => {
        if (!journalFile || !sortCodeFile || !client) return;
        try {
            const res = await ImportExportService.PreviewRamplusJournal(
                client.caseId, client.accountantId, journalFile, sortCodeFile, token, cardsFile, options
            );
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Ramplus journal preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitRamplusJournal = useCallback(async (journalFile, sortCodeFile, skipDuplicates = true, cardsFile = null, options = {}) => {
        if (!journalFile || !sortCodeFile || !client) return;
        try {
            setLoading(true);
            const res = await ImportExportService.ImportRamplusJournal(
                client.caseId, client.accountantId, journalFile, sortCodeFile, skipDuplicates, token, cardsFile, options
            );
            const processedCount = res.processedCount ?? 0;
            const errorCount = res.errorCount ?? 0;
            if (errorCount > 0) {
                toast.warning(`ייובאו ${processedCount} פקודות יומן עם ${errorCount} שגיאות.`);
            } else {
                toast.success(`ייובאו ${processedCount} פקודות יומן בהצלחה.`);
            }
            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Ramplus journal import error:', err);
            toast.error(err?.message || 'ייבוא פקודות יומן רם פלוס נכשל');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    const previewRamplusClosingBalance = useCallback(async (balanceFile, year) => {
        if (!balanceFile || !client) return;
        try {
            const res = await ImportExportService.PreviewRamplusClosingBalance(
                client.caseId, client.accountantId, balanceFile, year, token
            );
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Ramplus closing balance preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitRamplusClosingBalance = useCallback(async (balanceFile, year) => {
        if (!balanceFile || !client) return;
        try {
            setLoading(true);
            const res = await ImportExportService.ImportRamplusClosingBalance(
                client.caseId, client.accountantId, balanceFile, year, token
            );
            const processedCount = res.processedCount ?? 0;
            const errorCount = res.errorCount ?? 0;
            if (errorCount > 0) {
                toast.warning(`ייובאו ${processedCount} פקודות יומן עם ${errorCount} שגיאות.`);
            } else {
                toast.success(`ייובאו ${processedCount} פקודות יומן בהצלחה.`);
            }
            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Ramplus closing balance import error:', err);
            toast.error('ייבוא יתרת סגירה רם פלוס נכשל');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    const previewSumitClosingBalance = useCallback(async (balanceFile, year, profitLossFile = null) => {
        if (!balanceFile || !client) return;

        try {
            const res = await ImportExportService.PreviewSumitClosingBalance(
                client.caseId,
                client.accountantId,
                balanceFile,
                year,
                token,
                profitLossFile
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Sumit closing balance preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitSumitClosingBalance = useCallback(async (balanceFile, year, profitLossFile = null) => {
        if (!balanceFile || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportSumitClosingBalance(
                client.caseId,
                client.accountantId,
                balanceFile,
                year,
                token,
                profitLossFile
            );

            const processedCount = res.processedCount ?? 0;
            const errorCount = res.errorCount ?? 0;
            const errorMessages = res.errorMessages ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Sumit closing balance import errors:', errorMessages);
                toast.warning(
                    `ייובאו ${processedCount} פקודות יומן עם ${errorCount} שגיאות.`
                );
            } else {
                toast.success(
                    `ייובאו ${processedCount} פקודות יומן בהצלחה.`
                );
            }

            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Sumit closing balance import error:', err);
            toast.error('ייבוא יתרת סגירה Sumit נכשל');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    const previewFinbotClosingBalance = useCallback(async (balanceFile, year) => {
        if (!balanceFile || !client) return;

        try {
            const res = await ImportExportService.PreviewFinbotClosingBalance(
                client.caseId,
                client.accountantId,
                balanceFile,
                year,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Finbot closing balance preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitFinbotClosingBalance = useCallback(async (balanceFile, year) => {
        if (!balanceFile || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportFinbotClosingBalance(
                client.caseId,
                client.accountantId,
                balanceFile,
                year,
                token
            );

            const processedCount = res.processedCount ?? 0;
            const errorCount = res.errorCount ?? 0;
            const errorMessages = res.errorMessages ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Finbot closing balance import errors:', errorMessages);
                toast.warning(
                    `ייובאו ${processedCount} פקודות יומן עם ${errorCount} שגיאות.`
                );
            } else {
                toast.success(
                    `ייובאו ${processedCount} פקודות יומן בהצלחה.`
                );
            }

            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Finbot closing balance import error:', err);
            toast.error('ייבוא יתרת סגירה Finbot נכשל');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // SUMIT IMPORT FUNCTIONS
    // ═══════════════════════════════════════════════════════════════════════════════

    /** Preview Sumit account cards */
    const previewSumitAccountCards = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewSumitAccountCards(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Sumit account cards preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Sumit account cards */
    const commitSumitAccountCards = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportSumitAccountCards(
                client.caseId,
                file,
                token
            );

            const processedCount = res.processedCount ?? res[0] ?? 0;
            const errorCount = res.errorCount ?? res[1] ?? 0;
            const errorMessages = res.errorMessages ?? res[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Sumit account cards import errors:', errorMessages);
                toast.warning(
                    t('SumitAccountCardsUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} cards with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('SumitAccountCardsUploadedSuccessfully', {
                        processedCount
                    }) || `Successfully imported ${processedCount} account cards from Sumit.`
                );
            }
            
            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Sumit account cards upload error:', err);
            toast.error(t('SumitAccountCardsUploadFailed') || 'Sumit account cards import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Preview Sumit journal entries */
    const previewSumitJournal = useCallback(async (journalFile, transactionTypesFile) => {
        if (!journalFile || !client) return;

        try {
            const res = await ImportExportService.PreviewSumitJournal(
                client.caseId,
                client.accountantId,
                journalFile,
                transactionTypesFile,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Sumit journal preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Sumit journal entries */
    const commitSumitJournal = useCallback(async (journalFile, transactionTypesFile) => {
        if (!journalFile || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportSumitJournal(
                client.caseId,
                journalFile,
                transactionTypesFile,
                token
            );

            // Handle both object and array response formats
            const processedCount = res?.processedCount ?? res?.item1 ?? res?.[0] ?? 0;
            const errorCount = res?.errorCount ?? res?.item2 ?? res?.[1] ?? 0;
            const errorMessages = res?.errorMessages ?? res?.item3 ?? res?.[2] ?? [];

            toast.success(t('SumitJournalUploadedSuccessfully')) 
            // if (errorCount > 0) {
            //     console.error('Sumit journal import errors:', errorMessages);
            //     toast.error(
            //         errorMessages[0] || t('SumitJournalUploadFailed')
            //     );
            //     // Return error response to keep modal open
            //     return { errorCount, errorMessages };
            // } else if (processedCount > 0) {
            //     toast.success(
            //         t('SumitJournalUploadedSuccessfully', {
            //             processedCount
            //         }) || `Successfully imported ${processedCount} journal entries from Sumit.`
            //     );
            //     await fetchEnums(token, client, true);
            // } else {
            //     // processedCount = 0, errorCount = 0
            //     // This means all entries were duplicates (already exist)
            //     toast.info(t('AllEntriesAlreadyExist') || 'כל הרשומות כבר קיימות במערכת - לא נדרש ייבוא');
            // }
            
            return res;
        } catch (err) {
            console.error('Sumit journal import error:', err);
            toast.error(t('SumitJournalUploadFailed') || 'Sumit journal import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // FINBOT IMPORT FUNCTIONS
    // ═══════════════════════════════════════════════════════════════════════════════

    /** Preview Finbot account cards */
    const previewFinbotAccountCards = useCallback(async (file, templateVersion = 1) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewFinbotAccountCards(
                client.caseId,
                client.accountantId,
                file,
                token,
                templateVersion
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Finbot account cards preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Finbot account cards */
    const commitFinbotAccountCards = useCallback(async (file, templateVersion = 1) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportFinbotAccountCards(
                client.caseId,
                file,
                token,
                templateVersion
            );

            const processedCount = res.processedCount ?? res[0] ?? 0;
            const errorCount = res.errorCount ?? res[1] ?? 0;
            const errorMessages = res.errorMessages ?? res[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Finbot account cards import errors:', errorMessages);
                toast.warning(
                    t('FinbotAccountCardsUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} cards with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('FinbotAccountCardsUploadedSuccessfully', {
                        processedCount
                    }) || `Successfully imported ${processedCount} account cards from Finbot.`
                );
            }

            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Finbot account cards upload error:', err);
            toast.error(t('FinbotAccountCardsUploadFailed') || 'Finbot account cards import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Preview Finbot journal entries */
    const previewFinbotJournal = useCallback(async (journalFile) => {
        if (!journalFile || !client) return;

        try {
            const res = await ImportExportService.PreviewFinbotJournal(
                client.caseId,
                client.accountantId,
                journalFile,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Finbot journal preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Finbot journal entries */
    const commitFinbotJournal = useCallback(async (journalFile, isTempJournal = false) => {
        if (!journalFile || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportFinbotJournal(
                client.caseId,
                journalFile,
                token,
                isTempJournal
            );

            toast.success(t('FinbotJournalUploadedSuccessfully') || t('SumitJournalUploadedSuccessfully'));

            return res;
        } catch (err) {
            console.error('Finbot journal import error:', err);
            toast.error(t('FinbotJournalUploadFailed') || 'Finbot journal import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** List Finbot clients/accounts for the import client picker */
    const fetchFinbotClients = useCallback(async (apiParams) => {
        try {
            return await ImportExportService.GetFinbotClients(apiParams, token);
        } catch (err) {
            console.error('Finbot clients listing failed:', err);
            toast.error(t('FinbotClientsLoadFailed') || 'Failed to load Finbot clients');
            throw err;
        }
    }, [token, t]);

    /** Preview Finbot journal entries fetched directly from the Finbot API */
    const previewFinbotJournalApi = useCallback(async (apiParams) => {
        if (!client) return;

        try {
            const res = await ImportExportService.PreviewFinbotJournalApi(
                { caseId: client.caseId, accountantId: client.accountantId, ...apiParams },
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Finbot journal API preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Finbot journal entries fetched directly from the Finbot API */
    const commitFinbotJournalApi = useCallback(async (apiParams) => {
        if (!client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportFinbotJournalApi(
                { caseId: client.caseId, ...apiParams },
                token
            );

            toast.success(t('FinbotJournalUploadedSuccessfully') || t('SumitJournalUploadedSuccessfully'));

            return res;
        } catch (err) {
            console.error('Finbot journal API import error:', err);
            toast.error(t('FinbotJournalUploadFailed') || 'Finbot journal import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t]);

    /** Preview Finbot account cards fetched directly from the Finbot API */
    const previewFinbotAccountCardsApi = useCallback(async (apiParams) => {
        if (!client) return;

        try {
            const res = await ImportExportService.PreviewFinbotAccountCardsApi(
                { caseId: client.caseId, accountantId: client.accountantId, ...apiParams },
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Finbot account cards API preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Finbot account cards fetched directly from the Finbot API */
    const commitFinbotAccountCardsApi = useCallback(async (apiParams) => {
        if (!client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportFinbotAccountCardsApi(
                { caseId: client.caseId, ...apiParams },
                token
            );

            const processedCount = res.processedCount ?? res[0] ?? 0;
            const errorCount = res.errorCount ?? res[1] ?? 0;
            const errorMessages = res.errorMessages ?? res[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Finbot account cards API import errors:', errorMessages);
                toast.warning(
                    t('FinbotAccountCardsUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} cards with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('FinbotAccountCardsUploadedSuccessfully', {
                        processedCount
                    }) || `Successfully imported ${processedCount} account cards from Finbot.`
                );
            }

            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Finbot account cards API upload error:', err);
            toast.error(t('FinbotAccountCardsUploadFailed') || 'Finbot account cards import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // PAPERLESS IMPORT FUNCTIONS
    //
    // Paperless models a period as one flat document set carrying both the counterparty and the
    // sort-code tag, so a single preview/import covers account cards and journal entries together.
    // ═══════════════════════════════════════════════════════════════════════════════

    /** List the accountant's Paperless businesses for the import picker */
    const fetchPaperlessUsers = useCallback(async (apiParams) => {
        try {
            return await ImportExportService.GetPaperlessUsers(apiParams, token);
        } catch (err) {
            console.error('Paperless businesses listing failed:', err);
            toast.error(t('PaperlessBusinessesLoadFailed') || 'Failed to load Paperless businesses');
            throw err;
        }
    }, [token, t]);

    /** Preview the account cards and journal entries a Paperless business would produce */
    const previewPaperlessApi = useCallback(async (apiParams) => {
        if (!client) return;

        try {
            const res = await ImportExportService.PreviewPaperlessApi(
                { caseId: client.caseId, accountantId: client.accountantId, ...apiParams },
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Paperless API preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Import the account cards and journal entries for a Paperless business */
    const commitPaperlessApi = useCallback(async (apiParams) => {
        if (!client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportPaperlessApi(
                { caseId: client.caseId, accountantId: client.accountantId, ...apiParams },
                token
            );

            const processedCount = res?.processedCount ?? 0;
            const cardCount = res?.cardCount ?? 0;
            const errorCount = res?.errorCount ?? 0;
            const errorMessages = res?.errorMessages ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Paperless API import errors:', errorMessages);
                toast.warning(
                    t('PaperlessImportedWithErrors', { processedCount, cardCount, errorCount, firstError: errorMessages[0] })
                    || `Imported ${processedCount} entries and ${cardCount} cards with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('PaperlessImportedSuccessfully', { processedCount, cardCount })
                    || `Successfully imported ${processedCount} journal entries and ${cardCount} account cards from Paperless.`
                );
            }

            // Refresh the enums so the newly created cards and sort codes are selectable.
            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Paperless API import error:', err);
            toast.error(t('PaperlessImportFailed') || 'Paperless import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // RAVGINIT (RAVGONIT .26) IMPORT FUNCTIONS
    // ═══════════════════════════════════════════════════════════════════════════════

    /** Preview Ravginit account cards */
    const previewRavginitAccountCards = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewRavginitAccountCards(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Ravginit account cards preview failed:', err);
            toast.error(err?.message || t('RavginitPreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Ravginit account cards */
    const commitRavginitAccountCards = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportRavginitAccountCards(
                client.caseId,
                file,
                token
            );

            const processedCount = res?.processedCount ?? res?.item1 ?? res?.[0] ?? 0;
            const errorCount = res?.errorCount ?? res?.item2 ?? res?.[1] ?? 0;
            const errorMessages = res?.errorMessages ?? res?.item3 ?? res?.[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Ravginit account cards import errors:', errorMessages);
                toast.warning(
                    t('RavginitAccountCardsUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} cards with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('RavginitAccountCardsUploadedSuccessfully', {
                        processedCount
                    }) || `Successfully imported ${processedCount} account cards from Ravginit.`
                );
            }

            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error('Ravginit account cards upload error:', err);
            toast.error(t('RavginitAccountCardsUploadFailed') || 'Ravginit account cards import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Preview Ravginit journal entries */
    const previewRavginitJournal = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewRavginitJournal(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Ravginit journal preview failed:', err);
            toast.error(err?.message || t('RavginitPreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Ravginit journal entries */
    const commitRavginitJournal = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportRavginitJournal(
                client.caseId,
                file,
                token,
                true
            );

            const processedCount = res?.processedCount ?? res?.item1 ?? res?.[0] ?? 0;
            const errorCount = res?.errorCount ?? res?.item2 ?? res?.[1] ?? 0;
            const errorMessages = res?.errorMessages ?? res?.item3 ?? res?.[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('Ravginit journal import errors:', errorMessages);
                toast.warning(
                    t('RavginitJournalUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} entries with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('RavginitJournalUploadedSuccessfully', {
                        processedCount
                    }) || `Successfully imported ${processedCount} journal entries from Ravginit.`
                );
                await fetchEnums(token, client, true);
            }

            return res;
        } catch (err) {
            console.error('Ravginit journal import error:', err);
            toast.error(t('RavginitJournalUploadFailed') || 'Ravginit journal import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Preview journal entries rebuilt from a uniform file (BKMVDATA.txt) */
    const previewBmkvdJournal = useCallback(async (file, dateRange = {}, skipDuplicates = true) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewBmkvdJournal(
                client.caseId,
                client.accountantId,
                file,
                token,
                0,
                { ...dateRange, skipDuplicates }
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('BMKVD journal preview failed:', err);
            toast.error(err?.message || t('BmkvdPreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit journal entries from a uniform file (BKMVDATA.txt) */
    const commitBmkvdJournal = useCallback(async (
        file, sortCodeAssignments = null, dateRange = {}, importReconciliations = false,
        skipDuplicates = true
    ) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportBmkvdJournal(
                client.caseId,
                file,
                token,
                {
                    skipDuplicates,
                    autoCreateAccountCards: true,
                    sortCodeAssignments,
                    importReconciliations,
                    ...dateRange,
                }
            );

            const processedCount = res?.processedCount ?? res?.item1 ?? res?.[0] ?? 0;
            const errorCount = res?.errorCount ?? res?.item2 ?? res?.[1] ?? 0;
            const errorMessages = res?.errorMessages ?? res?.item3 ?? res?.[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('BMKVD journal import errors:', errorMessages);
                toast.warning(
                    t('BmkvdJournalUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} entries with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('BmkvdJournalUploadedSuccessfully', {
                        processedCount
                    }) || `Successfully imported ${processedCount} journal entries from the uniform file.`
                );
            }

            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('BMKVD journal import error:', err);
            toast.error(t('BmkvdJournalUploadFailed') || 'Uniform file journal import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Preview Webenefit journal entries */
    const previewWebenefitJournal = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            const res = await ImportExportService.PreviewWebenefitJournal(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('Webenefit journal preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    /** Commit Webenefit journal entries */
    const commitWebenefitJournal = useCallback(async (file) => {
        if (!file || !client) return;

        try {
            setLoading(true);
            const res = await ImportExportService.ImportWebenefitJournal(
                client.caseId,
                client.accountantId,
                file,
                token
            );

            toast.success(t('WebenefitJournalUploadedSuccessfully') || 'פקודות יומן Webenefit יובאו בהצלחה');
            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('Webenefit journal import error:', err);
            toast.error(t('WebenefitJournalUploadFailed') || 'Webenefit journal import failed');
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    /** Create missing PalCode */
    const createMissingPalCode = useCallback(async (newPalCode) => {
        try {
            const response = await EnumsService.AddPalCode(newPalCode, token);
            if (response.ok) {
                toast.success(t('BalanceClassificationAddedSuccessfully') || 'חשבון ראשי נוסף בהצלחה');
                await fetchEnums(token, client, true);
            }
            return response;
        } catch (err) {
            console.error('PalCode creation error:', err);
            toast.error(t('BalanceClassificationNotAddedSuccessfully') || 'שגיאה ביצירת חשבון ראשי');
            throw err;
        }
    }, [token, t, client, fetchEnums]);

    /** Create missing sortcode category */
    const createMissingSortCodeCategory = useCallback(async (categoryName, accountantId, categoryType = 1) => {
        try {
            // Calculate next orderNumber (similar to PalCode logic)
            // Get existing sortcode groups for this accountant
            const sortCodeGroupsResponse = await EnumsService.GetSortCodesGroupByAccountantId(accountantId, token);
            let nextOrderNumber = 100; // Default starting number
            
            if (sortCodeGroupsResponse.ok) {
                const existingGroups = await sortCodeGroupsResponse.json();
                
                // Find max orderNumber and increment (using sortCodeListNumber or sortCodeGroupListNumber)
                const maxOrderNumber = existingGroups.reduce((max, group) => {
                    const orderNum = group.sortCodeListNumber || group.sortCodeGroupListNumber || 0;
                    return Math.max(max, orderNum);
                }, 0);
                
                nextOrderNumber = maxOrderNumber > 0 ? maxOrderNumber + 100 : 100;
            }

            const response = await EnumsService.AddSortCodeGroup(
                accountantId,
                categoryName,
                nextOrderNumber,
                '', // profitName - empty
                categoryType, // category type
                token
            );
            
            if (response.ok) {
                toast.success(t('CategoryCreatedSuccessfully') || `קטגוריה "${categoryName}" נוצרה בהצלחה`);
                await fetchEnums(token, client, true);
            }
            return response;
        } catch (err) {
            console.error('SortCode category creation error:', err);
            toast.error(t('CategoryCreationFailed') || 'שגיאה ביצירת קטגוריה');
            throw err;
        }
    }, [token, t, client, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // KODBENA IMPORT FUNCTIONS
    // ═══════════════════════════════════════════════════════════════════════════════

    // Account Cards
    const previewKodBenaAccountCards = useCallback(async (file) => {
        if (!file || !client) return;
        try {
            const res = await ImportExportService.PreviewKodBenaAccountCards(client.caseId, client.accountantId, file, token);
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('KodBena account cards preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitKodBenaAccountCards = useCallback(async (file) => {
        if (!file || !client) return;
        try {
            setLoading(true);
            const res = await ImportExportService.ImportKodBenaAccountCards(client.caseId, file, token);
            
            const processedCount = res?.processedAccountCards ?? res?.[0] ?? 0;
            const errorCount = res?.errorCount ?? res?.[1] ?? 0;
            const errorMessages = res?.errorMessages ?? res?.[2] ?? [];

            if (errorCount > 0 && errorMessages.length > 0) {
                console.error('KodBena account cards import errors:', errorMessages);
                toast.warning(
                    t('KodBenaAccountCardsUploadedWithErrors', {
                        processedCount,
                        errorCount,
                        firstError: errorMessages[0]
                    }) || `Imported ${processedCount} cards with ${errorCount} errors. Check console for details.`
                );
            } else {
                toast.success(
                    t('KodBenaAccountCardsUploadedSuccessfully', {
                        processedCount
                    }) || `Successfully imported ${processedCount} account cards from KodBena.`
                );
            }
            
            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('KodBena account cards import error:', err);
            toast.error(t('KodBenaAccountCardsImportFailed'));
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // Journal Entries
    const previewKodBenaJournal = useCallback(async (file) => {
        if (!file || !client) return;
        try {
            const res = await ImportExportService.PreviewKodBenaJournal(client.caseId, client.accountantId, file, token);
            toast.success(t('PreviewSuccess'));
            return res;
        } catch (err) {
            console.error('KodBena journal preview failed:', err);
            toast.error(t('PreviewFailed'));
            throw err;
        }
    }, [client, token, t]);

    const commitKodBenaJournal = useCallback(async (file) => {
        if (!file || !client) return;
        try {
            setLoading(true);
            const res = await ImportExportService.ImportKodBenaJournal(client.caseId, file, token);
            const processed = res?.processedJournalEntries ?? res?.[0] ?? 0;
            toast.success(
                t('KodBenaJournalEntriesUploadedSuccessfully', {
                    processed
                }) || `Successfully imported ${processed} journal entries from KodBena`
            );
            await fetchEnums(token, client, true);
            return res;
        } catch (err) {
            console.error('KodBena journal import error:', err);
            toast.error(t('KodBenaJournalImportFailed'));
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client, token, t, fetchEnums]);

    // ═══════════════════════════════════════════════════════════════════════════════
    // TAIODET IMPORT FUNCTIONS - Now using useTaiodetImport hook (see above)
    // ═══════════════════════════════════════════════════════════════════════════════

    const importMdbJournalEntries = async (file /* : File */) => {
        if (!file) return;
        try {
            setLoading(true);

            const res = await ImportExportService.ImportMdbJournalEntries(
                client.caseId,
                file,
                null,
                token
            );

            toast.success(
                t('MdbJournalUploadedSuccessfully', {
                    processedCount: res.processedCount ?? res[0],
                    errorCount: res.errorCount ?? res[1]
                })
            );

            /* anything changed? → refresh */
            await fetchEnums(token, client, true);

            return res;
        } catch (err) {
            console.error(err);
            toast.error(t('ErrorUploadingMdbJournal'));
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const handleInitializeProblematicActions = () => {
        // On open of the modal, build a default structure
        const defaultActions = problematicCards.map((pc) => ({
            accountCard: pc.dto,    // The CreateAccountCard object from the server
            actionType: 0,          // default to 0 (CreateNewCard)
            cardIdToReplace: '',    // or null
        }));
        setProblematicActions(defaultActions);
    };

    const handleSaveProblematicCards = async () => {
        // Send the final list of actions to the server
        try {
            setLoading(true);
            await ImportExportService.ImportProblematicAccountCards(
                client.caseId,
                problematicActions,
                token
            );
            toast.success(t('ProblematicCardsHandledSuccessfully'));
            setShowProblematicCardsModal(false);
            setProblematicCards([]);
            setProblematicActions([]);

            // Possibly refetch data
            await fetchEnums(token, client, true);
        } catch (error) {
            console.error(error);
            toast.error(`Failed to fix problematic cards: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // If the modal is open AND we have problematicCards
        // AND we haven't yet initialized the state
        if (showProblematicCardsModal && problematicCards.length > 0 && problematicActions.length === 0) {
            handleInitializeProblematicActions();
        }
    }, [showProblematicCardsModal, problematicCards, problematicActions]);



    const handleDateChangeNew = async (newValue, type) => {
        
        const newDate = new Date(newValue);
        let updatedDate;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), date.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(date.getFullYear(), newDate.getMonth(), 10));
        }
        setDate(updatedDate);
        localStorage.setItem('Date', updatedDate);
        if (isAdvancedBiMonthly === isBiMonthly) {
            setAdvancedDate(updatedDate);
        }
        await fetchDataOnDateRangeChange(updatedDate, updatedDate);
    };

    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 10));
        }
        setStartDate(updatedDate);
        localStorage.setItem('StartDate', updatedDate);
        if (isAdvancedBiMonthly === isBiMonthly) {
            setAdvancedStartDate(updatedDate);
        }
        if (isRange) await fetchDataOnDateRangeChange(updatedDate, endDate);
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 10));
        }
        setEndDate(updatedDate);
        localStorage.setItem('EndDate', updatedDate);
        if (isAdvancedBiMonthly === isBiMonthly) {
            setAdvancedEndDate(updatedDate);
        }
        if (isRange) await fetchDataOnDateRangeChange(startDate, updatedDate);
    };

    const handleBiMonthDate = async (start, end) => {
        setBiStartDate(start);
        setBiEndDate(end);
        localStorage.setItem('BiStartDate', start.toISOString());
        localStorage.setItem('BiEndDate', end.toISOString());
        if (isAdvancedBiMonthly === isBiMonthly) {
            setAdvancedBiStartDate(start);
            setAdvancedBiEndDate(end);
        }
        await fetchDataOnDateRangeChange(start, end);
    };

    const handleRangeChange = () => {
        const next = !isRange;
        isRangeRef.current = next;
        localStorage.setItem('IsRange', JSON.stringify(next));
        setIsRange(next);

        const samePeriod = isAdvancedBiMonthly === isBiMonthly;

        if (samePeriod) {
            setAdvancedStartDate(startDate);
            setAdvancedEndDate(endDate);
        }

        let vatStart, vatEnd, advDates = null;
        if (next) {
            vatStart = startDate;
            vatEnd = endDate;
            if (!samePeriod) {
                advDates = { start: advancedStartDate, end: advancedEndDate };
            }
        } else {
            if (isBiMonthly) {
                vatStart = biStartDate;
                vatEnd = biEndDate;
            } else {
                vatStart = date;
                vatEnd = date;
            }
            if (!samePeriod) {
                if (isAdvancedBiMonthly) {
                    advDates = { start: advancedBiStartDate, end: advancedBiEndDate };
                } else {
                    advDates = { start: advancedDate, end: advancedDate };
                }
            }
        }

        fetchDataOnDateRangeChange(vatStart, vatEnd, advDates, next);
    };

    // Example: handle data update from either child
    const handleDataUpdate = (updatedData) => {


        const sanitizedReportTax = {
            vatTransactions: updatedData.vatTransactions,
            otherVATTaxes: updatedData.otherVATTaxes,
            equipmentVAT: updatedData.equipmentVAT,
            netVAT: updatedData.netVAT,
        };
        // setReportTax(sanitizedReportTax);
        dispatch(setReportTax(sanitizedReportTax));
        // dispatch(setVatReportData(sanitizedReportTax));
    };

    const handleWithholdingDataUpdate = (updatedData, partnerId = null, _dateContext = null) => {

        
        // If it's a partnership and we have a specific partner ID, update only that partner's data
        if (client?.isPartners && partnerId) {
            // For partnerships, we need to update the partner-specific data structure
            // Get current state and update the specific partner's data
            const currentAdvanceReportTax = advanceReportTax || {};
            const updatedPartnerData = {
                ...currentAdvanceReportTax,
                [partnerId]: updatedData
            };
            dispatch(setAdvanceReportTax(updatedPartnerData));
        } else {
            // For non-partnership clients or general updates, update the main data
            dispatch(setAdvanceReportTax(updatedData));
        }

        // Refresh consolidated page data. VAT StartDate/EndDate must always follow the VAT
        // panel (date / bi-monthly / range), not the withholding modal's advance period.
        // When advance reporting is bi-monthly but VAT is monthly, dateContext from the modal
        // incorrectly mixed isAdvancedBiMonthly into isBiMonthly and sent advance bi-dates as VAT.
        const vatStart = isRange ? startDate : isBiMonthly ? biStartDate : date;
        const vatEnd = isRange ? endDate : isBiMonthly ? biEndDate : date;
        fetchDataOnDateRangeChange(vatStart, vatEnd);
    };

    // The follow-up modal (opened here or from the hamburger menu) can save reported VAT/advances.
    const refreshAfterReportingFollowUpRef = useRef(null);
    refreshAfterReportingFollowUpRef.current = () => {
        if (!client) return;
        const vatStart = isRange ? startDate : isBiMonthly ? biStartDate : date;
        const vatEnd = isRange ? endDate : isBiMonthly ? biEndDate : date;
        fetchDataOnDateRangeChange(vatStart, vatEnd);
    };
    useEffect(() => {
        const handleSaved = (event) => {
            if (event.detail?.caseId && event.detail.caseId !== client?.caseId) return;
            refreshAfterReportingFollowUpRef.current?.();
        };
        window.addEventListener(REPORTING_FOLLOW_UP_SAVED_EVENT, handleSaved);
        return () => window.removeEventListener(REPORTING_FOLLOW_UP_SAVED_EVENT, handleSaved);
    }, [client?.caseId]);

    // National Insurance panel: monthly amounts of the selected (end) month.
    const showNationalInsurancePanel = !!client && !permissionsState.ViewSubAccountantClients && !isClient && !isManageOnly;
    const nationalInsuranceDate = isRange ? endDate : isBiMonthly ? biEndDate : date;
    const nationalInsuranceYear = nationalInsuranceDate ? new Date(nationalInsuranceDate).getFullYear() : null;
    const nationalInsuranceMonth = nationalInsuranceDate ? new Date(nationalInsuranceDate).getMonth() + 1 : null;
    const nationalInsurancePeriodLabel = nationalInsuranceYear
        ? `${String(nationalInsuranceMonth).padStart(2, '0')}/${nationalInsuranceYear}`
        : '';

    const loadNationalInsuranceSummaryRef = useRef(null);
    loadNationalInsuranceSummaryRef.current = async () => {
        if (!showNationalInsurancePanel || !token || !nationalInsuranceYear) return;
        try {
            const summary = await ReportingFollowUpService.getNationalInsuranceSummary({
                caseId: client.caseId,
                year: nationalInsuranceYear,
                month: nationalInsuranceMonth,
            }, token);
            setNationalInsuranceSummary(summary);
        } catch (error) {
            console.error('Error loading National Insurance summary:', error);
            setNationalInsuranceSummary(null);
        }
    };
    useEffect(() => {
        setNationalInsuranceSummary(null);
        loadNationalInsuranceSummaryRef.current?.();
    }, [client?.caseId, token, showNationalInsurancePanel, nationalInsuranceYear, nationalInsuranceMonth]);
    useEffect(() => {
        const handleFollowUpSaved = (event) => {
            if (event.detail?.caseId && event.detail.caseId !== client?.caseId) return;
            loadNationalInsuranceSummaryRef.current?.();
        };
        const handleNationalInsuranceSaved = (event) => {
            const caseIds = event.detail?.caseIds;
            if (Array.isArray(caseIds) && client?.caseId && !caseIds.includes(client.caseId)) return;
            loadNationalInsuranceSummaryRef.current?.();
        };
        window.addEventListener(REPORTING_FOLLOW_UP_SAVED_EVENT, handleFollowUpSaved);
        window.addEventListener(NATIONAL_INSURANCE_SAVED_EVENT, handleNationalInsuranceSaved);
        return () => {
            window.removeEventListener(REPORTING_FOLLOW_UP_SAVED_EVENT, handleFollowUpSaved);
            window.removeEventListener(NATIONAL_INSURANCE_SAVED_EVENT, handleNationalInsuranceSaved);
        };
    }, [client?.caseId]);

    // Salary panel: totals of the selected period, missing months across the selected year(s).
    const showSalaryPanel = showNationalInsurancePanel;
    const toMonthKey = (value) => {
        if (!value) return '';
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return '';
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
    };
    const salaryPeriodStart = toMonthKey(isRange ? startDate : isBiMonthly ? biStartDate : date);
    const salaryPeriodEnd = toMonthKey(isRange ? endDate : isBiMonthly ? biEndDate : date);
    const salaryStartYear = salaryPeriodStart ? Number(salaryPeriodStart.slice(0, 4)) : nationalInsuranceYear;
    const salaryEndYear = salaryPeriodEnd ? Number(salaryPeriodEnd.slice(0, 4)) : salaryStartYear;
    const salaryFromYear = salaryStartYear && salaryEndYear
        ? Math.max(Math.min(salaryStartYear, salaryEndYear), Math.max(salaryStartYear, salaryEndYear) - 5)
        : null;
    const salaryToYear = salaryStartYear && salaryEndYear ? Math.max(salaryStartYear, salaryEndYear) : null;
    const salaryPeriodLabel = salaryPeriodStart && salaryPeriodEnd && salaryPeriodStart !== salaryPeriodEnd
        ? `${salaryPeriodStart.slice(5, 7)}/${salaryPeriodStart.slice(0, 4)} - ${salaryPeriodEnd.slice(5, 7)}/${salaryPeriodEnd.slice(0, 4)}`
        : nationalInsurancePeriodLabel;

    const loadSalaryOverviewRef = useRef(null);
    const salaryRequestIdRef = useRef(0);
    loadSalaryOverviewRef.current = async () => {
        if (!showSalaryPanel || !token || !salaryFromYear || !salaryToYear) return;
        const requestId = ++salaryRequestIdRef.current;
        setSalaryLoading(true);
        try {
            const overview = await SalariesService.getOverview({
                caseId: client.caseId,
                startYear: salaryFromYear,
                endYear: salaryToYear,
                periodStart: salaryPeriodStart || null,
                periodEnd: salaryPeriodEnd || null,
            }, token);
            if (requestId !== salaryRequestIdRef.current) return;
            setSalaryOverview(overview);
        } catch (error) {
            if (requestId !== salaryRequestIdRef.current) return;
            console.error('Error loading salary overview:', error);
            setSalaryOverview(null);
        } finally {
            if (requestId === salaryRequestIdRef.current) setSalaryLoading(false);
        }
    };
    useEffect(() => {
        setSalaryOverview(null);
        loadSalaryOverviewRef.current?.();
    }, [client?.caseId, token, showSalaryPanel, salaryFromYear, salaryToYear, salaryPeriodStart, salaryPeriodEnd]);
    useEffect(() => {
        const handleSalarySaved = (event) => {
            if (event.detail?.caseId && event.detail.caseId !== client?.caseId) return;
            loadSalaryOverviewRef.current?.();
        };
        window.addEventListener(SALARY_SETTINGS_SAVED_EVENT, handleSalarySaved);
        return () => window.removeEventListener(SALARY_SETTINGS_SAVED_EVENT, handleSalarySaved);
    }, [client?.caseId]);

    const handleOpenVatModal = () => {
        if (isRange) {
            toast.info(t('ChangeToSingleDateRangeForVAT'));
            setOpenVatModal(false);
            return;
        }
        // setCurrentItem(item);
        // client Details
        const biStart = biStartDate;
        const biEnd = biEndDate;

        const IncomesNoVats = incomesAmount - incomeNoVat;
        const IncomesNoZeroVats = incomeNoVat;
        const StartDate = isBiMonthly ? biStart : date;
        const EndDate = isBiMonthly ? biEnd : date;

        const VatReport = {
            id: reportTax.id,
            clientName: client.name,
            clientLocation: client.location || '',
            clientCaseId: client.caseId,
            // DISPLAY ONLY: VAT-authority dealer number shown on the VAT modal / report.
            vatClientNumber: client.vatClientNumber ?? client.VatClientNumber ?? '',
            clientAccountantId: client.accountantId,
            VATEquipment: purchaseOfEquipmentExpensesVatAmount,
            VATExpenses: expensesVatAmount,
            VATTransactions: incomesVatAmount,
            VATNet: netVatAmount,
            IncomesNoVats: IncomesNoVats,
            IncomesNoZeroVats: IncomesNoZeroVats,
            StartDate: StartDate,
            EndDate: EndDate,
            VATRateTransactions: beautifyNumber((incomesVatAmount / IncomesNoVats) * 100 || 0),
            // Equipment
            VATEquipment17: equipmentVatDetailed.vat17,
            VATEquipment18: equipmentVatDetailed.vat18,
            // Expenses
            VATExpenses17: expensesVatDetailed.vat17,
            VATExpenses18: expensesVatDetailed.vat18,
            // Incomes
            VATTransactions17: incomesVatDetailed.vat17,
            VATTransactions18: incomesVatDetailed.vat18,
            income17Amount: incomesAmountDetailed.amount17,
            income18Amount: incomesAmountDetailed.amount18,
        };

        dispatch(setVatReportData(VatReport));
    };

    useEffect(() => {
        if (!openVatModal || clientDataLoading) return;
        handleOpenVatModal();
    }, [openVatModal, clientDataLoading, isRange, biStartDate, biEndDate, incomesAmount, incomeNoVat, isBiMonthly, date, reportTax, client, purchaseOfEquipmentExpensesVatAmount, expensesVatAmount, incomesVatAmount, netVatAmount]);




    const handleWithholdingTaxEdit = () => {
        if (isRange) {
            toast.info(t('ChangeToSingleDateRangeForVAT'));
            setOpenWithholdingTaxModal(false);
            return;
        }

        // const witholdingIncomesNoVat = incomesAmount - incomeOfSellEquipmentNoVat;
        const paymentAcceptanceWithholdingTax = parseFloat(acceptedWithholdingTax) || 0;
        const advPct =
            pageIncomeTaxAdvancePercentage != null && pageIncomeTaxAdvancePercentage !== ''
                ? Number(pageIncomeTaxAdvancePercentage)
                : Number(client.incomeTaxAdvancePercentage) || 0;
        const advUsePct =
            pageUseIncomeTaxAdvancePercentage != null
                ? !!pageUseIncomeTaxAdvancePercentage
                : !!client.useIncomeTaxAdvancePercentage;
        const advFixed =
            pageIncomeTaxAdvanceAmount != null && pageIncomeTaxAdvanceAmount !== ''
                ? Number(pageIncomeTaxAdvanceAmount)
                : Number(client.incomeTaxAdvanceAmount) || 0;

        let total = (witholdingIncomesNoVat * (advPct / 100)) || 0;

        if (!advUsePct) {
            total = advFixed;
        }
        let IncomeTaxAdvances = (total - paymentAcceptanceWithholdingTax) || 0;
        if (IncomeTaxAdvances < 0) {
            IncomeTaxAdvances = 0;
        }
        let AcceptedWithholdingTaxMaximum = paymentAcceptanceWithholdingTax;
        if (paymentAcceptanceWithholdingTax > total) {
            AcceptedWithholdingTaxMaximum = total;
        }

        const surplusExpenses = advanceReportTax.surplusExpenses ?? 0;
        IncomeTaxAdvances += surplusExpenses;

        // --- Date logic ---
        let StartDate, EndDate;
        if (isAdvancedBiMonthly !== isBiMonthly) {
            if (isRange) {
                StartDate = advancedStartDate;
                EndDate = advancedEndDate;
            } else if (isAdvancedBiMonthly) {
                StartDate = advancedBiStartDate;
                EndDate = advancedBiEndDate;
            } else {
                StartDate = advancedDate;
                EndDate = advancedDate;
            }
        } else {
            if (isRange) {
                StartDate = startDate;
                EndDate = endDate;
            } else if (isBiMonthly) {
                StartDate = biStartDate;
                EndDate = biEndDate;
            } else {
                StartDate = date;
                EndDate = date;
            }
        }

        const WithholdingTax = {
            id: advanceReportTax.id,
            clientName: client.name,
            clientLocation: client.location || '',
            clientCaseId: client.caseId,
            taxClientNumber: client.taxClientNumber ?? client.TaxClientNumber ?? '',
            AcceptedWithholdingTax: paymentAcceptanceWithholdingTax,
            AcceptedWithholdingTaxMaximum: AcceptedWithholdingTaxMaximum,
            incomeTaxAdvancePercentage: advPct,
            IncomeTaxAdvances: IncomeTaxAdvances,
            total: total,
            witholdingIncomesNoVat: witholdingIncomesNoVat,
            StartDate: StartDate,
            EndDate: EndDate,
            useIncomeTaxAdvancePercentage: advUsePct,
            incomeTaxAdvanceAmount: advFixed,
            caseType: client.caseType,
            surplusExpenses: advanceReportTax.surplusExpenses
        };

        setWithholdingTax(WithholdingTax);
    };


    useEffect(() => {
        if (!openWithholdingTaxModal || clientDataLoading) return;
        handleWithholdingTaxEdit();
    }, [
        openWithholdingTaxModal,
        clientDataLoading,
        isRange,
        acceptedWithholdingTax,
        witholdingIncomesNoVat,
        client,
        biStartDate,
        biEndDate,
        isBiMonthly,
        date,
        advanceReportTax,
        pageIncomeTaxAdvancePercentage,
        pageUseIncomeTaxAdvancePercentage,
        pageIncomeTaxAdvanceAmount,
    ]);

    const handleShowVatModal = () => setOpenVatModal(true);
    const [selectedPartnerForModal, setSelectedPartnerForModal] = useState(null);
    
    const handleOpenWithholdingTaxModal = (selectedPartner = null) => {
        setSelectedPartnerForModal(selectedPartner);
        setOpenWithholdingTaxModal(true);
    };

    // Function to calculate partner-specific values
    const calculatePartnerValues = (partners) => {

        if (!partners || partners.length === 0 || !client.isPartners) {
            setPartnerCalculatedValues({});
            return;
        }

        const partnerValues = {};
    
        partners.forEach(partner => {
            const equityMultiplier = partner.equity / 100;

            // Calculate partner's portion of incomes
            const partnerIncomesNoVat = Math.floor((witholdingIncomesNoVat || 0) * equityMultiplier);
            const partnerAcceptedWithholdingTax = Math.floor((acceptedWithholdingTax || 0) * equityMultiplier);

            // Resolved yearly settings from API (auto-seeded from legacy partner fields when missing).
            const partnerYearly = partnerAdvanceSettings?.[partner.id];
            const partnerAdvPct = partnerYearly?.incomeTaxAdvancePercentage != null
                ? Number(partnerYearly.incomeTaxAdvancePercentage)
                : (partner.withholdingTaxPercentage || 0);
            const partnerAdvUsePct = partnerYearly?.useIncomeTaxAdvancePercentage != null
                ? !!partnerYearly.useIncomeTaxAdvancePercentage
                : !!partner.useIncomeTaxAdvancePercentage;
            const partnerAdvFixed = partnerYearly?.incomeTaxAdvanceAmount != null
                ? Number(partnerYearly.incomeTaxAdvanceAmount)
                : (partner.incomeTaxAdvanceAmount || 0);

            // Use the same calculateIncomeTaxAdvances function for each partner with their resolved settings
            const partnerComputed = calculateIncomeTaxAdvances(
                partnerIncomesNoVat,
                partnerAcceptedWithholdingTax,
                partnerAdvPct,
                partnerAdvUsePct,
                partnerAdvFixed,
                0 // surplusExpenses for partners
            );
            
            const partnerTotal = partnerComputed.total;
            const partnerIncomeTaxAdvances = partnerComputed.IncomeTaxAdvances;
            const partnerAcceptedWithholdingTaxMaximum = partnerComputed.AcceptedWithholdingTaxMaximum;
            
            // Get partner-specific reported values from the new backend response format
            // For partnerships, advanceReportTax is a dictionary with partner IDs as string keys
            // For non-partnerships, advanceReportTax is a single object
            let partnerReportedData = {};
            if (client.isPartners && typeof advanceReportTax === 'object' && advanceReportTax !== null) {
                // Check if it's a dictionary (partnership) or single object (non-partnership)
                if (advanceReportTax[partner.id] !== undefined) {
                    // It's a dictionary with partner IDs as string keys
                    partnerReportedData = advanceReportTax[partner.id] || {};
                } else {
                    // It's a single object, use it directly
                    partnerReportedData = advanceReportTax;
                }
            } else {
                // Fallback to the original format
                partnerReportedData = advanceReportTax || {};
            }
            
            const reportedIncomesNoVat = partnerReportedData?.witholdingIncomesNoVat || 0;
            const reportedAcceptedWithholding = partnerReportedData?.acceptedWithholdingTax || 0;
            const reportedSurplusExpenses = partnerReportedData?.surplusExpenses || 0;
            
            // Use the same calculateIncomeTaxAdvances function for reported values with partner's resolved settings
            const partnerReported = calculateIncomeTaxAdvances(
                reportedIncomesNoVat,
                reportedAcceptedWithholding,
                partnerAdvPct,
                partnerAdvUsePct,
                partnerAdvFixed,
                reportedSurplusExpenses
            );
            
            const reportedTotal = partnerReported.total;
            const reportedIncomeTaxAdvances = partnerReported.IncomeTaxAdvances;
            const reportedAcceptedWithholdingTaxMaximum = partnerReported.AcceptedWithholdingTaxMaximum;
            
            partnerValues[partner.id] = {
                computed: {
                    IncomeTaxAdvances: partnerIncomeTaxAdvances,
                    AcceptedWithholdingTaxMaximum: partnerAcceptedWithholdingTaxMaximum,
                    total: partnerTotal,
                    witholdingIncomesNoVat: partnerIncomesNoVat
                },
                reported: {
                    IncomeTaxAdvances: reportedIncomeTaxAdvances,
                    AcceptedWithholdingTaxMaximum: reportedAcceptedWithholding,
                    total: reportedTotal,
                    witholdingIncomesNoVat: reportedIncomesNoVat
                }
            };
        });
        
        setPartnerCalculatedValues(partnerValues);
    };

    // Fetch partners when client is a partnership
    useEffect(() => {
        const fetchPartners = async () => {
            if (!client?.isPartners || !token) {
                setPartners([]);
                return;
            }

            try {
                const response = await PartnerService.getPartnersByCaseId(client.caseId, token);
                if (response.ok) {
                    const partnersData = await response.json();
                    setPartners(partnersData);
                }
            } catch (error) {
                console.error('Error fetching partners:', error);
                setPartners([]);
            }
        };

        fetchPartners();
    }, [client?.caseId, client?.isPartners, token]);
    

    useEffect(() => {
        if (!client) return;

        // Safe destructure + fallback in case advanceReportTax is still loading
        const {
            witholdingIncomesNoVat: reportedIncomesNoVat = 0,
            acceptedWithholdingTax: reportedAcceptedWithholding = 0,
            incomeTaxAdvancePercentage: reportedAdvancePct = 0,
            incomeTaxAdvanceAmount: reportedAdvanceAmount = 0,
            surplusExpenses: reportedSurplus = 0
        } = advanceReportTax || {};


        
        // Use main client settings for calculations if this is a subordinate client
        const clientForCalculation = mainClientData || client;

        const resolvedAdvPct =
            pageIncomeTaxAdvancePercentage != null && pageIncomeTaxAdvancePercentage !== ''
                ? Number(pageIncomeTaxAdvancePercentage)
                : (clientForCalculation.incomeTaxAdvancePercentage ?? 0);
        const resolvedAdvUsePct =
            pageUseIncomeTaxAdvancePercentage != null
                ? !!pageUseIncomeTaxAdvancePercentage
                : (clientForCalculation.useIncomeTaxAdvancePercentage ?? true);
        const resolvedAdvFixed =
            pageIncomeTaxAdvanceAmount != null && pageIncomeTaxAdvanceAmount !== ''
                ? Number(pageIncomeTaxAdvanceAmount)
                : (clientForCalculation.incomeTaxAdvanceAmount ?? 0);

        const computed = calculateIncomeTaxAdvances(
            witholdingIncomesNoVat ?? 0,
            acceptedWithholdingTax ?? 0,
            resolvedAdvPct,
            resolvedAdvUsePct,
            resolvedAdvFixed,
            0
        );

        const reported = calculateIncomeTaxAdvances(
            reportedIncomesNoVat,
            reportedAcceptedWithholding,
            reportedAdvancePct,
            resolvedAdvUsePct,
            reportedAdvanceAmount,
            reportedSurplus
        );

        dispatch(setCalculatedValues({ computed, reported }));

        // If client is a partnership, calculate partner-specific values
        if (client.isPartners && partners.length > 0) {
            calculatePartnerValues(partners);
        } else {
            setPartnerCalculatedValues({});
        }
    }, [
        client,
        witholdingIncomesNoVat,
        acceptedWithholdingTax,
        incomeTaxAdvances,
        advanceReportTax,
        partners,
        dispatch,
        pageIncomeTaxAdvancePercentage,
        pageUseIncomeTaxAdvancePercentage,
        pageIncomeTaxAdvanceAmount,
        partnerAdvanceSettings,
        mainClientData,
    ]);

    const [showedPostponedChecksWarning, setShowedPostponedChecksWarning] = useState(false);
    useEffect(() => {
        const warnIfPostponed = async () => {
            if (!client || !token) return;

            const caseId = client.caseId;

            dispatch(clearExpiredWarnings(30 * 60 * 1000)); // 30 min expiry

            if (warnedCaseIds[caseId]) return;

            const now = new Date();
            const endOfUtcDay = new Date(Date.UTC(
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate(),
                23, 59, 59, 999
            ));

            const isoUtcEndOfDay = endOfUtcDay.toISOString();
            try {
                const response = await DocumentService.CheckPostponedChecks(
                    caseId,
                    isoUtcEndOfDay,
                    token,
                    false
                );

                if (response.hasPostponed) {
                    dispatch(markWarned(caseId));
                    const result = await Swal.fire({
                        title: t('PostponedChecksFound'),
                        text: t('PostponedChecksHandlePrompt'),
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: t('Yes'),
                        cancelButtonText: t('No'),
                    });

                    if (result.isConfirmed) setShowPostponedChecks(true);
                }
            } catch (err) {
                console.error('Check postponed-checks failed:', err);
            }
        };

        warnIfPostponed();
    }, [client?.caseId, token]);



    const formatDateToYearMonth = (dateString) => {
        const date = new Date(dateString);
        const year = date.getUTCFullYear();
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        return `${year}/${month}`;
    };





    const headerContextValue = {
        client,
        permissions,
        permissionsLoading,
        user,
        token,
        isAccountant,
        userTypeContext,
        // Surface the per-client ManageOnly flag so header subcomponents can suppress
        // reporting widgets (TotalUploads, Import/Export, date picker, close month,
        // OnlyProcessed checkbox) without re-reading PermissionsContext.
        isManageOnly,
        // "Only processed documents" toggle (rendered in ClientDetailsHeader)
        onlyProcessedDocuments,
        setOnlyProcessedDocuments,
        // --- Modal show/hide flags ---
        showDownloadModal, setShowDownloadModal, closeDownloadModal,
        showDownloadFilesModal, setShowDownloadFilesModal, closeFileDownloadModal,
        showExportJournalModal, setShowExportJournalModal, closeExportJournal,
        showImportModal, setShowImportModal, closeImportModal,
        showImportJournalModal, setShowImportJournalModal, closeImportJournal,
        showAccountCardModal, setShowAccountCardModal, closeAccountCardModal,
        showAccountCardImportModal, setShowAccountCardImportModal, closeAccountCardImportModal,
        showHeshinDatModal, setShowHeshinDatModal,
        showJEImportModal, setShowJEImportModal,
        showRivhitImportModal, setShowRivhitImportModal,
        showBiMonth, setShowBiMonth,
        showPCNModal, setShowPCNModal,
        pcnIncludeStornoChecks, setPcnIncludeStornoChecks,
        showPCNChecksModal, setShowPCNChecksModal,
        pcnHighConfirmationDocs, setPcnHighConfirmationDocs,
        pcnDocumentsNeedingAllocation, setPcnDocumentsNeedingAllocation,
        pcnDocumentsWithoutReference, setPcnDocumentsWithoutReference,
        pcnDocumentsOutOfRange, setPcnDocumentsOutOfRange,
        pcnChecksLoading, setPcnChecksLoading,


        // --- Modal openers/handlers ---
        openExportModal,
        openAccountCardModal,
        openAccountCardImportModal,
        openImportModal,
        openRivhitEntriesImportModal,
        openJournalEntriesImportModal,
        openReferenceSequenceModal,

        // --- Download/upload handlers ---
        downloadVATReport,
        downloadWithholdingTaxReport,
        downloadPCNReport,
        handlePCNDownload,
        handlePCNChecks,
        downloadProfitAndLoss,
        journalEntryDownload,
        journalEntryDownloadMovein,
        showMoveinExportPreview,
        setShowMoveinExportPreview,
        moveinExportPreviewData,
        moveinSortCodeMappings,
        setMoveinSortCodeMappings,
        confirmMoveinExport,
        journalEntryDownloadPkuda,
        showPkudaExportPreview,
        setShowPkudaExportPreview,
        pkudaExportPreviewData,
        pkudaExportOptions,
        setPkudaExportOptions,
        refreshPkudaExportPreview,
        confirmPkudaExport,
        accountantCardDownload,
        accountantCardDownloadHeshin,
        accountantCardDownloadPkuda,
        showAccountCardExportPreview,
        setShowAccountCardExportPreview,
        accountCardExportPreviewData,
        editableAccountCards,
        setEditableAccountCards,
        confirmAccountCardExport,

        // --- File refs & upload handlers ---
        fileInputRef1,
        handleFileButtonClick,
        uploadFileToAccountCardRevhit,

        // --- Heshin/Movein file handlers ---
        handleHeshinDatDrop,
        handleHeshinPrmDrop,
        heshinDatFile,
        heshinPrmFile,
        handleHeshinDatUpload,
        handleDateChangeNew,
        handleStartDateChangeNew,
        handleEndDateChangeNew,
        handleBiMonthDate,

        // --- MoveIn file handlers ---
        moveInDatFile,
        handleMoveInDatDrop,
        handleMoveInDatUpload,
        moveInDatAmountDivisor,
        setMoveInDatAmountDivisor,
        handleRangeChange,

        // --- Date Pickers (journal entry) ---
        CustomMonthDatePicker,
        setJeStartDate,
        setJeEndDate,
        jeStartDate,
        jeEndDate,
        // --- Utilities/components ---
        dayjs,
        DropzoneArea,

        // --- Icons/images ---
        backIcon,

        // --- UI/Localization ---
        t,
        isRange,
        isBiMonthly,
        startDate,
        endDate,
        biStartDate,
        biEndDate,
        direction,
        date,
        unfinishedAssignments,
        viewAssignments,
        collectionBalance,
        beautifyNumber,
        viewCollectionPage,
        walletIcon,
        uploadIcon,
        totalUploads,
        openUploadsBreakdown: () => setShowUploadsBreakdown(true),
        permissionsState,
        userTypeContext,
        Constants,
        importIconSvg,
        isClosedReportingMonth,
        setActionType,
        setIsModalVisible,
        formatDateToYearMonth,
        showAtzmaitImportModal,
        setShowAtzmaitImportModal,
        handleAtzmaitCsvDrop,
        atzmaitCsvFile,
        setAtzmaitCsvFile,
        previewAtzmaitCsv,
        commitAtzmaitCsv,
        missingSortCodes,
        setMissingSortCodes,
        createMissingSortCodes,
        formattedSortCodesGroupNamesOptions,
        formattedSortCodeVatType,
        importMdbAccountCards,
        importMdbJournalEntries,
        previewMdbJournal,
        commitMdbJournal,
        previewExcelJournal,
        commitExcelJournal,
        previewExcelAccountCards,
        commitExcelAccountCards,
        createMissingPalCode,
        createMissingSortCodeCategory,
        // Rivhit CSV V2 Import Functions
        previewRivhitCsvV2,
        commitRivhitCsvV2,
        // Account Index Import Functions (רבגונית / ניהולית)
        previewRavginitAccountIndex,
        commitRavginitAccountIndex,
        previewNihulitAccountIndex,
        commitNihulitAccountIndex,
        // Rivhit Closing Balance Import Functions
        previewRivhitClosingBalance,
        commitRivhitClosingBalance,
        // Ramplus Import Functions
        previewRamplusAccountCards,
        commitRamplusAccountCards,
        previewRamplusJournal,
        commitRamplusJournal,
        previewRamplusClosingBalance,
        commitRamplusClosingBalance,
        // Sumit Closing Balance Import Functions
        previewSumitClosingBalance,
        commitSumitClosingBalance,
        previewFinbotClosingBalance,
        commitFinbotClosingBalance,
        // Sumit Import Functions
        previewSumitAccountCards,
        commitSumitAccountCards,
        previewSumitJournal,
        commitSumitJournal,
        // Finbot Import Functions
        previewFinbotAccountCards,
        commitFinbotAccountCards,
        previewFinbotJournal,
        commitFinbotJournal,
        // Finbot API Import Functions
        fetchFinbotClients,
        previewFinbotJournalApi,
        commitFinbotJournalApi,
        previewFinbotAccountCardsApi,
        commitFinbotAccountCardsApi,
        // Paperless API Import Functions (cards + journal entries in one call)
        fetchPaperlessUsers,
        previewPaperlessApi,
        commitPaperlessApi,
        // Ravginit (RAVGONIT .26) Import Functions
        previewRavginitAccountCards,
        commitRavginitAccountCards,
        previewRavginitJournal,
        commitRavginitJournal,
        // Uniform file (BKMVDATA.txt) journal import
        previewBmkvdJournal,
        commitBmkvdJournal,
        // Webenefit Import Functions
        previewWebenefitJournal,
        commitWebenefitJournal,
        // KodBena Import Functions
        previewKodBenaAccountCards,
        commitKodBenaAccountCards,
        previewKodBenaJournal,
        commitKodBenaJournal,
        // Taiodet Import handlers
        previewTaiodetAccountCards,
        commitTaiodetAccountCards,
        previewTaiodetJournal,
        commitTaiodetJournal,
        // Priority Import handlers
        previewPriorityAccountCards,
        commitPriorityAccountCards,
        previewPriorityJournal,
        commitPriorityJournal,
        previewPriorityOpeningBalance,
        commitPriorityOpeningBalance,
        palCodeCategoryOptions,
        palCodes,
        user,
        // --- Advanced Reporting Dates ---
        advancedDate,
        setAdvancedDate,
        advancedStartDate,
        setAdvancedStartDate,
        advancedEndDate,
        setAdvancedEndDate,
        advancedBiStartDate,
        setAdvancedBiStartDate,
        advancedBiEndDate,
        setAdvancedBiEndDate,
        isAdvancedBiMonthly,
        handleAdvancedDateChangeNew,
        handleAdvancedStartDateChangeNew,
        handleAdvancedEndDateChangeNew,
        handleAdvancedBiMonthDate,
        handleAdvancedRangeChange,
        pcnReportDetails,
        setPcnReportDetails,
        previewPkuda,
        commitPkuda,
        pkudaMissingSortCodes,
        setPkudaMissingSortCodes,
        sortCodeOptions,

    };




    return (
        <>

            {showPostponedChecks && (
                <PostponedChecks
                    open={showPostponedChecks}
                    onClose={handleClosePostponedChecks}
                    caseId={client?.caseId}    // We pass the caseId so the component can fetch
                    token={token}         // The user's JWT token
                />
            )}

            <WithholdingModal
                open={withHoldingTaxModalOpen}
                onClose={closeWithHoldingTaxModal}
                t={t}
                direction={direction}
                withHoldingTaxType={withHoldingTaxType}
                setWithholdingTaxTypeFunc={setWithholdingTaxTypeFunc}
                isDateRange={isDateRange}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                date={date}
                setDate={setDate}
                dayjs={dayjs}
                formattedAccountSourceDeductionCardOptions={formattedAccountSourceDeductionCardOptions}
                selectedAccountCard={selectedAccountCard}
                handleSelectedAccountCardChangeForWithholding={handleSelectedAccountCardChangeForWithholding}
                handleDownloadWithholdingReportReport={handleDownloadWithholdingReportReport}
                handleShowWithholdingReportReport={handleShowWithholdingReportReport}
                modalStyle={modalStyle}
                client={client}
                partners={partners}
                token={token}
            />

            <ClientWithholdingModal
                open={clientWithHoldingTaxModalOpen}
                onClose={closeClientWithHoldingTaxModal}
                t={t}
                direction={direction}
                withHoldingTaxType={withHoldingTaxType}
                setWithholdingTaxTypeFunc={setWithholdingTaxTypeFunc}
                isDateRange={isDateRange}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                date={date}
                setDate={setDate}
                dayjs={dayjs}
                formattedAccountSourceDeductionCardOptions={formattedAccountSourceDeductionCardOptions}
                selectedAccountCard={selectedAccountCard}
                handleSelectedAccountCardChangeForWithholding={handleSelectedAccountCardChangeForWithholding}
                handleDownloadClientWithholdingReportReport={handleDownloadClientWithholdingReportReport}
                handleDownloadClientWithholdingExcelReport={handleDownloadClientWithholdingExcelReport}
                handleShowClientWithholdingReportReport={handleShowClientWithholdingReportReport}
                modalStyle={modalStyle}
                client={client}
                partners={partners}
            />

            <DownloadModals
                show856Modal={show856Modal}
                setShow856Modal={setShow856Modal}
                showUniformFileModal={showUniformFileModal}
                setShowUniformFileModal={setShowUniformFileModal}
                client={client}
                token={token}
            />

            <MonthStatusModal
                open={showMonthStatusModal}
                onClose={() => setShowMonthStatusModal(false)}
                caseId={client?.caseId}
                selectedYear={new Date().getFullYear()}
                token={token}
                t={t}
                direction={direction}
                onRefresh={() => fetchEnums(token, client, false)}
            />

            <ProblematicCardsModal
                open={showProblematicCardsModal}
                onClose={() => setShowProblematicCardsModal(false)}
                t={t}
                direction={direction}
                modalStyle={modalStyle}
                problematicActions={problematicActions}
                problematicCards={problematicCards}
                handleSelectActionType={handleSelectActionType}
                handleSelectExistingCard={handleSelectExistingCard}
                formattedAccountCardOptions={formattedAccountCardOptions}
                handleSaveProblematicCards={handleSaveProblematicCards}
                loading={loading}
            />

            {/* <HamburgerMenu client={client} /> */}
            <>
                {client &&
                    <>
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                            {!client.isActive && (
                                <Box display="flex" alignItems="center" sx={{ marginTop: '8px' }}>
                                    <Typography variant="body1" sx={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>
                                        {t("UserInactiveClickToActivate")}
                                    </Typography>
                                    <Tooltip title={t('ActivateUser')}>
                                        <IconButton
                                            onClick={() => setOpenDialog(true)}
                                            color="error"
                                            sx={{ marginBottom: '4px' }}
                                        >
                                            <BlockIcon fontSize="large" />
                                        </IconButton>
                                    </Tooltip>

                                </Box>
                            )}
                            {vatGroup && !vatGroup.isSatellite && vatGroup.satelliteCaseIds?.length > 0 && (
                                <Tooltip
                                    title={`${t('VatGroupConsolidatedTooltip')}: ${vatGroup.satelliteCaseIds.join(', ')}`}
                                >
                                    <Box
                                        display="inline-flex"
                                        alignItems="center"
                                        sx={{
                                            marginTop: '8px',
                                            padding: '4px 12px',
                                            borderRadius: '16px',
                                            backgroundColor: '#e3f2fd',
                                            border: '1px solid #90caf9',
                                            color: '#1565c0',
                                            fontSize: '0.85rem',
                                            fontWeight: 600,
                                        }}
                                    >
                                        {t('VatGroupConsolidatedWith', { count: vatGroup.satelliteCaseIds.length })}
                                    </Box>
                                </Tooltip>
                            )}
                            <MasavPaymentDayNotice
                                accountantId={client.accountantId}
                                caseId={client.caseId}
                                isLeadingBusiness={!!client.leadingBusiness}
                                sx={{ mt: 1, width: '100%', maxWidth: 900 }}
                            />
                        </Box>

                        <ClientHeaderProvider value={headerContextValue}>
                            <ClientDetailsHeader />
                        </ClientHeaderProvider>
                        <UploadsBreakdownModal
                            open={showUploadsBreakdown}
                            onClose={() => setShowUploadsBreakdown(false)}
                            caseId={client?.caseId}
                            clientName={client?.name}
                            token={token}
                            direction={direction}
                        />

                        <div className="action-cards-container">
                            {!isManageOnly && (
                                <ClientActionCard
                                    icon={<AccountingModuleIcon />}
                                    accent="blue"
                                    title={t("AccountingManagement")}
                                    items={accountingItems}
                                />
                            )}

                            {!isManageOnly && (
                                userTypeContext?.toString() === Constants.UserType.Client ? (
                                    <>
                                        {/* Sales (Client-specific order) */}
                                        <ClientActionCard
                                            icon={<SalesModuleIcon />}
                                            accent="blue"
                                            title={t("Sales")}
                                            items={filteredSalesItems}
                                        />

                                        <ClientActionCard
                                            icon={<SettingsModuleIcon />}
                                            accent="purple"
                                            title={t("Settings")}
                                            items={settingsItems}
                                        />

                                        {/* Reports */}
                                        <ClientActionCard
                                            icon={<ReportsModuleIcon />}
                                            accent="blue"
                                            title={t("Reports")}
                                            items={filteredReportsItems}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {/* Reports (Default order for non-clients) */}
                                        <ClientActionCard
                                            icon={<ReportsModuleIcon />}
                                            accent="blue"
                                            title={t("Reports")}
                                            items={filteredReportsItems}
                                        />
                                        <ClientActionCard
                                            icon={<SettingsModuleIcon />}
                                            accent="purple"
                                            title={t("Settings")}
                                            items={settingsItems}
                                        />
                                        {/* Sales */}
                                        <ClientActionCard
                                            icon={<SalesModuleIcon />}
                                            accent="blue"
                                            title={t("Sales")}
                                            items={filteredSalesItems}
                                        />
                                    </>
                                )
                            )}

                            {isManageOnly && (
                                <ClientActionCard
                                    icon={<ReportsModuleIcon />}
                                    accent="blue"
                                    title={t("Reports")}
                                    items={manageOnlyReportsItems}
                                />
                            )}

                            <ClientActionCard
                                icon={<ArchiveModuleIcon />}
                                accent="teal"
                                title={t("Archive")}
                                items={isManageOnly ? manageOnlyDocumentsItems : documentsItems}
                                subItemNumber={true}
                            />

                            {!isManageOnly && (
                                <ClientActionCard
                                    icon={<MatchingModuleIcon />}
                                    accent="orange"
                                    title={t("Matching")}
                                    items={bankItems}
                                    disabled={userTypeContext?.toString() === Constants.UserType.Client && !permissionsState.Premium}
                                />
                            )}

                            {
                                (!permissionsState.ViewSubAccountantClients && userTypeContext?.toString() !== Constants.UserType.Client) &&

                                <ClientActionCard
                                    icon={<CrmModuleIcon />}
                                    accent="purple"
                                    title={t("CRM")}
                                    items={crmItems}
                                    subItemNumber={true}
                                />
                            }

                            {/* Dynamic Business Field Action Cards */}
                            {!isManageOnly && (
                                <BusinessFieldActionCard
                                    client={client}
                                    businessFieldConfigs={businessFieldConfigs}
                                    direction={direction}
                                    navigationFunctions={{
                                        viewVehicleManagement: viewVehicleManagement,
                                        viewGarageWorkDiary: viewGarageWorkDiary,
                                        viewAudit: viewAudit,
                                        // viewAuditReports: viewAuditReports
                                        // Add more navigation functions here as needed
                                        // viewSomeOtherManagement: viewSomeOtherManagement
                                    }}
                                />
                            )}

                            {!isManageOnly && auditItems.length > 0 && userTypeContext?.toString() !== Constants.UserType.Client && (
                                <ClientActionCard
                                    variant="ai"
                                    icon={auditAiSparkIcon}
                                    title={t('AuditCategory')}
                                    items={auditItems}
                                    directClick
                                    onDirectClick={() => viewAudit('Audit')}
                                />
                            )}
                        </div>

                        {/* Fallback totals when VatAdvancesSection (Total Summary table) is hidden */}
                        {!isManageOnly && clientPermissionsState.CannotSeeVat && isClient && (
                            <div className={`action-cards ${direction}`}>
                                <ActionCards
                                    direction={direction}
                                    fetchLoading={fetchLoading}
                                    client={client}
                                    incomesAmount={incomesAmount}
                                    expensesAmount={expensesAmount}
                                    purchaseOfEquipmentExpensesAmount={purchaseOfEquipmentExpensesAmount}
                                    profitAmount={profitAmount}
                                    viewDocumentDetails={viewDocumentDetails}
                                    viewSortCodeReport={viewSortCodeReport}
                                    t={t}
                                    beautifyNumber={beautifyNumber}
                                    startDate={startDate}
                                    endDate={endDate}
                                    isMonthly={isMonthly}
                                    startYearDate={startYearDate}
                                    endYearDate={endYearDate}
                                />
                            </div>
                        )}

                        {
                            !isManageOnly &&
                            (!clientPermissionsState.CannotSeeVat || !isClient) && (
                            <VatAdvancesSection
                                fetchLoading={fetchLoading}
                                client={client}
                                hideVatPanel={Constants.TaxExemptTypes.includes(
                                    (client?.caseType ?? client?.CaseType ?? '').trim()
                                )}
                                direction={direction}
                                headerStyle={headerStyle}
                                t={t}
                                beautifyNumber={beautifyNumber}
                                netVatAmount={netVatAmount}
                                incomesVatDetailed={incomesVatDetailed}
                                expensesVatDetailed={expensesVatDetailed}
                                equipmentVatDetailed={equipmentVatDetailed}
                                purchaseOfEquipmentExpensesVatAmount={purchaseOfEquipmentExpensesVatAmount}
                                expensesVatAmount={expensesVatAmount}
                                incomesVatAmount={incomesVatAmount}
                                reportTax={reportTax}
                                downloadVATReport={downloadVATReport}
                                permissionsState={permissionsState}
                                userTypeContext={userTypeContext}
                                handleShowVatModal={handleShowVatModal}
                                VatTooltip={VatTooltip}
                                calculatedValues={calculatedValues}
                                witholdingIncomesNoVat={witholdingIncomesNoVat}
                                downloadWithholdingTaxReport={downloadWithholdingTaxReport}
                                advanceReportTax={advanceReportTax || {}}
                                handleOpenWithholdingTaxModal={handleOpenWithholdingTaxModal}
                                Constants={Constants}
                                // Shared case props
                                isSubordinateClient={isSubordinateClient}
                                mainClientData={mainClientData}
                                isMainWithSubordinates={isMainWithSubordinates}
                                subordinateClients={subordinateClients}
                                // Date-related props
                                isRange={isRange}
                                isBiMonthly={isBiMonthly}
                                isAdvancedBiMonthly={isAdvancedBiMonthly}
                                date={date}
                                startDate={startDate}
                                endDate={endDate}
                                biStartDate={biStartDate}
                                biEndDate={biEndDate}
                                advancedDate={advancedDate}
                                advancedStartDate={advancedStartDate}
                                advancedEndDate={advancedEndDate}
                                advancedBiStartDate={advancedBiStartDate}
                                advancedBiEndDate={advancedBiEndDate}
                                showBiMonth={showBiMonth}
                                setShowBiMonth={setShowBiMonth}
                                handleDateChangeNew={handleDateChangeNew}
                                handleStartDateChangeNew={handleStartDateChangeNew}
                                handleEndDateChangeNew={handleEndDateChangeNew}
                                handleBiMonthDate={handleBiMonthDate}
                                handleAdvancedDateChangeNew={handleAdvancedDateChangeNew}
                                handleAdvancedStartDateChangeNew={handleAdvancedStartDateChangeNew}
                                handleAdvancedEndDateChangeNew={handleAdvancedEndDateChangeNew}
                                handleAdvancedBiMonthDate={handleAdvancedBiMonthDate}
                                formatDateToYearMonth={formatDateToYearMonth}
                                // Additional props for FinancialModal and ActionCards
                                incomesAmount={incomesAmount}
                                expensesAmount={expensesAmount}
                                purchaseOfEquipmentExpensesAmount={purchaseOfEquipmentExpensesAmount}
                                profitAmount={profitAmount}
                                paymentWithholdingTax={paymentWithholdingTax}
                                viewDocumentDetails={viewDocumentDetails}
                                viewSortCodeReport={viewSortCodeReport}
                                viewPaymentAcceptanceDetails={viewPaymentAcceptanceDetails}
                                viewAdvanceCalculator={viewAdvanceCalculator}
                                handleRangeChange={handleRangeChange}
                                withholdingTaxPercentage={client?.withholdingTaxPercentage}
                                withholdingTaxApprovalValidUntil={client?.withholdingTaxApprovalValidUntil}
                                // Add missing props for SortCodeReport navigation
                                isMonthly={isMonthly}
                                startYearDate={startYearDate}
                                endYearDate={endYearDate}
                                // Partners props
                                token={token}
                                partners={partners}
                                calculatePartnerValues={calculatePartnerValues}
                                partnerCalculatedValues={partnerCalculatedValues}
                                // Chat
                                handleSendTextMessageToChat={handleSendTextMessageToChat}
                                accountantName={user?.name || ''}
                                onlyProcessedDocuments={onlyProcessedDocuments}
                                showNationalInsurancePanel={showNationalInsurancePanel}
                                nationalInsuranceSummary={nationalInsuranceSummary}
                                nationalInsurancePeriodLabel={nationalInsurancePeriodLabel}
                                onOpenNationalInsurance={() => setOpenNationalInsurance(true)}
                                showSalaryPanel={showSalaryPanel}
                                salaryOverview={salaryOverview}
                                salaryLoading={salaryLoading}
                                salaryPeriodLabel={salaryPeriodLabel}
                                onOpenSalary={() => setOpenSalary(true)}
                                onOpenReportingFollowUp={() => setOpenReportingFollowUp(true)}
                            />
                            )
                        }

                        <ClientDataTable
                            fetchLoading={fetchLoading}
                            client={client}
                            direction={direction}
                            t={t}
                            headerStyle={headerStyle}
                            editIcon={editIcon}
                            deleteIcon={deleteIcon}
                            handleEdit={handleEdit}
                            handleDeleteClick={handleDeleteClick}
                            permissionsState={permissionsState}
                            userTypeContext={userTypeContext}
                            Constants={Constants}
                            subAccountants={subAccountants}
                            tokenDaysRemaining={tokenDaysRemaining}
                            tokenSecondsRemaining={tokenSecondsRemaining}
                            TaxAuthorityService={TaxAuthorityService}
                            token={token}
                            handleTaxAuthorityAuth={handleTaxAuthorityAuth}
                            setLoading={setLoading}
                            refreshTokenValidity={refreshTaxAuthorityTokenValidity}
                            isManageOnly={isManageOnly}
                            onSaveNotes={handleSaveNotes}
                        />
                    </>
                }


                {/* All modals/dialogs rendered in one place */}
                <ModalsSection
                    direction={direction}
                    t={t}
                    openDialog={openDialog}
                    handleCloseDialog={handleCloseDialog}
                    handleActivateClient={handleActivateClient}
                    openDeleteDialog={openDeleteDialog}
                    handleCloseDeleteDialog={handleCloseDeleteDialog}
                    handleDeletePermanently={handleDeletePermanently}
                    handleInactiveUser={handleInactiveUser}
                    isModalVisible={isModalVisible}
                    setIsModalVisible={setIsModalVisible}
                    setItemIdToDelete={setItemIdToDelete}
                    handleConfirm={handleConfirm}
                    getConfirmMessage={getConfirmMessage}
                    getTitleMessage={getTitleMessage}
                    actionType={actionType}
                    showImportManifestModal={showImportManifestModal}
                    setShowImportManifestModal={setShowImportManifestModal}
                    client={client}
                    token={token}
                    user={user}
                />

                <ToastContainer />
                {(loading || !client) && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}

                <VatModal
                    open={openVatModal}
                    onClose={() => setOpenVatModal(false)}
                    item={vatReport}
                    user={user}
                    client={client}
                    token={token}
                    onlyProcessedDocuments={onlyProcessedDocuments}
                    onDataUpdate={handleDataUpdate}
                    onStartDateChange={handleStartDateChangeNew}
                    onEndDateChange={handleEndDateChangeNew}
                    startDate={startDate}
                    endDate={endDate}
                    setShowBiMonth={setShowBiMonth}
                    showBiMonth={showBiMonth}
                    date={date}
                    biStartDate={biStartDate}
                    biEndDate={biEndDate}
                    handleBiMonthDate={handleBiMonthDate}
                    isRange={isRange}
                    isBiMonthly={isBiMonthly}
                    viewDocumentDetails={viewDocumentDetails}
                    handleRangeChange={handleRangeChange}
                    handleStartDateChangeNew={handleStartDateChangeNew}
                    handleEndDateChangeNew={handleEndDateChangeNew}
                    handleDateChangeNew={handleDateChangeNew}
                    isMainLoading={loading}
                    fetchDataOnDateRangeChange={fetchDataOnDateRangeChange}
                    fetchDocumentsNotification={fetchDocumentsNotification}
                    downloadPCNReport={downloadPCNReport}
                />
                <WithholdingTaxModal
                    open={openWithholdingTaxModal}
                    onClose={() => setOpenWithholdingTaxModal(false)}
                    item={withholdingTax}
                    user={user}
                    token={token}
                    onDataUpdate={handleWithholdingDataUpdate}
                    startDate={isAdvancedBiMonthly !== isBiMonthly ? advancedStartDate : startDate}
                    endDate={isAdvancedBiMonthly !== isBiMonthly ? advancedEndDate : endDate}
                    isRange={isRange}
                    isBiMonthly={isAdvancedBiMonthly}
                    date={isAdvancedBiMonthly !== isBiMonthly ? advancedDate : date}
                    biStartDate={isAdvancedBiMonthly !== isBiMonthly ? advancedBiStartDate : biStartDate}
                    biEndDate={isAdvancedBiMonthly !== isBiMonthly ? advancedBiEndDate : biEndDate}
                    showBiMonth={showBiMonth}
                    setShowBiMonth={setShowBiMonth}
                    handleStartDateChangeNew={isAdvancedBiMonthly !== isBiMonthly ? handleAdvancedStartDateChangeNew : handleStartDateChangeNew}
                    handleEndDateChangeNew={isAdvancedBiMonthly !== isBiMonthly ? handleAdvancedEndDateChangeNew : handleEndDateChangeNew}
                    handleDateChangeNew={isAdvancedBiMonthly !== isBiMonthly ? handleAdvancedDateChangeNew : handleDateChangeNew}
                    handleBiMonthDate={isAdvancedBiMonthly !== isBiMonthly ? handleAdvancedBiMonthDate : handleBiMonthDate}
                    selectedPartner={selectedPartnerForModal}
                    handleRangeChange={isAdvancedBiMonthly !== isBiMonthly ? handleAdvancedRangeChange : handleRangeChange}
                    advancedDate={isAdvancedBiMonthly !== isBiMonthly ? advancedDate : undefined}
                    setAdvancedDate={isAdvancedBiMonthly !== isBiMonthly ? setAdvancedDate : undefined}
                    advancedStartDate={isAdvancedBiMonthly !== isBiMonthly ? advancedStartDate : undefined}
                    setAdvancedStartDate={isAdvancedBiMonthly !== isBiMonthly ? setAdvancedStartDate : undefined}
                    advancedEndDate={isAdvancedBiMonthly !== isBiMonthly ? advancedEndDate : undefined}
                    setAdvancedEndDate={isAdvancedBiMonthly !== isBiMonthly ? setAdvancedEndDate : undefined}
                    advancedBiStartDate={isAdvancedBiMonthly !== isBiMonthly ? advancedBiStartDate : undefined}
                    setAdvancedBiStartDate={isAdvancedBiMonthly !== isBiMonthly ? setAdvancedBiStartDate : undefined}
                    advancedBiEndDate={isAdvancedBiMonthly !== isBiMonthly ? advancedBiEndDate : undefined}
                    setAdvancedBiEndDate={isAdvancedBiMonthly !== isBiMonthly ? setAdvancedBiEndDate : undefined}
                    isAdvancedBiMonthly={isAdvancedBiMonthly !== isBiMonthly ? isAdvancedBiMonthly : undefined}
                    isSubordinateClient={isSubordinateClient}
                    mainClientData={mainClientData}
                    isMainWithSubordinates={isMainWithSubordinates}
                    subordinateClients={subordinateClients}
                    partnerAdvanceSettings={partnerAdvanceSettings}
                />

                <ReportingFollowUpModal
                    open={openReportingFollowUp}
                    onClose={() => setOpenReportingFollowUp(false)}
                    client={client}
                    user={user}
                    token={token}
                    defaultDate={isRange ? endDate : isBiMonthly ? biEndDate : date}
                />

                {showNationalInsurancePanel && (
                    <NationalInsuranceModal
                        open={openNationalInsurance}
                        onClose={() => setOpenNationalInsurance(false)}
                        client={client}
                        user={user}
                        token={token}
                        defaultYear={nationalInsuranceYear || undefined}
                    />
                )}

                {showSalaryPanel && (
                    <SalaryModal
                        open={openSalary}
                        onClose={() => setOpenSalary(false)}
                        client={client}
                        token={token}
                        startYear={salaryFromYear || undefined}
                        endYear={salaryToYear || undefined}
                        periodStart={salaryPeriodStart || undefined}
                        periodEnd={salaryPeriodEnd || undefined}
                        canEdit={!permissionsState.ViewSubAccountantClients}
                    />
                )}

                <JournalDocumentationModal
                    open={showJournalDocModal}
                    onClose={() => setShowJournalDocModal(false)}
                    onSubmit={onSubmitJournalDocumentation}
                    initialSortBy={'uploadNumber'}
                    initialSortDirection={'asc'}
                    initialTypes={[]}
                    initialFormat={'pdf'}
                    initialStartDate={isRange ? startDate : date}
                    initialEndDate={isRange ? endDate : date}
                    initialIsRange={isRange}
                    accountCardOptions={AccountCardOptions.filter(opt => opt.cardId)}
                    sortCodeOptions={sortCodeOptions}
                    direction={direction}
                />

            </ >
        </>
    );
};

export default ClientDetails;